
var editor;
(function ($) {




    window.p$ = {};




    // Check if button is active.
    var isActive = function (cmd) {
        // console.log("isactive")
        var blocks = this.selection.blocks();

        if (blocks.length) {
            var blk = blocks[0];
            var tag = 'N';
            var default_tag = this.html.defaultTag();
            if (blk.tagName.toLowerCase() != default_tag && blk != this.el) {
                tag = blk.tagName;
            }
        }

        if (['LI', 'TD', 'TH'].indexOf(tag) >= 0) {
            tag = 'N';
        }

        if (tag) return tag.toLowerCase() == cmd;
    }





    // Log function will print log message
    var flog = function () {

        if (typeof (console) !== 'undefined' && KEditor.debug === true) {
            var args = Array.prototype.slice.apply(arguments);
            args.unshift('[KEditor]');

            //console.log(args)

        }
    };

    // Throw error message
    var error = function (msg) {
        throw new Error('[KEditor] ' + msg);
    };

    // Check dependencies




    // KEditor class
    var KEditor = function (target, options) {


        this.element = target;
        this.options = $.extend({}, KEditor.DEFAULTS, options);

        this.init(target);
    };

    // Turn on/off debug mode
    KEditor.debug = true;

    // Version of KEditor
    KEditor.version = '@{version}';


    KEditor.labels = "labels";
    KEditor.language = "de";





    // Default configuration of KEditor
    KEditor.DEFAULTS = {
        content: null,
        css: null,
        js: null,
        cssRaw: null,
        jsRaw: null,
        accessKeditorFirstTime: true,
        isNewPage: false,
        snippets: null,
        locale: null,
        corporateIdentity: null,
        groupSettings: null,
        pageLanguage: null,
        personalizedData: null,
        env: null,
        language: 'en',
        isSysAdmin: false,
        privileges: null,
        allPageSiblings: [],
        prevNextSiblings: [],
        data: {},
        variablesPlugin: [],
        chatGPTPlugin: {},
        niceScrollEnabled: false,
        nestedContainerEnabled: true,
        btnMoveUp: '<i class="fa fa-long-arrow-up"></i>',
        btnMoveDown: '<i class="fa fa-long-arrow-down"></i>',
        btnMoveContainerText: '<i class="fa fa-sort"></i>',
        btnMoveComponentText: '<i class="fa fa-arrows"></i>',
        btnSettingContainerText: '<i class="fa fa-pencil"></i> ',
        btnSettingComponentText: '<i class="fa fa-pencil"></i> ' + KEditor.labels.editor_edit_snippet,
        btnDuplicateContainerText: '<i class="fa fa-files-o"></i>',
        btnDuplicateComponentText: '<i class="fa fa-files-o"></i>',
        btnDeleteContainerText: '<i class="fa fa-times"></i>',
        btnDeleteComponentText: '<i class="fa fa-trash-o"></i>',
        btnUpdateComponentText: '<i class="fa fa-refresh"></i>',//+KEditor.labels.editor_update_snippet,
        tabContainersText: 'Layout',
        tabContainersTitle: 'Layout',
        tabComponentsText: 'Snippets',
        tabComponentsTitle: 'Snippets',
        tabTooltipEnabled: false,
        extraTabs: null,
        defaultComponentType: 'blank',
        sidebarContainer: null,
        renderSidebarInParent: false, // When true, sidebar is rendered in parent document instead of iframe
        snippetsUrl: 'snippets/snippets.html',
        snippetsUrl: 'snippets/',
        snippetsTooltipEnabled: false,
        snippetsTooltipPosition: 'left',
        snippetsFilterEnabled: true,
        snippetsCategoriesSeparator: ';',
        snippetsContainer: true,
        snippetsComponents: true,
        previewUrl: null,
        templateSearch: false,
        templateFilter: false,
        snippetSearch: true,
        snippetFilter: true,
        iframeMode: true,
        newSnippetList: true,
        // set also again further at the bottom!!
        //toolbarSet1: "bold,italic,underline,strikeThrough,primary,insertLink,undo,redo",
        toolbarSet1: "bold,italic,underline,strikeThrough,textColor,insertLink,clearFormatting,inlineClass,fontAwesome,undo,redo",
        toolbarSet2: "bold,italic,underline,strikeThrough,textColor,clearFormatting,inlineClass,fontAwesome,undo,redo",
        toolbarSet3: "bold,italic,underline,strikeThrough,insertLink,clearFormatting,inlineClass,fontAwesome,undo,redo",
        toolbarSet4: "bold,italic,underline,strikeThrough,textColor,insertLink,formatUL,formatOL,inlineClass,fontAwesome,clearFormatting,undo,redo",
        toolbarSet4a: "bold,italic,underline,strikeThrough,textColor,insertLink,formatUL,formatOL,inlineClass,fontAwesome,clearFormatting,undo,redo",
        toolbarSet5: "bold,italic,underline,strikeThrough,textColor,paragraphFormat,inlineClass,insertLink,formatUL,formatOL,fontAwesome,clearFormatting,undo,redo",
        toolbarSet5a: "bold,italic,underline,strikeThrough,textColor,paragraphFormat,inlineClass,insertLink,formatUL,formatOL,fontAwesome,clearFormatting,undo,redo",
        toolbarSet6: "bold,italic,subscript,superscript,underline,strikeThrough,textColor,paragraphFormat,fontFamily,inlineClass,insertLink,formatUL,formatOL,alignLeft,alignCenter,alignRight,alignJustify,fontAwesome,clearFormatting,undo,redo",
        toolbarSet7: {
            indexOf: key => Object.keys(this).indexOf(key),
            'moreText': {
                'buttons': ['bold', 'italic', 'textColor', 'inlineClass', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'backgroundColor', 'clearFormatting'],
                'buttonsVisible': 4
            },
            'moreParagraph': {
                'buttons': ['alignLeft', 'alignCenter', 'paragraphFormat', 'formatULSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'customFormatUL', 'lineHeight', 'outdent', 'indent', 'paragraphStyle'],
                'buttonsVisible': 3
            },
            'moreRich': {
                // 'embedly' button removed: Embedly is being phased out. The plugin stays
                // loaded so existing .fr-embedly content keeps rendering in the editor.
                'buttons': ['personalizationBtn', 'insertLink', 'insertImage', 'insertVideo', 'inline_snippets', 'chatGPT', 'insertTable', 'fontAwesome', 'iconPicker', 'emoticons', 'specialCharacters', 'customCountUp', 'customForms', /*'insertOembed'*/, 'br', 'line'],
                'buttonsVisible': 4
            },
            'moreMisc': {
                'buttons': ['undo', 'redo', 'html', 'help'],
                'align': 'right',
                'buttonsVisible': 2
            }
        },
        sortingArray: [
            {
                "icon": "fa-window-minimize",
                "value": "Footers"
            },
            {
                "icon": "fa-th",
                "value": "Others"
            },
            {
                "icon": "fa-bars",
                "value": "Navigations & Indexes"
            },
            {
                "icon": "fa-window-maximize",
                "value": "Modals"
            },
            {
                "icon": "fa-check-square-o",
                "value": "Forms"
            },
            {
                "icon": "fa-share",
                "value": "Sharing"
            },
            {
                "icon": "fa-user",
                "value": "Team & Signatures"
            },
            {
                "icon": "fa-pie-chart",
                "value": "Tables & Charts"
            },
            {
                "icon": "fa-quote-right",
                "value": "Quotes & Testimonials"
            },
            {
                "icon": "fa-bullhorn",
                "value": "Call to actions"
            },
            {
                "icon": "fa-arrows-h",
                "value": "Full width"
            },
            {
                "icon": "fa-list",
                "value": "Features & Lists"
            },
            {
                "icon": "fa-id-card-o",
                "value": "Cards & Boxes"
            },
            {
                "icon": "fa-play",
                "value": "Videos & Audios"
            },
            {
                "icon": "fa-file-image-o",
                "value": "Images & Galleries"
            },
            {
                "icon": "fa-align-justify",
                "value": "Titles & Texts"
            },
            {
                "icon": "fa-header",
                "value": "Headers"
            },
            {
                "icon": "fa-pencil",
                "value": "Custom"
            },
            {
                "icon": "fa-square-o",
                "value": "Basic Elements"
            },
            {
                "icon": "fa-address-card-o",
                "value": "Covers"
            },
            {
                "icon": "fa-columns",
                "value": "Layouts"
            },
            {
                "icon": "fa-star",
                "value": "All"
            },
            {
                "icon": "fa-star",
                "value": "Telefonica B2C",
                "style": true,
            },
            {
                "icon": "fa-star",
                "value": "Telefonica B2B",
                "style": true,
            },
            {
                "icon": "fa-star",
                "value": "ABG",
                "style": true,
            },
            {
                "icon": "fa-star",
                "value": "ASD|Portfolios",
                "style": true,
            },
            {
                "icon": "fa-star",
                "value": "ASD|Snippets",
                "style": true,
            },
            {
                "icon": "fa-star",
                "value": "Haufe Akademie",
                "style": true,
            },
            {
                "icon": "fa-star",
                "value": "Webmag",
                "style": true,
            },
            {
                "icon": "fa-star",
                "value": "Tennet",
                "style": true,
            },
            {
                "icon": "fa-star",
                "value": "Telefonica",
                "style": true,
            },
            {
                "icon": "fa-star",
                "value": "Universal",
                "style": true,
            },
            {
                "icon": "fa-star",
                "value": "Fokus Layout",
                "style": true,
            },
            {
                "icon": "fa-star",
                "value": "CNHI",
                "style": true,
            },
            {
                "icon": "fa-star",
                "value": "CNHI - Case IH",
                "style": true,
            },

            {
                "icon": "fa-star",
                "value": "CNHI - New Holland",
                "style": true,
            },
            {
                "icon": "fa-star",
                "value": "CNHI - Steyr",
                "style": true,
            }
        ],
        contentStyles: [],
        contentAreasSelector: null,
        contentAreasWrapper: '<div class="keditor-ui keditor-content-areas-wrapper"></div>',
        containerSettingEnabled: true,
        containerSettingInitFunction: null,
        containerSettingShowFunction: null,
        containerSettingHideFunction: null,
        onReady: function () { },
        onInitFrame: function (frame, frameHead, frameBody) { },
        onSidebarToggled: function (isOpened) { },
        onContentChanged: function (event, contentArea) { },

        onBeforeInitContentArea: function (contentArea) { },
        onInitContentArea: function (contentArea) { },

        onBeforeInitContainer: function (container, contentArea) { },
        onInitContainer: function (container, contentArea) { },
        onBeforeContainerDeleted: function (event, selectedContainer, contentArea) { },
        onContainerDeleted: function (event, selectedContainer, contentArea) { },
        onContainerChanged: function (event, changedContainer, contentArea) { },
        onContainerDuplicated: function (event, originalContainer, newContainer, contentArea) { },
        onContainerSelected: function (event, selectedContainer, contentArea) { },
        onContainerSnippetDropped: function (event, newContainer, droppedSnippet, contentArea) { },

        onComponentReady: function (component) { },
        onBeforeInitComponent: function (component, contentArea) { },
        onInitComponent: function (component, contentArea) { },
        onBeforeComponentDeleted: function (event, selectedComponent, contentArea) { },
        onComponentDeleted: function (event, selectedComponent, contentArea) { },
        onBeforeComponentUpdated: function (event, selectedComponent, contentArea) { },
        onComponentUpdated: function (event, selectedComponent, contentArea) { },
        onComponentChanged: function (event, changedComponent, contentArea) { },
        onComponentDuplicated: function (event, originalComponent, newComponent, contentArea) { },
        onComponentSelected: function (event, selectedComponent, contentArea) { },
        onComponentSnippetDropped: function (event, newComponent, droppedSnippet, contentArea) { },

        onBeforeDynamicContentLoad: function (dynamicElement, component, contentArea) { },
        onDynamicContentLoaded: function (dynamicElement, response, status, xhr, contentArea) { },
        onDynamicContentError: function (dynamicElement, response, status, xhr, contentArea) { }
    };

    // Component types
    KEditor.components = {
        blank: {
            settingEnabled: false
        }
    };

    // Export log methods;
    KEditor.log = flog;
    KEditor.error = error;

    // Communication with Vue parent component via custom events
    KEditor.prototype.notifyParent = function (type, data) {
        flog('notifyParent:', type, data);
        // Use custom events since keditor runs in the same window as Vue
        window.dispatchEvent(new CustomEvent('keditor-message', {
            detail: { type: type, data: data }
        }));
    };

    // Generate unique ID for elements
    KEditor.prototype.generateElementId = function () {
        return 'wps-el-' + Math.random().toString(36).substr(2, 9);
    };

    KEditor.prototype.ensureElementId = function ($el) {
        if (!$el || $el.length === 0) {
            return null;
        }
        var existingId = $el.attr('id');
        if (!existingId) {
            existingId = this.generateElementId();
            $el.attr('id', existingId);
        }
        return existingId;
    };

    // Parse class-change options from attribute string
    KEditor.prototype.parseClassChangeOptions = function (classChangeStr, $el, upgradeKey) {
        var self = this;
        if (!classChangeStr) return null;

        var options = [];
        var parts = classChangeStr.split('|');
        var currentValue = null;

        parts.forEach(function (opt) {
            var optParts = opt.split('=');
            var label = optParts[0] || '';
            var value = optParts[1] || '';

            var isSelected = $el.hasClass(value);
            if (isSelected) {
                currentValue = value;
            }

            options.push({
                label: label,
                value: value,
                selected: isSelected
            });
        });

        // Check for upgrade options from groupSettings
        var upgrade = self.options.groupSettings && self.options.groupSettings.editorSettings
            ? self.options.groupSettings.editorSettings.upgrade
            : null;

        if (upgrade && upgrade[upgradeKey]) {
            Object.keys(upgrade[upgradeKey]).forEach(function (triggerClass) {
                if ($el.hasClass(triggerClass)) {
                    var upgradeOpts = upgrade[upgradeKey][triggerClass].split('|');
                    upgradeOpts.forEach(function (opt) {
                        if (!opt) return;
                        var optParts = opt.split('=');
                        var label = optParts[0] || '';
                        var value = optParts[1] || '';

                        var isSelected = $el.hasClass(value);
                        if (isSelected) {
                            currentValue = value;
                        }

                        options.push({
                            label: label,
                            value: value,
                            selected: isSelected,
                            isUpgrade: true
                        });
                    });
                }
            });
        }

        return {
            options: options,
            currentValue: currentValue
        };
    };

    // Parse slider config from attribute string
    KEditor.prototype.parseSliderConfig = function (sliderStr, $el) {
        if (!sliderStr) return null;

        var parts = sliderStr.split(';');
        var property = parts[0] || '';
        var min = parseInt(parts[1], 10) || 0;
        var max = parseInt(parts[2], 10) || 100;
        var unit = parts[3] || 'px';
        var important = parts[4] !== 'false';

        // Get current value from element's computed style
        var currentValue = min;
        var style = $el.attr('style') || '';

        // Try to extract value from inline style
        var regex = new RegExp(property + ':\\s*([\\d.]+)' + unit.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
        var match = style.match(regex);
        if (match) {
            currentValue = parseFloat(match[1]);
        }

        return {
            property: property,
            min: min,
            max: max,
            unit: unit,
            important: important,
            currentValue: currentValue
        };
    };


    KEditor.prototype.getTemplateScope = function ($component, parentInstanceId) {
        var $scope = $component;
        if (parentInstanceId) {
            var $parentScope = this.body.find('#' + parentInstanceId);
            if ($parentScope.length > 0) {
                $scope = $parentScope;
            }
        }
        return $scope;
    };

    KEditor.prototype.getNextTemplateIndex = function ($scope, templateAttr) {
        var maxIndex = 0;
        $scope.find('[pgs-ams-template="' + templateAttr + '"]').not('.swiper-slide-duplicate').each(function () {
            var idx = parseInt($(this).attr('data-wps-index'), 10);
            if (!isNaN(idx) && idx > maxIndex) {
                maxIndex = idx;
            }
        });
        return maxIndex + 1;
    };

    KEditor.prototype.removeDuplicateIds = function ($element) {
        $element.find('[id]').addBack('[id]').each(function () {
            $(this).removeAttr('id');
        });
    };

    KEditor.prototype.updateDataWpsEditReferences = function ($element, oldIndex, newIndex) {
        $element.find('[data-wps-edit]').addBack('[data-wps-edit]').each(function () {
            var $el = $(this);
            var editValue = $el.attr('data-wps-edit');
            if (!editValue) return;
            var match = editValue.match(/(\d+)(?!.*\d)/);
            if (!match) return;
            var number = parseInt(match[1], 10);
            if (number !== oldIndex) return;
            var startPosition = editValue.lastIndexOf(match[1]);
            var updatedValue = editValue.substring(0, startPosition)
                + newIndex
                + editValue.substring(startPosition + match[1].length);
            $el.attr('data-wps-edit', updatedValue);
        });
    };

    KEditor.prototype.getDefaultContainerContent = function () {
        var visibleContainers = this.body.find('.keditor-container-content').filter(function () {
            var $el = $(this);
            return !$el.hasClass('webmag_hide') && $el.css('display') !== 'none';
        });
        if (visibleContainers.length > 0) {
            return visibleContainers.last();
        }
        return this.body.find('.keditor-container-content').last();
    };

    KEditor.prototype.getRootContainerContent = function () {
        var containers = this.body.find('.keditor-container-content').not('.keditor-sub-container-content');
        var visibleContainers = containers.filter(function () {
            var $el = $(this);
            return !$el.hasClass('webmag_hide') && $el.css('display') !== 'none';
        });
        if (visibleContainers.length > 0) {
            return visibleContainers.last();
        }
        return containers.last();
    };


    // Add snippet from parent document
    KEditor.prototype.addSnippetFromParent = function (data) {
        var self = this;
        flog('addSnippetFromParent called with:', data.snippetName);

        var insertTargetId = data.insertTargetId || null;
        var insertPosition = data.insertPosition || null;
        var $insertTarget = insertTargetId ? self.body.find('#' + insertTargetId) : $();
        if ($insertTarget.length > 0 && $insertTarget.hasClass('webmag_hide')) {
            $insertTarget = $();
            insertPosition = null;
        }
        var targetContainerContent = $insertTarget.length > 0
            ? ($insertTarget.hasClass('keditor-container-content') ? $insertTarget : $insertTarget.closest('.keditor-container-content'))
            : $();

        var forceRoot = !!data.forceRoot;
        var containerContent = targetContainerContent.length > 0
            ? targetContainerContent
            : (forceRoot ? self.getRootContainerContent() : self.getDefaultContainerContent());
        if (forceRoot && containerContent.length === 0) {
            containerContent = self.getDefaultContainerContent();
        }
        flog('Found container content:', containerContent.length, containerContent.attr('id'));

        if (containerContent.length === 0) {
            flog('No container content found to add snippet');
            return;
        }

        if (containerContent.hasClass('webmag_hide')) {
            var visibleContainers = self.body.find('.keditor-container-content').filter(function () {
                var $el = $(this);
                return !$el.hasClass('webmag_hide') && $el.css('display') !== 'none';
            });
            if (visibleContainers.length === 0) {
                containerContent.removeClass('webmag_hide').css('display', '');
            }
        }

        // Find the snippet by name from our cached snippets
        var snippetHtml = data.snippetHtml;
        if (snippetHtml) {
            var $snippet = $(snippetHtml);
            flog('Snippet element created:', $snippet.length, $snippet.attr('data-wps-name'));

            if ($insertTarget.length > 0 && insertPosition) {
                if (insertPosition === 'append' && $insertTarget.hasClass('keditor-container-content')) {
                    $insertTarget.append($snippet);
                } else if (insertPosition === 'before') {
                    $snippet.insertBefore($insertTarget);
                } else {
                    $snippet.insertAfter($insertTarget);
                }
                flog('Snippet inserted near target:', insertTargetId, insertPosition);
            } else {
                // IMPORTANT: Append the snippet to the container BEFORE converting it
                containerContent.append($snippet);
                flog('Snippet appended to container');
            }

            // Now convert it to a proper keditor component
            var contentArea = containerContent.parent().parent();
            self.convertToComponent(contentArea, containerContent, $snippet, false);
            flog('Snippet converted to component');

            // Initialize padding drag handlers for the new component
            var newComponent = $snippet.closest('.keditor-component');
            if (newComponent.length === 0) {
                newComponent = containerContent.find('.keditor-component').last();
            }
            flog('New component in DOM:', newComponent.length, newComponent.attr('id'));

            if (newComponent.length > 0) {
                self.initPaddingDragHandlers(newComponent);

                // Add highlight class
                newComponent.addClass('keditor-component-just-added');

                if (self.iframeBody) {
                    var scrollTop = newComponent.offset().top - 100;
                    flog('Scrolling to:', scrollTop);
                    setTimeout(function() {
                        self.iframeBody.animate({
                            scrollTop: scrollTop
                        }, 300, function() {
                            // Remove highlight after scroll completes
                            setTimeout(function() {
                                newComponent.removeClass('keditor-component-just-added');
                            }, 1500);
                        });
                    }, 100);
                } else {
                    // No scroll possible, just remove highlight after delay
                    setTimeout(function() {
                        newComponent.removeClass('keditor-component-just-added');
                    }, 2000);
                }
            }

            self.notifyParent('keditor-snippet-added', { success: true });
            self.save();
        }
    };

    KEditor.prototype.ensureSnippetDropIndicator = function () {
        if (this.snippetDropIndicator && this.snippetDropIndicator.length > 0) {
            return;
        }
        if (!this.iframeBody) {
            return;
        }
        var indicator = $('<div class="keditor-snippet-drop-indicator"></div>');
        indicator.css({
            position: 'fixed',
            height: '4px',
            background: '#6366f1',
            left: 0,
            top: 0,
            width: '0px',
            zIndex: 99999,
            pointerEvents: 'none',
            display: 'none',
            boxShadow: '0 0 6px rgba(99, 102, 241, 0.7)'
        });
        this.iframeBody.append(indicator);
        this.snippetDropIndicator = indicator;
    };

    KEditor.prototype.ensureSnippetDropInsideIndicator = function () {
        if (this.snippetDropInsideIndicator && this.snippetDropInsideIndicator.length > 0) {
            return;
        }
        if (!this.iframeBody) {
            return;
        }
        var indicator = $('<div class="keditor-snippet-drop-inside"></div>');
        indicator.css({
            position: 'fixed',
            left: 0,
            top: 0,
            width: '0px',
            height: '0px',
            zIndex: 99998,
            pointerEvents: 'none',
            display: 'none',
            border: '2px dashed #22c55e',
            background: 'rgba(34, 197, 94, 0.12)',
            borderRadius: '10px',
            boxShadow: '0 0 0 1px rgba(34, 197, 94, 0.35)'
        });
        this.iframeBody.append(indicator);
        this.snippetDropInsideIndicator = indicator;
    };

    KEditor.prototype.hideSnippetDropIndicator = function () {
        if (this.snippetDropIndicator && this.snippetDropIndicator.length > 0) {
            this.snippetDropIndicator.hide();
        }
    };

    KEditor.prototype.hideSnippetDropInsideIndicator = function () {
        if (this.snippetDropInsideIndicator && this.snippetDropInsideIndicator.length > 0) {
            this.snippetDropInsideIndicator.hide();
        }
    };

    KEditor.prototype.getContainerContentFromPoint = function (x, y) {
        var doc = (this.iframe && this.iframe[0]) ? this.iframe[0].contentDocument : null;
        if (!doc || typeof doc.elementFromPoint !== 'function') {
            return $();
        }
        var element = doc.elementFromPoint(x, y);
        if (!element) {
            return $();
        }
        return $(element).closest('.keditor-container-content');
    };

    KEditor.prototype.getInsideContainerTarget = function (x, y) {
        var doc = (this.iframe && this.iframe[0]) ? this.iframe[0].contentDocument : null;
        if (!doc || typeof doc.elementFromPoint !== 'function') {
            return null;
        }
        var element = doc.elementFromPoint(x, y);
        if (!element) {
            return null;
        }
        var $element = $(element);
        var containerContent = $element.closest('.keditor-sub-container-content');
        if (containerContent.length === 0) {
            return null;
        }
        if (containerContent.hasClass('keditor-no-drop')) {
            return null;
        }
        if (containerContent.hasClass('webmag_hide') || containerContent.css('display') === 'none') {
            return null;
        }
        if ($element.closest('section.keditor-component').length > 0) {
            return null;
        }
        return {
            element: containerContent[0],
            position: 'inside',
            type: 'container-content'
        };
    };

    KEditor.prototype.getSectionDropTarget = function (x, y, allowInside) {
        var self = this;
        var containerContent = self.getDefaultContainerContent();
        if (containerContent.length === 0) {
            return null;
        }

        if (allowInside) {
            var insideTarget = self.getInsideContainerTarget(x, y);
            if (insideTarget) {
                return insideTarget;
            }
        }

        var containerContentAtPoint = allowInside ? self.getContainerContentFromPoint(x, y) : $();
        var sections = containerContentAtPoint.length > 0
            ? containerContentAtPoint.children('section.section')
            : self.body.find('.keditor-container-content > section.section');
        if (sections.length === 0) {
            if (allowInside && containerContentAtPoint.length > 0) {
                return {
                    element: containerContentAtPoint[0],
                    position: 'inside',
                    type: 'container-content'
                };
            }
            return {
                element: containerContent[0],
                position: 'append',
                type: 'container'
            };
        }

        var sectionEntries = [];
        sections.each(function () {
            sectionEntries.push({
                element: this,
                rect: this.getBoundingClientRect()
            });
        });

        sectionEntries.sort(function (a, b) {
            return a.rect.top - b.rect.top;
        });

        var firstRect = sectionEntries[0].rect;
        if (y <= firstRect.top + 48) {
            return {
                element: sectionEntries[0].element,
                position: 'before'
            };
        }

        var target = null;
        for (var i = 0; i < sectionEntries.length; i += 1) {
            var entry = sectionEntries[i];
            var mid = entry.rect.top + (entry.rect.height / 2);
            if (y < mid) {
                target = {
                    element: entry.element,
                    position: 'before'
                };
                break;
            }
        }

        if (!target) {
            target = {
                element: sectionEntries[sectionEntries.length - 1].element,
                position: 'after'
            };
        }

        return target;
    };

    KEditor.prototype.updateSnippetDropIndicator = function (target) {
        if (!target || !target.element) {
            this.hideSnippetDropIndicator();
            this.hideSnippetDropInsideIndicator();
            return;
        }

        if (target.position === 'inside') {
            this.ensureSnippetDropInsideIndicator();
            this.hideSnippetDropIndicator();
            if (!this.snippetDropInsideIndicator) {
                return;
            }
            var insideRect = target.element.getBoundingClientRect();
            var padding = 6;
            var width = insideRect.width - (padding * 2);
            var height = insideRect.height - (padding * 2);
            if (width <= 0 || height <= 0) {
                this.hideSnippetDropInsideIndicator();
                return;
            }
            this.snippetDropInsideIndicator.css({
                display: 'block',
                top: Math.max(0, insideRect.top + padding) + 'px',
                left: (insideRect.left + padding) + 'px',
                width: width + 'px',
                height: height + 'px'
            });
            return;
        }

        this.hideSnippetDropInsideIndicator();
        this.ensureSnippetDropIndicator();

        if (!this.snippetDropIndicator) {
            return;
        }

        var rect = target.element.getBoundingClientRect();
        var top = rect.top;
        if (target.position === 'after') {
            top = rect.top + rect.height;
        } else if (target.position === 'before') {
            top = rect.top - 2;
        }
        if (target.type === 'container') {
            top = rect.top + 8;
        }

        var width = rect.width;
        var left = rect.left;
        if (target.type === 'container' && (!width || width === 0)) {
            width = this.body[0].clientWidth || width;
            left = 0;
        }
        this.snippetDropIndicator.css({
            display: 'block',
            top: Math.max(0, top) + 'px',
            left: left + 'px',
            width: width + 'px'
        });
    };

    KEditor.prototype.handleSnippetDragMove = function (data) {
        if (!data || !data.inIframe) {
            this.snippetDropTarget = null;
            this.hideSnippetDropIndicator();
            this.hideSnippetDropInsideIndicator();
            return;
        }

        var snippetIsContainer = !!(data.snippetIsContainer || data.snippetType === 'container');
        var target = this.getSectionDropTarget(data.x, data.y, !snippetIsContainer);
        this.snippetDropTarget = target;
        this.updateSnippetDropIndicator(target);
        this.handleSnippetDragAutoScroll(data);
    };

    KEditor.prototype.handleSnippetDragDrop = function (data) {
        if (!data || !data.snippetHtml) {
            this.handleSnippetDragEnd();
            return;
        }

        var snippetIsContainer = !!(data.snippetIsContainer || data.snippetType === 'container');
        var target = this.snippetDropTarget || this.getSectionDropTarget(data.x, data.y, !snippetIsContainer);
        if (target && target.element) {
            if (target.position === 'inside') {
                var containerTargetId = this.ensureElementId($(target.element));
                this.addSnippetFromParent({
                    snippetHtml: data.snippetHtml,
                    snippetName: data.snippetName,
                    insertTargetId: containerTargetId,
                    insertPosition: 'append'
                });
            } else if (target.type === 'container') {
                this.addSnippetFromParent({
                    snippetHtml: data.snippetHtml,
                    snippetName: data.snippetName
                });
            } else {
                var targetId = this.ensureElementId($(target.element));
                this.addSnippetFromParent({
                    snippetHtml: data.snippetHtml,
                    snippetName: data.snippetName,
                    insertTargetId: targetId,
                    insertPosition: target.position
                });
            }
        }

        this.handleSnippetDragEnd();
    };

    KEditor.prototype.handleSnippetDragEnd = function () {
        this.snippetDropTarget = null;
        this.hideSnippetDropIndicator();
        this.hideSnippetDropInsideIndicator();
    };

    KEditor.prototype.handleSnippetDragAutoScroll = function (data) {
        if (!this.iframeBody || !this.iframeDoc || !data) {
            return;
        }
        var viewHeight = (this.iframe && this.iframe[0] && this.iframe[0].contentWindow)
            ? this.iframe[0].contentWindow.innerHeight
            : (this.iframeBody[0] ? this.iframeBody[0].clientHeight : 0);
        if (!viewHeight) {
            return;
        }
        var threshold = 120;
        var scrollDelta = 0;
        if (data.y < threshold) {
            scrollDelta = -25;
        } else if (data.y > viewHeight - threshold) {
            scrollDelta = 25;
        }
        if (scrollDelta === 0) {
            return;
        }
        var currentScroll = this.iframeBody.scrollTop();
        var maxScroll = this.iframeBody[0].scrollHeight - viewHeight;
        var nextScroll = Math.max(0, Math.min(currentScroll + scrollDelta, maxScroll));
        if (nextScroll !== currentScroll) {
            this.iframeBody.scrollTop(nextScroll);
        }
    };

    // Update element from parent settings panel
    KEditor.prototype.updateElementFromParent = function (data) {
        var self = this;
        var elementId = data.elementId;
        var changes = data.changes;

        var $element = self.body.find('#' + elementId);
        if ($element.length === 0) {
            flog('Element not found: ' + elementId);
            return;
        }

        flog('Updating element from parent:', elementId, changes);

        var needsReinit = false;

        // Apply class changes
        if (changes.removeClass) {
            // Handle space-separated classes
            var classesToRemove = changes.removeClass.split(' ').filter(function(c) { return c.trim(); });
            classesToRemove.forEach(function(cls) {
                $element.removeClass(cls);
            });
        }
        if (changes.addClass) {
            // Handle space-separated classes
            var classesToAdd = changes.addClass.split(' ').filter(function(c) { return c.trim(); });
            classesToAdd.forEach(function(cls) {
                $element.addClass(cls);
            });

            // Handle special class change cases that require additional DOM updates
            self.handleSpecialClassChanges($element, classesToAdd);
        }

        // Apply CSS changes
        if (changes.css) {
            $.each(changes.css, function (property, value) {
                if (value === '' || value === null) {
                    // Remove the style property by setting to empty
                    // For CSS custom properties, use setProperty
                    if (property.indexOf('--') === 0) {
                        $element[0].style.setProperty(property, '');
                    } else {
                        var currentStyle = $element.attr('style') || '';
                        var regex = new RegExp(property + '\\s*:\\s*[^;]+;?', 'gi');
                        currentStyle = currentStyle.replace(regex, '');
                        $element.attr('style', currentStyle.trim());
                    }
                } else {
                    // Handle !important in value
                    if (value.indexOf('!important') !== -1) {
                        $element[0].style.setProperty(property, value.replace('!important', '').trim(), 'important');
                    } else if (property.indexOf('--') === 0) {
                        // CSS custom properties must use setProperty
                        $element[0].style.setProperty(property, value);
                    } else {
                        $element.css(property, value);
                    }
                }
            });
        }

        // Apply attribute changes
        if (changes.attr) {
            $.each(changes.attr, function (key, value) {
                if (value === '' || value === null) {
                    $element.removeAttr(key);
                } else {
                    $element.attr(key, value);
                }

                // Check if this change requires component reinitialization
                if (key === 'data-swiper' || key === 'data-aos') {
                    needsReinit = true;
                }
            });
        }

        // Apply data attribute changes
        if (changes.data) {
            $.each(changes.data, function (key, value) {
                $element.data(key, value);
                $element.attr('data-' + key, value);
            });
        }

        // Apply HTML content changes
        if (changes.html !== undefined) {
            $element.html(changes.html);
            needsReinit = true;
        }

        // Apply text content changes (for non-HTML text)
        if (changes.text !== undefined) {
            $element.text(changes.text);
        }

        // Apply src attribute for images
        if (changes.src !== undefined) {
            $element.attr('src', changes.src);
        }

        // Apply href attribute for links
        if (changes.href !== undefined) {
            $element.attr('href', changes.href);
        }

        // Apply visibility changes (toggle webmag_hide class)
        if (changes.visibility !== undefined) {
            var hideTarget = $element;
            var hideAttr = $element.attr('data-wps-edit-hide');

            if (hideAttr === 'parent') {
                hideTarget = $element.parent();
            } else if (hideAttr && hideAttr !== 'true') {
                hideTarget = $element.closest(hideAttr);
            }

            if (changes.visibility) {
                hideTarget.removeClass('webmag_hide');
            } else {
                hideTarget.addClass('webmag_hide');
            }
        }

        // Reinitialize component if needed
        if (needsReinit) {
            var $component = $element.closest('.keditor-component');
            if ($component.length > 0) {
                var contentArea = $component.closest('.keditor-content-area');
                var container = $component.closest('.keditor-container');
                self.reinitComponent(contentArea, container, $component);
            }
        } else {
            $element.trigger('datachange');
        }

        // Trigger autosave
        self.save();

        // Notify parent that update was applied
        self.notifyParent('keditor-element-updated', {
            elementId: elementId,
            success: true
        });
    };


    KEditor.prototype.handleImageUploadRequest = function (data) {
        if (!data || !data.elementId) {
            return;
        }

        var $img = this.body.find('#' + data.elementId);
        if ($img.length === 0) {
            return;
        }

        var $component = $img.closest('.keditor-component');
        if ($component.length === 0) {
            return;
        }

        var self = this;
        if (typeof self.options.callFromKeditor !== 'function') {
            return;
        }

        var imageEl = $img[0];
        var $imgWrapper = $img.parent();
        var sizeAttr = $imgWrapper.attr('data-size');
        var width = sizeAttr ? parseInt(sizeAttr.split(',')[0], 10) : (imageEl.naturalWidth || (self.window ? self.window.innerWidth : window.innerWidth));
        var height = sizeAttr ? parseInt(sizeAttr.split(',')[1], 10) : (imageEl.naturalHeight || (self.window ? self.window.innerHeight : window.innerHeight));
        var focus = $imgWrapper.attr('data-focus');

        self.options.callFromKeditor('imageUploadModal', {
            src: imageEl.src,
            width: width,
            height: height,
            focal: focus
        }, function (response) {
            if (!response || !response[0]) {
                return;
            }

            var uploaded = response[0];
            var finalUrl = uploaded.url;
            if (self.cloudImageFunction) {
                finalUrl = self.cloudImageFunction(uploaded.url, { width: width, height: height }, uploaded);
            }

            var focalPoint = uploaded.focalpoint || { x: 50, y: 50 };

            if (uploaded.personalization) {
                $img.attr('data-wps-variable', uploaded.personalization.setId + '.' + uploaded.personalization.valueId);
            } else {
                $img.removeAttr('data-wps-variable');
            }

            $img.removeAttr('data-wps-edit-variable');
            $img.removeAttr('srcset');
            $img.attr('data-url', finalUrl);
            $imgWrapper.attr('data-focus', focalPoint.x + ',' + focalPoint.y);
            if (uploaded.width && uploaded.height) {
                $imgWrapper.attr('data-size', uploaded.width + ',' + uploaded.height);
            }
            $img.attr('src', finalUrl);

            var autoFitAttr = $img.attr('data-wps-auto-fit');
            if (autoFitAttr) {
                var $autoFitTarget = autoFitAttr === 'true' ? $imgWrapper : $img.closest(autoFitAttr);
                if ($autoFitTarget && !$autoFitTarget.hasClass('no_auto_fit') && uploaded.width && uploaded.height) {
                    var percentage = uploaded.height / uploaded.width * 100;
                    $autoFitTarget.css({ paddingBottom: percentage + '%' });
                }
            }

            if (self.window && self.window.imgCover) {
                self.window.imgCover.update(self.body[0]);
            }

            self.refreshComponentAfterTemplateChange($component);
        });
    };



    KEditor.prototype.refreshComponentAfterTemplateChange = function ($component) {
        if (!$component || $component.length === 0) {
            return;
        }

        var contentArea = $component.closest('.keditor-content-area');
        var container = $component.closest('.keditor-container');
        this.reinitComponent(contentArea, container, $component);
        this.save();
        this.syncSettingsPanel($component);
    };


    // Handle special class changes that require additional DOM manipulation
    KEditor.prototype.handleSpecialClassChanges = function ($element, classesToAdd) {
        classesToAdd.forEach(function(cls) {
            switch (cls) {
                case 'universal_tabs1_js':
                    $element.find('.universal_js_video').addClass('col-md-12').removeClass('col-md-9 order-2 order-md-1');
                    $element.find('.universal_js_list').addClass('col-md-12').removeClass('col-md-3 order-1 order-md-2');
                    $element.find('.universal_js_list .row > div').addClass('col-md-3').removeClass('col-md-12');
                    break;
                case 'universal_tabs2_js':
                    $element.find('.universal_js_video').removeClass('col-md-12').addClass('col-md-9 order-2 order-md-1');
                    $element.find('.universal_js_list').removeClass('col-md-12').addClass('col-md-3 order-1 order-md-2');
                    $element.find('.universal_js_list .row > div').removeClass('col-md-3').addClass('col-md-12');
                    break;
                case 'cta05_01_js':
                    $element.find('.cta05_text').addClass('order-0').removeClass('order-2');
                    $element.find('.cta05_image').addClass('mt-3 mt-md-0').removeClass('mb-3 mb-md-0');
                    break;
                case 'cta05_02_js':
                    $element.find('.cta05_text').addClass('order-2').removeClass('order-0');
                    $element.find('.cta05_image').addClass('mb-3 mb-md-0').removeClass('mt-3 mt-md-0');
                    break;
                // Add more special class handlers as needed
            }
        });
    };

    // Toggle mobile preview mode
    KEditor.prototype.toggleMobilePreview = function (data) {
        var self = this;
        // This is handled by CSS in the parent, but we can add any iframe-specific handling here
        var mode = data && data.mode ? data.mode : (data && data.enabled ? 'mobile' : 'desktop');
        flog('Preview mode toggled:', mode);
    };

    KEditor.prototype.init = function (target) {


        var self = this;
        var options = self.options;

        self.labels = self.options.locale.localeObject.editor;
        self.corporateIdentity = self.options.corporateIdentity;
        self.groupSettings = self.options.groupSettings;
        self.privileges = self.options.privileges;
        self.isSysAdmin = self.options.isSysAdmin;
        self.options.btnSettingComponentText = '<i class="fa fa-pencil"></i> ' + self.labels.edit_snippet;
        self.options.btnUpdateComponentText = '<i class="fa fa-refresh"></i> ';
        //self.cloudimage = "https://axyqwmwryo.cloudimg.io/v7/";
        self.target = target;

        //test privileges
        /*var value = "can_edit_page"
        self.privileges = self.privileges.filter(function(item) {
            return item !== value
        })*/


        // use the cloudimage functions from vue
        self.cloudImageFunction = self.options.cloudImageFunction;
        self.checkForCloudImage = self.options.checkForCloudImage;
        //self.cloudImageWrapperFunction = self.options.cloudImageWrapperFunction;


        self.body = $(target.closest("body"));

        // Initialize postMessage listener for parent communication
        if (options.renderSidebarInParent) {
            console.log("KEditor init: renderSidebarInParent is enabled, initializing postMessage listener");
            console.log("KEditor init: self =", self);
            console.log("KEditor init: self.initPostMessageListener =", typeof self.initPostMessageListener);
            if (typeof self.initPostMessageListener === 'function') {
                self.initPostMessageListener();
                console.log("KEditor init: postMessage listener initialized successfully");
            } else {
                console.warn("KEditor init: initPostMessageListener is not available yet - parent panel may not be registered");
            }
        }

        self.initFrame(target, function (target) {


            var body = self.body;
            if (body.hasClass('initialized-snippets-list')) {
                flog('Snippets list is already initialized!');
            } else {

                ajaxRequest = self.initSidebar();
                body.addClass('initialized-snippets-list');
            }

            if (body.hasClass('initialized-click-event-handlers')) {
                flog('CLick event handlers is already initialized!');
            } else {
                self.initKEditorClicks();
                body.addClass('initialized-click-event-handlers');
            }

            self.window.imgCover.setup({
                ready: true,
                doc: self.body[0].ownerDocument
            }); //make READY=true

            self.window.KEditor = self;
            self.initObservers();
            self.initContentAreas(target);

            // Initialize history management (session-based, fresh start each time)
            self.initHistory();
            var ajaxRequest;
            if (!ajaxRequest && typeof options.onReady === 'function') {
                options.onReady.call(self);
            }



            self.getdisplaydata = function () {
                var deferred = $.Deferred();
                self.getContent(false, true).then(function (content) {
                    var newData_min = content.replace(/\n|\t/g, ' ').replace(/&amp;shy;/g, '&shy;');
                    deferred.resolve(newData_min);
                })
                return deferred.promise();
            }




            //if(self.options.newArticle)

            self.save();


            // firefox drop fix https://github.com/SortableJS/Sortable/issues/985
            if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {

                document.body.ondragover = function (event) {
                    if (event.dataTransfer) {
                        event.stopPropagation();
                        event.preventDefault();
                    }
                };
                document.body.ondrop = function (event) {
                    if (event.dataTransfer) {
                        event.stopPropagation();
                        event.preventDefault();
                    }
                };

                self.body[0].ondragover = function (event) {
                    if (event.dataTransfer) {
                        event.stopPropagation();
                        event.preventDefault();
                    }
                };
                self.body[0].ondrop = function (event) {
                    if (event.dataTransfer) {onActive
                        event.stopPropagation();
                        event.preventDefault();
                    }
                };
            }

            // wrap sidebar and keditor-content-area
            if (self.privileges.includes('can_edit_page') || self.options.isSysAdmin) {
                if (self.privileges.includes('can_edit_page_layouts') || self.privileges.includes('can_edit_page_snippets') || self.options.isSysAdmin) {
                    self.body.find("#keditor-sidebar, .keditor-content-area").wrapAll("<div class='d-flex flex-row justify-content-center' />");
                }
            }

            $(self.body).idle({
                onActive: function () {
                    if (typeof self.options.callFromKeditor === 'function') self.options.callFromKeditor("onActive", null, function () { })
                },
                onShow: function () {
                    if (typeof self.options.callFromKeditor === 'function') self.options.callFromKeditor("onActive", null, function () { })
                },
                idle: 2000
            })

            if (typeof self.options.callFromKeditor === 'function') self.options.callFromKeditor("loaded", null, function () { })

            if (typeof self.options.callFromKeditor === 'function') self.options.callFromKeditor("stopEditorLoader", null, function () { })


        });




        console.log("keditor", this);








    };




    //prototype of save Data
    KEditor.prototype.save = function () {

        if (
            (this.options.accessKeditorFirstTime && this.options.isNewPage)
            || (!this.options.accessKeditorFirstTime && !this.options.isNewPage)
        ) {
            this.options.isNewPage = false;
            this.options.accessKeditorFirstTime = false;
            //console.error("save", this.options.data, this);






            var self = this;

            // Fucking ugly: if no timeout, froala text is not initiated
            // need that because of froala Bug https://jsfiddle.net/ac3r4f80/3/
            setTimeout(function () {


                //prevent autosave!
                //if(window.parent._AMS.noAutoSave) return;
                self.getContent().then(function (content) {
                    var newData = content.replace(/\n|\t/g, ' ');

                    // Only trigger autosave if not restoring from history
                    if (!self.historyState || !self.historyState.isRestoring) {
                        if (typeof self.options.autosave === 'function') self.options.autosave(newData);
                    }

                    // Save history snapshot (will be debounced internally)
                    if (self.historyState && !self.historyState.isRestoring) {
                        self.saveHistorySnapshot();
                    }
                })

            }, 100);

            //console.error("SAFE", newData_min)
        } else {
            this.options.accessKeditorFirstTime = false;
        }
        this.options.isNewPage = false;
    }


    KEditor.prototype.generateId = function (type) {
        var timestamp = (new Date()).getTime();
        return 'keditor-' + type + '-' + timestamp;
    };

    // ========================================================================
    // History Management for Undo/Redo
    // ========================================================================
    // This system provides global undo/redo functionality for the entire editor.
    // Features:
    // - Saves up to 40 versions per page in localStorage
    // - Works across pages - each page maintains its own history
    // - Automatically captures snapshots after changes (debounced 500ms)
    // - Restores versions by reinitializing the entire editor
    //
    // Usage:
    //   var editor = $('.keditor-element').keditor();
    //   editor.keditor('undo');     // Undo last change
    //   editor.keditor('redo');     // Redo last undone change
    //   editor.keditor('canUndo');  // Check if undo is possible
    //   editor.keditor('canRedo');  // Check if redo is possible
    // ========================================================================

    // Single localStorage key for all page histories
    KEditor.HISTORY_STORAGE_KEY = 'keditor_page_histories';
    KEditor.MAX_VERSIONS_PER_PAGE = 40;
    KEditor.MAX_PAGES_IN_HISTORY = 20; // Limit number of pages to prevent storage overflow

    // LZ-string compression helper functions
    KEditor.prototype.compressContent = function (content) {
        // Try to use LZString if available (loaded from npm via KEditor.vue)
        var LZString = window.LZString || (typeof LZString !== 'undefined' ? LZString : null);
        if (LZString && LZString.compressToUTF16) {
            try {
                return LZString.compressToUTF16(content);
            } catch (e) {
                flog('Error compressing content:', e);
                return content; // Fallback to uncompressed
            }
        }
        // If LZString not available, return uncompressed
        console.warn('[KEditor History] LZString not available, saving uncompressed');
        return content;
    };

    KEditor.prototype.decompressContent = function (compressedContent) {
        // Try to use LZString if available
        var LZString = window.LZString || (typeof LZString !== 'undefined' ? LZString : null);
        if (LZString && LZString.decompressFromUTF16) {
            try {
                // Try to decompress - if it fails, assume it's not compressed
                var decompressed = LZString.decompressFromUTF16(compressedContent);
                return decompressed || compressedContent; // Return original if decompression fails
            } catch (e) {
                // If decompression fails, assume content is not compressed (backward compatibility)
                return compressedContent;
            }
        }
        // If LZString not available, assume content is not compressed
        return compressedContent;
    };

    KEditor.prototype.getPageId = function () {
        var self = this;
        // Try to get page ID from options.pageId first (passed from Vue component)
        if (self.options.pageId) {
            return String(self.options.pageId);
        }
        // Try to get page ID from options.data.id
        if (self.options.data && self.options.data.id) {
            return String(self.options.data.id);
        }
        // Fallback: use element ID or generate one
        var elementId = self.element.attr('id') || self.element.attr('data-keditor-id');
        if (!elementId) {
            elementId = 'keditor-' + (self.element.attr('class') || 'default').split(' ')[0] + '-' +
                       (self.element.index() || 0);
            self.element.attr('data-keditor-id', elementId);
        }
        console.warn('[KEditor History] No pageId provided, using fallback:', elementId);
        return elementId;
    };

    KEditor.prototype.initHistory = function () {
        var self = this;
        var pageId = self.getPageId();

        // LZString should be loaded via npm in KEditor.vue

        // Load existing history for this page from localStorage
        var allHistories = self.loadAllHistories();
        var pageHistory = allHistories[pageId];

        // Decompress versions if they exist
        var versions = [];
        if (pageHistory && pageHistory.versions) {
            versions = pageHistory.versions.map(function(version) {
                return {
                    content: self.decompressContent(version.content),
                    timestamp: version.timestamp
                };
            });
        }

        // Get the page's updated_at timestamp from options (from database)
        var pageUpdatedAt = self.options.pageUpdatedAt || null;
        // Get when we last saved a snapshot locally
        var lastSavedAt = pageHistory ? pageHistory.lastSavedAt : null;

        console.log("[KEditor History] Comparing timestamps:", {
            pageUpdatedAt: pageUpdatedAt,
            lastSavedAt: lastSavedAt
        });

        // Check if page was updated externally (by another user)
        // If the database's updated_at is NEWER than when we last saved, someone else modified it
        var wasUpdatedExternally = false;
        if (pageUpdatedAt && lastSavedAt) {
            var dbTime = new Date(pageUpdatedAt).getTime();
            var savedTime = new Date(lastSavedAt).getTime();
            // Add 2 second buffer to account for timing differences
            if (dbTime > savedTime + 2000) {
                console.log('[KEditor History] Page was updated externally (DB is newer)', {
                    lastSavedAt: lastSavedAt,
                    pageUpdatedAt: pageUpdatedAt,
                    diffMs: dbTime - savedTime
                });
                wasUpdatedExternally = true;
                versions = [];  // Reset versions
            }
        }

        // Initialize history state
        self.historyState = {
            pageId: pageId,
            versions: versions,
            currentIndex: wasUpdatedExternally ? -1 : (pageHistory ? pageHistory.currentIndex : -1),
            maxVersions: KEditor.MAX_VERSIONS_PER_PAGE,
            isRestoring: false,
            saveTimeout: null,
            lastSavedAt: lastSavedAt
        };

        console.log('[KEditor History] Initialized for page:', pageId, {
            existingVersions: self.historyState.versions.length,
            currentIndex: self.historyState.currentIndex,
            lastSavedAt: lastSavedAt,
            wasUpdatedExternally: wasUpdatedExternally
        });

        // Update history button states (header buttons via callback)
        self.updateHistoryButtons();

        // Setup keyboard shortcuts for undo/redo
        self.initHistoryKeyboardShortcuts();

        // If no existing history or page was updated externally, save current content as first version
        setTimeout(function() {
            if (self.historyState && self.historyState.versions.length > 0 && !wasUpdatedExternally) {
                console.log('[KEditor History] Using existing history with', self.historyState.versions.length, 'versions');
                self.updateHistoryButtons();
            } else {
                // No existing history or page was updated externally, save current content as first version
                console.log('[KEditor History] Saving initial snapshot');
                self.saveHistorySnapshot();
            }
        }, 1000);
    };

    KEditor.prototype.loadAllHistories = function () {
        try {
            if (typeof localStorage === 'undefined') {
                return {};
            }
            var stored = localStorage.getItem(KEditor.HISTORY_STORAGE_KEY);
            if (stored) {
                return JSON.parse(stored);
            }
        } catch (e) {
            flog('Error loading histories:', e);
        }
        return {};
    };

    // Called when switching to a different page (editor is reused)
    KEditor.prototype.switchPageHistory = function () {
        var self = this;
        var newPageId = self.getPageId();

        // Check if we're actually switching to a different page
        if (self.historyState && self.historyState.pageId === newPageId) {
            console.log('[KEditor History] Same page, no switch needed:', newPageId);
            return;
        }

        // Cancel any pending saves for the old page
        if (self.historyState && self.historyState.saveTimeout) {
            clearTimeout(self.historyState.saveTimeout);
            self.historyState.saveTimeout = null;
        }

        // Load history for the new page
        var allHistories = self.loadAllHistories();
        var pageHistory = allHistories[newPageId];

        // Get the page's updated_at timestamp from options (from database)
        var pageUpdatedAt = self.options.pageUpdatedAt || null;
        // Get when we last saved a snapshot locally
        var lastSavedAt = pageHistory ? pageHistory.lastSavedAt : null;

        // Check if page was updated externally (by another user)
        var wasUpdatedExternally = false;
        if (pageUpdatedAt && lastSavedAt) {
            var dbTime = new Date(pageUpdatedAt).getTime();
            var savedTime = new Date(lastSavedAt).getTime();
            // Add 2 second buffer to account for timing differences
            if (dbTime > savedTime + 2000) {
                console.log('[KEditor History] Page was updated externally after switch (DB is newer)', {
                    lastSavedAt: lastSavedAt,
                    pageUpdatedAt: pageUpdatedAt,
                    diffMs: dbTime - savedTime
                });
                wasUpdatedExternally = true;
            }
        }

        // Decompress versions if they exist (and page wasn't updated externally)
        var versions = [];
        if (!wasUpdatedExternally && pageHistory && pageHistory.versions) {
            versions = pageHistory.versions.map(function(version) {
                return {
                    content: self.decompressContent(version.content),
                    timestamp: version.timestamp
                };
            });
        }

        // Update history state for new page
        self.historyState = {
            pageId: newPageId,
            versions: versions,
            currentIndex: wasUpdatedExternally ? -1 : (pageHistory ? pageHistory.currentIndex : -1),
            maxVersions: KEditor.MAX_VERSIONS_PER_PAGE,
            isRestoring: false,
            saveTimeout: null,
            lastSavedAt: lastSavedAt
        };

        console.log('[KEditor History] Switched to page:', newPageId, {
            existingVersions: self.historyState.versions.length,
            currentIndex: self.historyState.currentIndex,
            lastSavedAt: lastSavedAt,
            wasUpdatedExternally: wasUpdatedExternally
        });

        // Update button states
        if (self.updateHistoryButtons) {
            self.updateHistoryButtons();
        }

        // If no existing history or page was updated externally, save current content as first version
        setTimeout(function() {
            if (self.historyState && self.historyState.versions.length > 0 && !wasUpdatedExternally) {
                console.log('[KEditor History] Using existing history after switch with', self.historyState.versions.length, 'versions');
                self.updateHistoryButtons();
            } else {
                // No existing history or page was updated externally
                setTimeout(function() {
                    if (self.historyState && self.historyState.pageId === newPageId) {
                        console.log('[KEditor History] Saving initial snapshot after switch');
                        self.saveHistorySnapshot();
                    }
                }, 500);
            }
        }, 1000);
    };

    KEditor.prototype.initHistoryKeyboardShortcuts = function () {
        var self = this;

        // Remove any existing keyboard handlers to avoid duplicates
        $(document).off('keydown.keditor-history');

        // Keyboard shortcuts for undo/redo
        $(document).on('keydown.keditor-history', function(e) {
            if (e.ctrlKey || e.metaKey) {
                if (e.key === 'z' && !e.shiftKey) {
                    e.preventDefault();
                    console.log('[KEditor History] Ctrl+Z pressed');
                    self.undo();
                } else if (e.key === 'y' || (e.key === 'z' && e.shiftKey)) {
                    e.preventDefault();
                    console.log('[KEditor History] Ctrl+Y or Ctrl+Shift+Z pressed');
                    self.redo();
                }
            }
        });
    };

    KEditor.prototype.updateHistoryButtons = function () {
        var self = this;
        var canUndo = self.canUndo();
        var canRedo = self.canRedo();

        // Notify Vue component of history state change (header buttons)
        if (self.options.onHistoryChange) {
            self.options.onHistoryChange(canUndo, canRedo);
        }
    };

    KEditor.prototype.saveHistory = function () {
        var self = this;
        var pageId = self.historyState.pageId;

        try {
            // Check if localStorage is available
            if (typeof localStorage === 'undefined') {
                return;
            }

            // Load all histories
            var allHistories = self.loadAllHistories();

            // Compress versions before saving
            var originalSize = 0;
            var compressedSize = 0;
            var compressedVersions = self.historyState.versions.map(function(version) {
                originalSize += version.content.length;
                var compressed = self.compressContent(version.content);
                compressedSize += compressed.length;
                return {
                    content: compressed,
                    timestamp: version.timestamp
                };
            });

            if (originalSize > 0 && compressedSize > 0) {
                var compressionRatio = ((1 - compressedSize / originalSize) * 100).toFixed(1);
                console.log('[KEditor History] Compression stats:', {
                    originalSize: originalSize,
                    compressedSize: compressedSize,
                    compressionRatio: compressionRatio + '%',
                    savings: (originalSize - compressedSize) + ' bytes'
                });
            }

            // Update this page's history
            allHistories[pageId] = {
                versions: compressedVersions,
                currentIndex: self.historyState.currentIndex,
                lastModified: new Date().toISOString(),
                lastSavedAt: self.historyState.lastSavedAt || new Date().toISOString()
            };

            // Trim number of pages if exceeds limit (keep most recently modified)
            var pageIds = Object.keys(allHistories);
            if (pageIds.length > KEditor.MAX_PAGES_IN_HISTORY) {
                // Sort by lastModified, oldest first
                pageIds.sort(function(a, b) {
                    var aTime = allHistories[a].lastModified || '';
                    var bTime = allHistories[b].lastModified || '';
                    return aTime.localeCompare(bTime);
                });
                // Remove oldest pages
                var removeCount = pageIds.length - KEditor.MAX_PAGES_IN_HISTORY;
                for (var i = 0; i < removeCount; i++) {
                    delete allHistories[pageIds[i]];
                    console.log('[KEditor History] Removed old page history:', pageIds[i]);
                }
            }

            localStorage.setItem(KEditor.HISTORY_STORAGE_KEY, JSON.stringify(allHistories));
        } catch (e) {
            flog('Error saving history:', e);
            // If storage is full, try to clear old versions and pages
            if (e.name === 'QuotaExceededError' || e.code === 22) {
                self.trimHistory();
                self.cleanupOldPages();
                try {
                    var allHistories = self.loadAllHistories();
                    // Compress versions before saving
                    var compressedVersions = self.historyState.versions.map(function(version) {
                        return {
                            content: self.compressContent(version.content),
                            timestamp: version.timestamp
                        };
                    });
                    allHistories[pageId] = {
                        versions: compressedVersions,
                        currentIndex: self.historyState.currentIndex,
                        lastModified: new Date().toISOString(),
                        lastSavedAt: self.historyState.lastSavedAt || new Date().toISOString()
                    };
                    localStorage.setItem(KEditor.HISTORY_STORAGE_KEY, JSON.stringify(allHistories));
                } catch (e2) {
                    flog('Error saving history after trim:', e2);
                }
            }
        }
    };

    KEditor.prototype.trimHistory = function () {
        var self = this;
        // Keep only the last maxVersions
        if (self.historyState.versions.length > self.historyState.maxVersions) {
            var removeCount = self.historyState.versions.length - self.historyState.maxVersions;
            self.historyState.versions.splice(0, removeCount);
            self.historyState.currentIndex = Math.min(
                self.historyState.currentIndex,
                self.historyState.versions.length - 1
            );
        }
    };

    KEditor.prototype.cleanupOldPages = function () {
        var self = this;
        try {
            var allHistories = self.loadAllHistories();
            var pageIds = Object.keys(allHistories);

            // Keep only the 10 most recent pages
            if (pageIds.length > 10) {
                pageIds.sort(function(a, b) {
                    var aTime = allHistories[a].lastModified || '';
                    var bTime = allHistories[b].lastModified || '';
                    return aTime.localeCompare(bTime);
                });
                var removeCount = pageIds.length - 10;
                for (var i = 0; i < removeCount; i++) {
                    delete allHistories[pageIds[i]];
                }
                localStorage.setItem(KEditor.HISTORY_STORAGE_KEY, JSON.stringify(allHistories));
                console.log('[KEditor History] Cleaned up', removeCount, 'old page histories');
            }
        } catch (e) {
            flog('Error cleaning up old pages:', e);
        }
    };

    KEditor.prototype.saveHistorySnapshot = function () {
        var self = this;

        // Don't save snapshot if we're currently restoring
        if (self.historyState.isRestoring) {
            return;
        }

        // Clear any pending save
        if (self.historyState.saveTimeout) {
            clearTimeout(self.historyState.saveTimeout);
        }

        // Debounce snapshot saving (wait 500ms after last change)
        self.historyState.saveTimeout = setTimeout(function () {
            self.getContent().then(function (content) {
                var timestamp = new Date().toISOString();
                var snapshot = {
                    content: content,
                    timestamp: timestamp
                };

                // Remove any versions after current index (when undoing and then making new changes)
                if (self.historyState.currentIndex < self.historyState.versions.length - 1) {
                    self.historyState.versions = self.historyState.versions.slice(0, self.historyState.currentIndex + 1);
                }

                // Add new version
                self.historyState.versions.push(snapshot);
                self.historyState.currentIndex = self.historyState.versions.length - 1;

                // Trim if exceeds max
                if (self.historyState.versions.length > self.historyState.maxVersions) {
                    self.trimHistory();
                }

                // Update the stored timestamp to current time (when we made our last save)
                // This will be compared against the database's updated_at on next load
                self.historyState.lastSavedAt = timestamp;

                // Save to localStorage (for current session persistence)
                self.saveHistory();

                console.log('[KEditor History] Snapshot saved:', {
                    pageId: self.historyState.pageId,
                    totalVersions: self.historyState.versions.length,
                    currentIndex: self.historyState.currentIndex,
                    timestamp: timestamp,
                    contentLength: content.length
                });
                flog('History snapshot saved. Total versions:', self.historyState.versions.length, 'Current index:', self.historyState.currentIndex);

                // Update button states
                if (self.updateHistoryButtons) {
                    self.updateHistoryButtons();
                }
            }).catch(function (error) {
                flog('Error saving history snapshot:', error);
            });
        }, 500);
    };

    KEditor.prototype.canUndo = function () {
        var self = this;
        return self.historyState && self.historyState.currentIndex > 0;
    };

    KEditor.prototype.canRedo = function () {
        var self = this;
        return self.historyState &&
               self.historyState.currentIndex < self.historyState.versions.length - 1;
    };

    KEditor.prototype.undo = function () {
        var self = this;

        if (!self.canUndo()) {
            flog('Cannot undo: already at first version');
            return false;
        }

        // Set restoring flag immediately to prevent any new snapshots
        self.historyState.isRestoring = true;

        // Cancel any pending snapshot saves
        if (self.historyState.saveTimeout) {
            clearTimeout(self.historyState.saveTimeout);
            self.historyState.saveTimeout = null;
        }

        // Move to previous version
        self.historyState.currentIndex--;
        var targetVersion = self.historyState.versions[self.historyState.currentIndex];

        console.log('[KEditor History] Undo - Restoring version:', {
            pageId: self.historyState.pageId,
            index: self.historyState.currentIndex,
            totalVersions: self.historyState.versions.length,
            timestamp: targetVersion.timestamp,
            contentLength: targetVersion.content.length
        });

        // Restore the version
        self.setContent(targetVersion.content);

        // Save history state to localStorage
        self.saveHistory();

        // Reset flag after a delay to allow setContent to complete
        setTimeout(function () {
            self.historyState.isRestoring = false;
            self.updateHistoryButtons();
        }, 600);

        flog('Undo: restored version', self.historyState.currentIndex);
        return true;
    };

    KEditor.prototype.redo = function () {
        var self = this;

        if (!self.canRedo()) {
            flog('Cannot redo: already at last version');
            return false;
        }

        // Set restoring flag immediately to prevent any new snapshots
        self.historyState.isRestoring = true;

        // Cancel any pending snapshot saves
        if (self.historyState.saveTimeout) {
            clearTimeout(self.historyState.saveTimeout);
            self.historyState.saveTimeout = null;
        }

        // Move to next version
        self.historyState.currentIndex++;
        var targetVersion = self.historyState.versions[self.historyState.currentIndex];

        console.log('[KEditor History] Redo - Restoring version:', {
            pageId: self.historyState.pageId,
            index: self.historyState.currentIndex,
            totalVersions: self.historyState.versions.length,
            timestamp: targetVersion.timestamp,
            contentLength: targetVersion.content.length
        });

        // Restore the version
        self.setContent(targetVersion.content);

        // Save history state to localStorage
        self.saveHistory();

        // Reset flag after a delay to allow setContent to complete
        setTimeout(function () {
            self.historyState.isRestoring = false;
            self.updateHistoryButtons();
        }, 600);

        flog('Redo: restored version', self.historyState.currentIndex);
        return true;
    };

    KEditor.prototype.initNiceScroll = function (target) {
        flog('initNiceScroll', target);

        if ($.fn.niceScroll && this.options.niceScrollEnabled) {
            flog('Initialize $.fn.niceScroll');
            target.niceScroll({
                cursorcolor: '#999',
                cursorwidth: 6,
                railpadding: {
                    top: 0,
                    right: 0,
                    left: 0,
                    bottom: 0
                },
                cursorborder: '',
                disablemutationobserver: true
            });
        } else {
            flog('$.fn.niceScroll does not exist. Use default sidebar.');
        }
    };

    KEditor.prototype.initFrame = function (target, callback) {
        flog('initFrame', target);


        var self = this;
        var options = self.options;
        var originalContent;
        var content = options.content;
        var _templateVersion,
            _currentVersion;




        self.template = target.html();


        // compile content with handlebars
        //originalContent = self.compileHandlebars(originalContent)

        var iframe = self.iframe = $('<iframe style="display:none" />');


        //console.log("iframe",iframe)
        //var iframe = document.createElement('iframe'),
        iframe.src = "about:blank";
        var iframeId = self.generateId('frame');


        // Why do i have to insert that?
        target.append(iframe);


        iframe.attr({
            'id': iframeId,
            'class': 'keditor-ui keditor-frame',
            "src": "about:blank"
        });



        //target.css('display', 'none');
        target.attr('data-keditor-frame', '#' + iframeId);

        var iframeDoc = self.iframeDoc = iframe.contents();
        // Fix issue Firefox can't render content inside iframe
        // ======================================================
        iframeDoc.get(0).open();
        iframeDoc.get(0).close();
        // ======================================================
        self.window = iframe[0].contentWindow ? iframe[0].contentWindow : iframe[0].contentDocument.defaultView;

        // Workaround for Froala bug: toolbar.enable() called when toolbar is undefined during scroll
        // This error occurs when toolbarInline is true and selection handles are deselected during scroll
        self.window.addEventListener('error', function(e) {
            if (e && e.message && e.message.indexOf("Cannot read properties of undefined (reading 'enable')") !== -1) {
                e.preventDefault();
                e.stopPropagation();
                return true;
            }
        });

        var iframeHead = self.iframeHead = iframeDoc.find('head');
        var iframeBody = self.iframeBody = iframeDoc.find('body');

        var newDoctype = document.implementation.createDocumentType(
            'html',
            '',
            ''
        );
        iframe[0].contentDocument.insertBefore(newDoctype, iframe[0].contentDocument.childNodes[0]);

        // inacticityCheck
        $(iframeDoc).mousemove(function (e) {
            //window.parent._AMS.idleTime = 0;
        });
        $(iframeDoc).keypress(function (e) {
            //window.parent._AMS.idleTime = 0;
        });

        self.window.jQuery = function (selector) { return window.jQuery(selector, document); };
        jQuery = window.$.extend(jQuery, parent.$);
        self.window.$ = jQuery;
        self.window.jQuery = jQuery;
        self.window.FroalaPluginsShared = window.FroalaPluginsShared;
        self.window.FroalaConfig = window.FroalaConfig;
        //self.window.FroalaEditor = FroalaEditor;
        //delete window.FroalaEditor;



        self.window.p$ = {};

        self.window.p$ = {};
        self.window.p$.snippet = {};
        self.window.p$.module = {};

        flog('Adding styles to iframe...');
        var styles = '',
            scripts = '';

        //setWebFonts
        var customFontsOfCI = (self.corporateIdentity && self.corporateIdentity._customFonts) ? self.corporateIdentity._customFonts : null;
        if (self.options.groupSettings.customFonts && self.options.groupSettings.customFonts.length > 0) {
            this.setCustomUploadedFont(self.options.groupSettings.customFonts)
        }
        // Load Adobe Fonts if configured
        if (self.options.groupSettings.adobeFonts && self.options.groupSettings.adobeFonts.length > 0) {
            this.setAdobeFonts(self.options.groupSettings.adobeFonts);
        }
        this.setCustomFont(customFontsOfCI);









        var style;

        $.each(options.cssRaw, function (index, value) {
            styles += '<style type="text/css">' + value + '</style>\n';
        })

        $.each(options.jsRaw, function (index, value) {
            scripts += '<script type="text/javascript" >' + value + '<\/script>\n';
        })


        // console.log("self", self);

        if (options.pageLanguage) {
            iframeDoc.find('html').attr("lang", options.pageLanguage);
        }
        // no translation for google tranlate
        iframeDoc.find('html').attr("translate", "no");


        iframeHead.append(styles);
        iframeHead.append(scripts);


        var baseTag = document.createElement('base');
        iframeHead.append(baseTag);



        $.when(self.loadCSS(options.css, iframeHead))
        $.when(self.loadJS(options.js, iframeHead))
            .always(function () {

                var customColorOfCI = (self.corporateIdentity && self.corporateIdentity._customColor) ? self.corporateIdentity._customColor : null;
                var _colorString = self.setBaseColors(customColorOfCI);
                if (_colorString) var styles = '<style class="customColorOfCI" type="text/css">' + _colorString + '</style>\n';
                self.iframeHead.append(styles);

                // v2-Typografie-Modusklasse (Spec 2026-08-18-typography-round-design.md §3): steuert v2-type.scss im Editor-Iframe, unabhaengig vom setCustomTypo-Alt-Pfad darunter.
                if (self.corporateIdentity && self.corporateIdentity.designTokens && self.corporateIdentity.designTokens.typography && self.corporateIdentity.designTokens.typography.enabled === true) self.window.document.documentElement.classList.add('wm-typo'); else self.window.document.documentElement.classList.remove('wm-typo');
                if (self.corporateIdentity && self.corporateIdentity.enableExtendTypo && self.corporateIdentity.extendTypo) self.setCustomTypo(self.corporateIdentity.extendTypo);
                if (self.corporateIdentity && self.corporateIdentity.buttons) self.setCustomButtons(self.corporateIdentity.buttons);

                // add custom CSS
                iframeHead.prepend('<style class="customCss" type="text/css">' + options.customCss + '</style>\n');

                // init template
                self.options.template = new self.window.p$.module[self.options.templateName];

                flog('All styles are added');

                flog('Adding original content to iframe...');
                var contentAreasWrapper;

                if (content) {

                    var _dom = self.window.document.createElement("div");
                    _dom.innerHTML = content.trim();
                    _dom = _dom.children[0];



                    var isSection = $(_dom).is('section');
                    if (!isSection) {
                        content = "<section>" + $(_dom).prop('outerHTML') + "</section>";
                    }
                    originalContent = content;

                    target.find("pgs-article").remove();
                } else {

                    originalContent = target.is('textarea') ? target.val() : target.html();

                    originalContent = "<section>" + originalContent + "</section>";

                    target.find("pgs-article").remove();

                }


                // compile content with handlebars
                //self.window = iframe[0];
                originalContent = self.compileHandlebars(originalContent)

                if (options.contentAreasWrapper) {
                    contentAreasWrapper = $(options.contentAreasWrapper);
                    contentAreasWrapper.html(originalContent);
                    iframeBody.append(contentAreasWrapper);
                } else {
                    iframeBody.html(originalContent);
                }

                // delete helper iframe again (dont know why it is neccesary...?)
                $(iframeBody).find("iframe.keditor-ui").remove();

                self.body = iframeBody;

                $.each(options.css, function (index, value) {
                    //styles += '<link rel="stylesheet" type="text/css" href="' + value + '" />\n';
                })

                $.each(options.js, function (index, value) {
                    //scripts += '<script type="text/javascript" src="' + value + '" ><\/script>\n';
                })

                // add mp4 video provider
                self.window.FroalaEditor.VIDEO_PROVIDERS.push(
                    {
                        test_regex: /\.(mp4)$/,
                        url_regex: /(https?:\/\/[a-zA-Z0-9_\-\/\.]+\.(mp4))/,
                        url_text: "$1",
                        html: '<video controls><source src="{url}" type="video/mp4">Your browser does not support the video tag.</video>',
                        provider: "mp4"
                    }
                );

                self.iframe.show();

                if (typeof options.onInitFrame === 'function') {
                    options.onInitFrame.call(self, iframe, iframeHead, iframeBody);
                }

                // Initialize the selection widget when KEditor starts
                self.initSelectionWidget();

                callback(contentAreasWrapper || iframeBody);
            });


    };


    KEditor.prototype.loadJS = function (_loaded, iframeHead) {
        var promise,
            deferred = $.Deferred(),
            dependencies = [];



        for (var n = 0; n < _loaded.length; n++) {
            dependencies.push(
                promise = $.ajax({
                    url: _loaded[n] + "?v=" + new Date().getTime(),
                    template: {
                        type: "js",
                        index: n
                    },
                    dataType: 'text',
                    type: 'GET'
                }).always(function (data, status, xhr) {
                    //hack: htaccess rewrites to html file, so if js not available it loads the html. If it is a html (containes "<!doctype"), insert blank text
                    if (xhr.responseText == undefined || xhr.responseText.indexOf('<!doctype') == 0) {
                        xhr.responseText = "";
                    }
                    iframeHead.append("<script class='fromTemplate'>" + xhr.responseText + "</script>")
                }).then(function (data) {

                    return data;
                }, function (err) {
                    // convert failure into success so $.when() doesn't stop
                    return $.Deferred().resolve('err');
                })
            )
        }

        // when all dependencies (all connected JS and CSS) files are loaded - we're done!
        $.when.apply($, dependencies).done(function () {
            // all loaded - callback
            deferred.resolve(_loaded);
        })

        return deferred.promise();
    }

    KEditor.prototype.loadCSS = function (_loaded, iframeHead) {
        var promise,
            deferred = $.Deferred(),
            dependencies = [];



        for (var n = 0; n < _loaded.length; n++) {
            dependencies.push(
                promise = $.ajax({
                    url: _loaded[n] + "?v=" + new Date().getTime(),
                    template: {
                        type: "css",
                        index: n
                    },
                    dataType: 'text',
                    type: 'GET'
                }).always(function (data, status, xhr) {
                    if (xhr.responseText == undefined || xhr.responseText.indexOf('<!doctype') == 0) {
                        xhr.responseText = "";
                    }
                    // append before style tag with classname customColorOfCI if existing
                    if (iframeHead.find(".customColorOfCI").length > 0) {
                        iframeHead.find(".customColorOfCI").before("<style class='custom'>" + xhr.responseText + "</style>")
                    } else {
                        iframeHead.append("<style class='custom'>" + xhr.responseText + "</style>")
                    }

                }).then(function (data) {
                    return data;
                }, function (err) {
                    // convert failure into success so $.when() doesn't stop
                    return $.Deferred().resolve('err');
                })
            )
        }

        // when all dependencies (all connected JS and CSS) files are loaded - we're done!
        $.when.apply($, dependencies).done(function () {

            // all loaded - callback
            deferred.resolve(_loaded);
        })

        return deferred.promise();
    }



    KEditor.prototype.setBaseColors = function (_colors) {
        // Retrieve the object from storage

        //----------------------------------------
        // LIVE GENERATOR
        //----------------------------------------
        //var s = document.styleSheets[5];
        // createStyles("body", "background-color", "red");

        var colorString = "";


        /**
         * Base scheme for the bs4 primary color.
         */
        var t1 = "007bff"; // hsl(211, 100%, 50%)
        var t2 = "0062cc"; // hsl(211, 100%, 40%)
        var t3 = "9fcdff"; // hsl(211, 100%, 81%)
        var t4 = "b8daff"; // hsl(211, 100%, 86%)
        var t5 = "004085"; // hsl(211, 100%, 26%)
        var t6 = "005cbf"; // hsl(211, 100%, 37%)
        var t7 = "0069d9"; // hsl(211, 100%, 43%)
        var t8 = "002752"; // hsl(211, 100%, 16%)
        var t9 = "cce5ff"; // hsl(211, 100%, 90%)
        var shadow = 'rgba(0, 123, 255, 0.5)'; // hsl(211, 100%, 50%)
        var _suffix = ["primary", "secondary", "tertiary", "quaternary"]

        if (_colors !== null) {
            $.each(_colors, function (key, value) {
                if (!value) value = t1;
                colorString += updateColor(value, _suffix[key])
            });
        } else {
            colorString = updateColor(t1, _suffix[0])
        }

        //if(!primary) primary=t1;

        /*colorString+=updateColor(primary, "primary");
        if(secondary) colorString+=updateColor(secondary,"secondary");
        if(tertiary) colorString+=updateColor(tertiary,"tertiary");
        if(quaternary) colorString+=updateColor(quaternary,"quaternary");*/

        return colorString;



        function updateColor(color, suffix) {

            var hsl = hexToHSL(color);
            var _rgb = hexToRGB(color);
            var rgb = "rgb(" + +_rgb.r + "," + +_rgb.g + "," + +_rgb.b + ")";

            var hsl_h = hsl.h;
            var hsl_s = hsl.s;
            var hsl_l = hsl.l;

            t1 = HSLToHex(hsl_h, hsl_s, hsl_l);
            t2 = HSLToHex(hsl_h, hsl_s, hslAddition(hsl_l, -10));
            t3 = HSLToHex(hsl_h, hsl_s, hslAddition(hsl_l, 31));
            t4 = HSLToHex(hsl_h, hsl_s, hslAddition(hsl_l, 36));
            t5 = HSLToHex(hsl_h, hsl_s, hslAddition(hsl_l, -24));
            t6 = HSLToHex(hsl_h, hsl_s, hslAddition(hsl_l, -13));
            t7 = HSLToHex(hsl_h, hsl_s, hslAddition(hsl_l, -7));
            t8 = HSLToHex(hsl_h, hsl_s, hslAddition(hsl_l, -34));
            t9 = HSLToHex(hsl_h, hsl_s, hslAddition(hsl_l, 40));
            shadow = '0 0 0 0.2rem rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 0.5)';

            var _string = "";

            //----------------------------------------
            // Special
            //----------------------------------------
            if (suffix == "primary") {


                _string += createStyles("a", "color", t1, true);
                _string += createStyles("a:hover", "color", t2, true);
                _string += createStyles(".btn-link", "color", t1);
                _string += createStyles(".btn-link:hover", "color", t2);
                _string += createStyles(".btn-light", "color", t1);
                _string += createStyles(".btn-light:hover", "color", t2);








                _string += createStyles(" .ct-series-a .ct-area, .ct-series-a .ct-slice-donut-solid, .ct-series-a .ct-slice-pie", "fill", t1);
                _string += createStyles(" .ct-series-b .ct-area, .ct-series-b .ct-slice-donut-solid, .ct-series-b .ct-slice-pie", "fill", t2);
                _string += createStyles(" .ct-series-c .ct-area, .ct-series-c .ct-slice-donut-solid, .ct-series-c .ct-slice-pie", "fill", t3);
                _string += createStyles(" .ct-series-d .ct-area, .ct-series-d .ct-slice-donut-solid, .ct-series-d .ct-slice-pie", "fill", t4);
                _string += createStyles(" .ct-series-e .ct-area, .ct-series-e .ct-slice-donut-solid, .ct-series-e .ct-slice-pie", "fill", t5);
                _string += createStyles(" .ct-series-f .ct-area, .ct-series-f .ct-slice-donut-solid, .ct-series-f .ct-slice-pie", "fill", t6);
                _string += createStyles(" .ct-series-g .ct-area, .ct-series-g .ct-slice-donut-solid, .ct-series-g .ct-slice-pie", "fill", t7);
                _string += createStyles(" .ct-series-h .ct-area, .ct-series-h .ct-slice-donut-solid, .ct-series-h .ct-slice-pie", "fill", t8);
                _string += createStyles(" .ct-series-i .ct-area, .ct-series-i .ct-slice-donut-solid, .ct-series-i .ct-slice-pie", "fill", t9);

                _string += createStyles(".nav-pills .nav-link.active, .nav-pills .show>.nav-link", "color", t1, true)
                _string += createStyles(".nav-link:hover", "color", t1, true)
            }

            //----------------------------------------
            // t1
            //----------------------------------------
            _string += createStyles("." + suffix + "-hover:hover", "color", t1);
            _string += createStyles(".badge-" + suffix + "", "background-color", t1);
            _string += createStyles(".bg-" + suffix + "", "background-color", t1);
            _string += createStyles(".border-" + suffix + "", "border-color", t1);
            _string += createStyles(".btn-" + suffix + "", "background-color", t1);
            _string += createStyles(".btn-" + suffix + "", "border-color", t1);
            _string += createStyles(".btn-" + suffix + ".disabled, .btn-" + suffix + ":disabled", "background-color", t1);
            _string += createStyles(".btn-" + suffix + ".disabled, .btn-" + suffix + ":disabled", "border-color", t1);

            _string += createStyles(".btn-outline-" + suffix + "", "color", t1);
            _string += createStyles(".btn-outline-" + suffix + "", "border-color", t1);
            _string += createStyles(".btn-outline-" + suffix + ":hover", "background-color", t1);
            _string += createStyles(".btn-outline-" + suffix + ":hover", "border-color", t1);
            _string += createStyles(".btn-outline-" + suffix + ".disabled, .btn-outline-" + suffix + ":disabled", "color", t1);
            _string += createStyles(".btn-outline-" + suffix + ":not(:disabled):not(.disabled):active, .btn-outline-" + suffix + ":not(:disabled):not(.disabled).active, .show > .btn-outline-" + suffix + ".dropdown-toggle", "background-color", t1);
            _string += createStyles(".btn-outline-" + suffix + ":not(:disabled):not(.disabled):active, .btn-outline-" + suffix + ":not(:disabled):not(.disabled).active, .show > .btn-outline-" + suffix + ".dropdown-toggle", "border-color", t1);
            _string += createStyles(".text-" + suffix + "", "color", t1);
            _string += createStyles(".before-bg-" + suffix + ":before", "background-color", t1);
            _string += createStyles(".after-bg-" + suffix + ":after", "background-color", t1);
            _string += createStyles(".before-" + suffix + ":before", "color", t1);
            _string += createStyles(".after-" + suffix + ":after", "color", t1);
            if (suffix == "primary") {
                _string += "div.wps-bgbeforecolor:before {background-color: var(--before-bg-color, " + t1 + ") !important;}";
            }

            _string += createStyles(".swiper-pagination .pgs-bg-primary", "background-color", t1);
            _string += createStyles(".swiper-pagination-bullet-active", "background-color", t1);
            _string += createStyles("pgs-article.pgs-article .swiper-pagination .pgs-bg-primary", "background-color", t1);
            _string += createStyles("pgs-article.pgs-article .swiper-pagination-bullet.swiper-pagination-bullet-active", "background-color", t1);

            _string += createStyles(".fill-" + suffix + "", "fill", t1);

            //----------------------------------------
            // t2
            //----------------------------------------
            _string += createStyles(".badge-" + suffix + "[href]:hover, .badge-" + suffix + "[href]:focus", "background-color", t2);
            _string += createStyles("a.bg-" + suffix + ":hover, a.bg-" + suffix + ":focus, button.bg-" + suffix + ":hover, button.bg-" + suffix + ":focus", "background-color", t2);
            _string += createStyles(".btn-" + suffix + ":hover", "border-color", t2);
            _string += createStyles(".btn-" + suffix + ":not(:disabled):not(.disabled):active, .btn-" + suffix + ":not(:disabled):not(.disabled).active, .show > .btn-" + suffix + ".dropdown-toggle", "background-color", t2);
            _string += createStyles("a.text-" + suffix + ":hover, a.text-" + suffix + ":focus", "color", t2);


            //----------------------------------------
            // t3
            //----------------------------------------
            _string += createStyles(".alert-" + suffix + " hr", "border-top-color", t3);
            _string += createStyles(".list-group-item-" + suffix + ".list-group-item-action:hover, .list-group-item-" + suffix + ".list-group-item-action:focus", "background-color", t3);
            _string += createStyles(".table-hover .table-" + suffix + ":hover", "background-color", t3);
            _string += createStyles(".table-hover .table-" + suffix + ":hover > td, .table-hover .table-" + suffix + ":hover > th", "background-color", t3);


            //----------------------------------------
            // t4
            //----------------------------------------
            _string += createStyles(".alert-" + suffix + "", "border-color", t4);
            _string += createStyles(".list-group-item-" + suffix + "", "background-color", t4);
            _string += createStyles(".table-" + suffix + ", .table-" + suffix + " > th, .table-" + suffix + " > td", "background-color", t4);


            //----------------------------------------
            // t5
            //----------------------------------------
            _string += createStyles(".alert-" + suffix + "", "color", t5);
            _string += createStyles(".list-group-item-" + suffix + "", "color", t5);
            _string += createStyles(".list-group-item-" + suffix + ".list-group-item-action:hover, .list-group-item-" + suffix + ".list-group-item-action:focus", "color", t5);
            _string += createStyles(".list-group-item-" + suffix + ".list-group-item-action.active", "background-color", t5);
            _string += createStyles(".list-group-item-" + suffix + ".list-group-item-action.active", "border-color", t5);

            //----------------------------------------
            // t6
            //----------------------------------------
            _string += createStyles(".btn-" + suffix + ":not(:disabled):not(.disabled):active, .btn-" + suffix + ":not(:disabled):not(.disabled).active, .show > .btn-" + suffix + ".dropdown-toggle", "border-color", t6);


            //----------------------------------------
            // t7
            //----------------------------------------
            _string += createStyles(".btn-" + suffix + ":hover", "background-color", t7);

            //----------------------------------------
            // t8
            //----------------------------------------
            _string += createStyles(".alert-" + suffix + " .alert-link", "color", t8);

            //----------------------------------------
            // t9
            //----------------------------------------
            _string += createStyles(".alert-" + suffix + "", "background-color", t9);

            //----------------------------------------
            // shadow
            //----------------------------------------
            _string += createStyles(".btn-" + suffix + ":focus, .btn-" + suffix + ".focus", "box-shadow", shadow);
            _string += createStyles(".btn-" + suffix + ":not(:disabled):not(.disabled):active:focus, .btn-" + suffix + ":not(:disabled):not(.disabled).active:focus, .show > .btn-" + suffix + ".dropdown-toggle:focus", "box-shadow", shadow);
            _string += createStyles(".btn-outline-" + suffix + ":focus, .btn-outline-" + suffix + ".focus", "box-shadow", shadow);
            _string += createStyles(".btn-outline-" + suffix + ":not(:disabled):not(.disabled):active:focus, .btn-outline-" + suffix + ":not(:disabled):not(.disabled).active:focus, .show > .btn-outline-" + suffix + ".dropdown-toggle:focus", "box-shadow", shadow);


            //----------------------------------------
            // dark/light
            //----------------------------------------
            // wmContrastTextColor gibt die TEXTfarbe direkt zurueck (nicht
            // ein "Hintergrund ist dunkel"-Flag) — deshalb ohne Umweg ueber
            // ein Zwischen-Flag zugewiesen (Fix-round 1: genau dieser Umweg
            // hatte die Entscheidung invertiert).
            var textColor = wmContrastTextColor(color);
            _string += createStyles(".badge-" + suffix + "", "color", textColor);
            _string += createStyles(".badge-" + suffix + "[href]:hover, .badge-" + suffix + "[href]:focus", "color", textColor);
            _string += createStyles(".btn-" + suffix + "", "color", textColor, true);
            _string += createStyles(".btn-" + suffix + ":hover", "color", textColor);
            _string += createStyles(".btn-" + suffix + ".disabled, .btn-" + suffix + ":disabled", "color", textColor);
            _string += createStyles(".btn-" + suffix + ":not(:disabled):not(.disabled):active, .btn-" + suffix + ":not(:disabled):not(.disabled).active, .show > .btn-" + suffix + ".dropdown-toggle", "color", textColor);
            _string += createStyles(".btn-outline-" + suffix + ":hover", "color", textColor);
            _string += createStyles(".btn-outline-" + suffix + ":not(:disabled):not(.disabled):active, .btn-outline-" + suffix + ":not(:disabled):not(.disabled).active, .show > .btn-outline-" + suffix + ".dropdown-toggle", "color", textColor);
            _string += createStyles(".list-group-item-" + suffix + ".list-group-item-action.active", "color", textColor);

            return _string;
            // console.log(_string);


        }

        function hslAddition(hslValue, number) {
            var newVal = hslValue + number;
            if (newVal < 0) {
                newVal = 0;
            }
            if (newVal > 100) {
                newVal = 100;
            }
            return newVal;
        }

        // https://stackoverflow.com/questions/6620393/is-it-possible-to-alter-a-css-stylesheet-using-javascript-not-the-style-of-an/38133146#38133146
        function createStyles(selector, property, value, noImportant) {
            // Make the strings lowercase
            selector = selector.toLowerCase();
            property = property.toLowerCase();
            value = value.toLowerCase();

            if (noImportant) return (selector + " { " + property + ": " + value + "; }");

            return (selector + " { " + property + ": " + value + "!important; }");
            // Add it if it does not
            //stylesheet.insertRule(selector + " { " + property + ": " + value + "; }", 0);
        }

        function hexToRGB(h) {
            var r = 0, g = 0, b = 0;

            // 3 digits
            if (h.length == 4) {
                r = "0x" + h[1] + h[1];
                g = "0x" + h[2] + h[2];
                b = "0x" + h[3] + h[3];

                // 6 digits
            } else if (h.length == 7) {
                r = "0x" + h[1] + h[2];
                g = "0x" + h[3] + h[4];
                b = "0x" + h[5] + h[6];
            }

            //return "rgb("+ +r + "," + +g + "," + +b + ")";

            return {
                "r": r,
                "g": g,
                "b": b,
            }
        }

        function hexToHSL(H) {
            // Convert hex to RGB first
            var r = 0, g = 0, b = 0;
            if (H.length == 4) {
                r = "0x" + H[1] + H[1];
                g = "0x" + H[2] + H[2];
                b = "0x" + H[3] + H[3];
            } else if (H.length == 7) {
                r = "0x" + H[1] + H[2];
                g = "0x" + H[3] + H[4];
                b = "0x" + H[5] + H[6];
            }
            // Then to HSL
            r /= 255;
            g /= 255;
            b /= 255;
            var cmin = Math.min(r, g, b),
                cmax = Math.max(r, g, b),
                delta = cmax - cmin,
                h = 0,
                s = 0,
                l = 0;

            if (delta == 0)
                h = 0;
            else if (cmax == r)
                h = ((g - b) / delta) % 6;
            else if (cmax == g)
                h = (b - r) / delta + 2;
            else
                h = (r - g) / delta + 4;

            h = Math.round(h * 60);

            if (h < 0)
                h += 360;

            l = (cmax + cmin) / 2;
            s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
            s = +(s * 100).toFixed(1);
            l = +(l * 100).toFixed(1);

            return {
                "h": h,
                "s": s,
                "l": l,
            }
            //return "hsl(" + h + "," + s + "%," + l + "%)";
        }

        function HSLToHex(h, s, l) {
            s /= 100;
            l /= 100;

            var c = (1 - Math.abs(2 * l - 1)) * s,
                x = c * (1 - Math.abs((h / 60) % 2 - 1)),
                m = l - c / 2,
                r = 0,
                g = 0,
                b = 0;

            if (0 <= h && h < 60) {
                r = c; g = x; b = 0;
            } else if (60 <= h && h < 120) {
                r = x; g = c; b = 0;
            } else if (120 <= h && h < 180) {
                r = 0; g = c; b = x;
            } else if (180 <= h && h < 240) {
                r = 0; g = x; b = c;
            } else if (240 <= h && h < 300) {
                r = x; g = 0; b = c;
            } else if (300 <= h && h < 360) {
                r = c; g = 0; b = x;
            }
            // Having obtained RGB, convert channels to hex
            r = Math.round((r + m) * 255).toString(16);
            g = Math.round((g + m) * 255).toString(16);
            b = Math.round((b + m) * 255).toString(16);

            // Prepend 0s, if necessary
            if (r.length == 1)
                r = "0" + r;
            if (g.length == 1)
                g = "0" + g;
            if (b.length == 1)
                b = "0" + b;

            return "#" + r + g + b;
        }

        // Lesbare Textfarbe fuer eine Hintergrundfarbe: WCAG-Leuchtdichte-
        // Kontrast (docs/superpowers/specs/2026-08-18-color-round-design.md
        // §A1), gespiegelt aus src/editor-v2/utils/wcagContrast.ts. Ersetzt
        // die alte, fest verdrahtete Helligkeits-Faustformel, die frueher an
        // dieser Stelle stand. Nur Hex-Parser: an dieser Stelle kommt
        // ausschliesslich Hex aus dem Farbwaehler an, kein rgb()/hsl().
        function wmContrastTextColor(hex) {
            var h = hex.replace('#', '');
            if (h.length === 3) {
                h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
            }
            var r = parseInt(h.substr(0, 2), 16);
            var g = parseInt(h.substr(2, 2), 16);
            var b = parseInt(h.substr(4, 2), 16);
            // Muell-Hex (kein Hex-Zeichen, falsche Laenge inkl. #rgba mit
            // Alpha-Kurzform) -> parseInt liefert NaN -> auf den dokumentierten
            // '#fff'-Fallback fallen (Final-Review M1), nicht stillschweigend
            // auf dunkel (NaN-Vergleiche sind sonst immer false).
            if (isNaN(r) || isNaN(g) || isNaN(b)) return '#fff';

            function lin(c) {
                var s = c / 255;
                return s <= 0.04045 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
            }
            function luminance(rr, gg, bb) {
                return 0.2126 * lin(rr) + 0.7152 * lin(gg) + 0.0722 * lin(bb);
            }
            function ratio(l1, l2) {
                var hi = Math.max(l1, l2), lo = Math.min(l1, l2);
                return (hi + 0.05) / (lo + 0.05);
            }

            var L = luminance(r, g, b);
            var darkL = luminance(33, 37, 41); // #212529
            var ratioWhite = ratio(1, L);
            var ratioDark = ratio(L, darkL);

            if (Math.round(ratioWhite * 100) / 100 >= 3) return '#fff';
            return ratioWhite >= ratioDark ? '#fff' : '#212529';
        }


    }

    KEditor.prototype.setCustomFont = function (_customFonts) {

        var self = this;

        setTimeout(function () {

            if (self.corporateIdentity && self.corporateIdentity.defaultFonts) {
                var _defaultFonts = self.corporateIdentity.defaultFonts;

                // Process fonts in deterministic order: font1, font2, font3, font4
                var fontKeys = ['font1', 'font2', 'font3', 'font4'];

                fontKeys.forEach(function(key, index) {
                    var value = _defaultFonts[key];
                    if (!value || !value.font) return; // Skip if font not defined

                    var keyNumber = index + 1; // font1 = 1, font2 = 2, etc.

                    // Check the type of each font
                    if (value.type === 'google') {
                        console.log('wps-font' + keyNumber + ': ' + value.font + ' is a Google font.');

                        // Load Google font with closure to capture keyNumber
                        (function(fontNum, fontName) {
                            self.window.WebFont.load({
                                google: {
                                    families: [fontName + ":300,400,700"]
                                },
                                context: self.window,
                                active: function () { },
                                fontloading: function (familyName, fvd) {
                                    console.log("fontloading wps-font" + fontNum + ":", familyName);
                                },
                                loading: function () { },
                                inactive: function () { },
                                fontactive: function (familyName, fvd) {
                                    console.log("fontactive wps-font" + fontNum + ":", familyName);
                                    var _baseFontCss = ".wps-font" + fontNum + "{font-family:'" + familyName + "', sans-serif}";
                                    var style_theme = this.context.document.createElement("style");
                                    style_theme.className = "wps-webfont-styles wps-font" + fontNum + "-style";
                                    style_theme.innerHTML = _baseFontCss;
                                    // Remove any existing style for this font number before adding
                                    $(this.context.document).find(".wps-font" + fontNum + "-style").remove();
                                    this.context.document.head.appendChild(style_theme);
                                },
                                fontinactive: function (familyName, fvd) {
                                    console.warn("fontinactive wps-font" + fontNum + ":", familyName);
                                }
                            });
                        })(keyNumber, value.font);

                    } else if (value.type === 'custom') {
                        console.log('wps-font' + keyNumber + ': ' + value.font + ' is a custom font.');
                        var _baseFontCss = ".wps-font" + keyNumber + "{font-family:'" + value.font + "', sans-serif}";
                        var style_theme = document.createElement("style");
                        style_theme.className = "wps-custom-font-styles wps-font" + keyNumber + "-style";
                        style_theme.innerHTML = _baseFontCss;
                        self.window.document.head.appendChild(style_theme);

                    } else if (value.type === 'system') {
                        console.log('wps-font' + keyNumber + ': ' + value.font + ' is a system font.');
                        var _baseFontCss = ".wps-font" + keyNumber + "{font-family:'" + value.font + "', sans-serif}";
                        var style_theme = document.createElement("style");
                        style_theme.className = "wps-systemfont-styles wps-font" + keyNumber + "-style";
                        style_theme.innerHTML = _baseFontCss;
                        self.window.document.head.appendChild(style_theme);

                    } else if (value.type === 'adobe') {
                        console.log('wps-font' + keyNumber + ': ' + value.font + ' is an Adobe font.');
                        var _baseFontCss = ".wps-font" + keyNumber + "{font-family:'" + value.font + "', sans-serif}";
                        var style_theme = document.createElement("style");
                        style_theme.className = "wps-adobefont-styles wps-font" + keyNumber + "-style";
                        style_theme.innerHTML = _baseFontCss;
                        self.window.document.head.appendChild(style_theme);
                    }
                });

            } else {



                if (self.corporateIdentity.disableGoogleFont) {
                    // var style_theme = document.createElement("style");
                    // style_theme.className = "wps-font-styles";
                    // style_theme.innerHTML = ".wps-font1,.wps-font2 {font-family: Verdana, sans-serif};";
                    // console.error(style_theme, style_theme, self)
                    // self.iframeHead.append(style_theme);
                } else {
                    let googleFonts = [];
                    //prepare fonts for google
                    if (_customFonts && _customFonts.google && _customFonts.google.length > 0) {
                        $.each(_customFonts.google, function (index, value) {
                            if (_customFonts.google[index] && _customFonts.google[index] != "") googleFonts[index] = _customFonts.google[index] + ":300,400,700";
                        });
                    } else {
                        googleFonts = ['Open+Sans:300,400,700'];
                    }

                    console.error("googleFonts", googleFonts);

                    if (googleFonts.length == 0) googleFonts = ['Open+Sans:300,400,700'];
                    var fonts = [];
                    if (self.window.WebFont && googleFonts.length != 0) self.window.WebFont.load({
                        google: {
                            families: googleFonts
                        },
                        context: self.window,
                        active: function () { },
                        fontloading: function (familyName, fvd) {
                            var _found = (fonts.indexOf(familyName) > -1);
                            if (!_found) fonts.push(familyName);
                        },
                        loading: function () { },
                        inactive: function () { },
                        fontactive: function (familyName, fvd) {
                            var _baseFontCss = "";
                            for (var i = 0; i < fonts.length; i++) {
                                _baseFontCss +=
                                    ".wps-font" + (i + 1) + "{font-family:'" + fonts[i] + "', sans-serif}";
                            }
                            var style_theme = this.context.document.createElement("style");
                            style_theme.className = "wps-font-styles";
                            style_theme.innerHTML = _baseFontCss;
                            //fix, because active is just started once on multiple font loadings
                            if ($(this.context.document).find(".wps-font-styles").length == 0) this.context.document.head.appendChild(style_theme);
                        },
                        fontinactive: function (familyName, fvd) { }
                    });
                }
            }

        }, 10);
    }

    KEditor.prototype.setCustomUploadedFont = function (fontsArray) {
        var self = this;
        //if a custom font was uploaded
        fontsArray.forEach(function (font) {
            var fontFaceRule = "@font-face { font-family: '" + font.fontFamily + "'; font-style: " + font.style + "; font-weight: " + font.fontWeight + "; font-display: " + font.fontDisplay + "; src: ";

            font.fontFiles.forEach(function (file, index) {
                fontFaceRule += "url('" + file.url + "') format('" + file.filetype.split('/')[1] + "')";
                if (index < font.fontFiles.length - 1) {
                    fontFaceRule += ", ";
                }
            });
            fontFaceRule += "; }";
            // Inject the @font-face rule into the page
            //console.log("fontFaceRule", fontFaceRule, self.iframeHead);
            $("<style>").prop("type", "text/css").prop("class", "customFont").html(fontFaceRule).appendTo(self.iframeHead);
        });
    }

    KEditor.prototype.setAdobeFonts = function (adobeFontsArray) {
        var self = this;
        // Load Adobe Fonts CSS files into the iframe
        adobeFontsArray.forEach(function (adobeFont) {
            if (adobeFont.url) {
                // Add link element for Adobe Fonts CSS
                var linkElement = document.createElement('link');
                linkElement.rel = 'stylesheet';
                linkElement.href = adobeFont.url;
                linkElement.className = 'adobeFont';
                self.iframeHead.append(linkElement);
                console.log('Adobe Fonts loaded:', adobeFont.url, 'Families:', adobeFont.families);
            }
        });
    }

    KEditor.prototype.setCustomTypo = function (_customTypo) {

        var self = this;


        setTimeout(function () {

            function changeVar(val) {
                return val.replace(/([A-Z])/g, "-$1").toLowerCase();
            }
            if (_customTypo) {
                var _customCss = "";
                $.each(_customTypo, function (indexInArray, tag) {
                    if (indexInArray == "p") indexInArray = ".pgs-article p,.pgs-article td,.pgs-article li"; // also add typo to list and table
                    else if (indexInArray == "customTypo1") indexInArray = ".pgs-article ." + indexInArray; // also add typo to list and table
                    else if (indexInArray == "customTypo2") indexInArray = ".pgs-article ." + indexInArray; // also add typo to list and table
                    else if (indexInArray == "customTypo3") indexInArray = ".pgs-article ." + indexInArray; // also add typo to list and table
                    else indexInArray = ".pgs-article " + indexInArray;
                    _customCss += indexInArray + "{font-family:" + tag.fontFamily + ";}";
                    _customCss += indexInArray + "{"
                    $.each(tag.screen, function (indexInArray, value) {
                        _customCss += changeVar(indexInArray) + ":" + value + ";";
                    });
                    _customCss += "} ";

                    _customCss += "@media (max-width: 992px) { " + indexInArray + "{"
                    $.each(tag.tablet, function (indexInArray, value) {
                        _customCss += changeVar(indexInArray) + ":" + value + ";";
                    });
                    _customCss += "} }";

                    _customCss += "@media (max-width: 576px) { " + indexInArray + "{"
                    $.each(tag.mobile, function (indexInArray, value) {
                        _customCss += changeVar(indexInArray) + ":" + value + ";";
                    });
                    _customCss += "} }";

                });
                self.iframeHead.append("<style class='_customTypo'>" + _customCss + "</style>")
            }
        }, 10);
    }

    KEditor.prototype.setCustomButtons = function (_customButton) {

        var self = this;


        setTimeout(function () {

            function changeVar(val) {
                return val.replace(/([A-Z])/g, "-$1").toLowerCase();
            }
            if (_customButton) {
                var _customCss = "";
                _customCss += ".btn{"
                $.each(_customButton.styleObject, function (indexInArray, value) {
                    _customCss += changeVar(indexInArray) + ":" + value + ";";
                });
                _customCss += "}"
                self.iframeHead.append("<style class='_customButton'>" + _customCss + "</style>")
            }
        }, 10);
    }



    // Usage example:

    // console.log(cleanedHtml);

    // Load snippets for parent document (when renderSidebarInParent is true)
    KEditor.prototype.loadSnippetsForParent = function () {
        var self = this;
        var options = self.options;
        var _snippetsURL = options.snippets;
        var snippetArr = _snippetsURL;
        var promises = [];
        var snippetResults = []; // Array to store {url, html} pairs

        flog('Loading snippets for parent document...');

        for (var i = 0; i < snippetArr.length; i++) {
            (function(snippetUrl) {
                var request = $.ajax({
                    type: 'get',
                    dataType: 'html',
                    url: snippetUrl + "?v=" + new Date().getTime(),
                    success: function (resp) {
                        // Extract base URL from snippet URL (remove filename)
                        var baseUrl = snippetUrl.substring(0, snippetUrl.lastIndexOf('/') + 1);
                        // Go up one directory from /snippets/ to get collection base
                        baseUrl = baseUrl.replace(/snippets\/$/, '');
                        snippetResults.push({
                            baseUrl: baseUrl,
                            html: resp
                        });
                    },
                    error: function (jqXHR) {
                        console.error('Error when getting snippets', jqXHR);
                    }
                });
                promises.push(request);
            })(snippetArr[i]);
        }

        $.when.apply(null, promises).done(function () {
            self.parseSnippetsForParent(snippetResults);
        });
    };

    // Parse snippets and send to parent document
    KEditor.prototype.parseSnippetsForParent = function (snippetResults) {
        var self = this;
        var options = self.options;
        var snippetData = {
            containers: [],
            components: [],
            categories: []
        };
        var categoriesMap = {};

        // Process each snippet source with its base URL
        snippetResults.forEach(function(result) {
            var baseUrl = result.baseUrl;
            var cleanedHtml = self.cleanHtmlSnippets(result.html);
            var $snippets = $('<div>' + cleanedHtml + '</div>');

            // Parse only top-level sections (exclude nested snippets inside containers)
            var $topLevelSections = $snippets.find('section[data-wps-type]').filter(function () {
                return $(this).parents('section[data-wps-type]').length === 0;
            });

            // Parse container snippets (layouts)
            $topLevelSections.filter('section[data-wps-type="container"]').each(function () {
                var $snippet = $(this);
                var preview = $snippet.attr('data-wps-preview');
                // Build full preview URL if preview is relative
                var fullPreview = preview && !preview.startsWith('http') ? baseUrl + preview : preview;

                snippetData.containers.push({
                    name: $snippet.attr('data-wps-name'),
                    title: $snippet.attr('title'),
                    title_en: $snippet.attr('data-wps-title_en'),
                    title_de: $snippet.attr('data-wps-title_de'),
                    preview: fullPreview,
                    type: 'container',
                    style: $snippet.attr('data-style'),
                    html: $snippet[0].outerHTML
                });
            });

            // Parse component snippets
            $topLevelSections.filter('section[data-wps-type^="component"]').each(function () {
                var $snippet = $(this);
                var categories = ($snippet.attr('data-wps-categories') || '').split(options.snippetsCategoriesSeparator);
                var preview = $snippet.attr('data-wps-preview');
                // Build full preview URL if preview is relative
                var fullPreview = preview && !preview.startsWith('http') ? baseUrl + preview : preview;

                // Track categories
                categories.forEach(function (cat) {
                    cat = cat.trim();
                    if (cat && !categoriesMap[cat]) {
                        categoriesMap[cat] = true;
                    }
                });

                snippetData.components.push({
                    name: $snippet.attr('data-wps-name'),
                    title: $snippet.attr('title'),
                    title_en: $snippet.attr('data-wps-title_en'),
                    title_de: $snippet.attr('data-wps-title_de'),
                    preview: fullPreview,
                    categories: categories,
                    tags: $snippet.attr('data-wps-tags'),
                    elementTags: $snippet.attr('data-wps-element-tags'),
                    type: $snippet.attr('data-wps-type'),
                    html: $snippet[0].outerHTML
                });
            });
        });

        // Get sorted categories
        snippetData.categories = self.beautifyCategories(Object.keys(categoriesMap));

        // Store snippets for later use
        self.snippetDataForParent = snippetData;

        // Notify parent that snippets are ready
        self.notifyParent('keditor-snippets-ready', snippetData);

        // Still need to call onReady callback
        if (typeof options.onReady === 'function') {
            options.onReady.call(self);
        }

        self.checkContentArea($(self.body).find(".keditor-content-area"));
    };

    KEditor.prototype.initSidebar = function () {
        flog('initSidebar');


        var self = this;

        // check priviledge for user
        if (!self.privileges.includes('can_edit_page') && !self.options.isSysAdmin) return;
        if ((!self.privileges.includes('can_edit_page_layouts') && !self.privileges.includes('can_edit_page_snippets')) && !self.options.isSysAdmin) return;

        var options = self.options;
        var body = self.body;

        // If sidebar should be rendered in parent, load snippets and notify parent
        if (options.renderSidebarInParent) {
            flog('Sidebar will be rendered in parent document');
            self.loadSnippetsForParent();
            return;
        }

        self.body.addClass('opened-keditor-sidebar');
        var sidebarContainer = self.body;

        if (options.sidebarContainer) {
            sidebarContainer = options.sidebarContainer;
        }

        flog('Render Keditor sidebar');

        sidebarContainer.append(
            //'<div id="keditor-toolbarContainer" class="keditor-toolbarContainer">' +
            //'</div>'+
            '<div id="keditor-sidebar" class="keditor-ui">' +
            '   <a id="keditor-sidebar-toggler" class="keditor-ui"><i class="fa fa-chevron-right"></i></a>' +
            '   <div id="keditor-snippets-list" class="keditor-ui"></div>' +
            '   <div id="keditor-snippets-content" class="keditor-ui" style="display: none"></div>' +
            /*'   <div id="keditor-setting-panel" class="keditor-ui">' +
            '       <div id="keditor-setting-header" class="keditor-ui">' +
            '           <span id="keditor-setting-title" class="keditor-ui"></span>' +
            '           <a  id="keditor-setting-closer" class="keditor-ui"><i class="fa fa-arrow-right"></i></a>' +
            '       </div>' +
            '       <div id="keditor-setting-body" class="keditor-ui">' +
            '           <div id="keditor-setting-forms" class="keditor-ui"></div>' +
            '       </div>' +
            '   </div>' +*/
            '</div>'
        );

        sidebarContainer.append(
            '<div id="keditor-sidebar-overlay"></div>' +
            '<div id="keditor-sidebar-settings-editor"></div>' +
            '<div id="keditor-sidebar-settings" class="keditor-ui">' +
            '   <a id="keditor-sidebar-toggler" class="keditor-ui"><i class="fa fa-chevron-right"></i></a>' +
            /*  '   <div id="keditor-snippets-list" class="keditor-ui"></div>' +
              '   <div id="keditor-snippets-content" class="keditor-ui" style="display: none"></div>' +*/
            '   <div id="keditor-setting-panel" class="keditor-ui">' +

            '       <div id="keditor-setting-body" class="keditor-ui">' +
            '           <div id="keditor-setting-forms" class="keditor-ui">' +
            '               <div id="keditor-setting-header" class="keditor-ui">' +
            '                   <span id="keditor-setting-title" class="keditor-ui"></span>' +
            '                   <a  id="keditor-setting-closer" class="keditor-ui"><i class="fa fa-close"></i></a>' +
            '                   <a  id="keditor-setting-maximizer" class="keditor-ui"><i class="fa fa-arrows-h"></i></a>' +
            '               </div>' +
            '           </div>' +
            '       </div>' +
            '   </div>' +
            '</div>'
        );




        self.initSidebarToggler();

        if (typeof options.snippetsUrl === 'string' && options.snippetsUrl.length > 0) {
            flog('Getting snippets form "' + options.snippetsUrl + '"...');


            //var _snippetsURL =  window.parent._AMS.defaults.templates.templates[window.parent._AMS.active.template].snippets,
            //  _rootTemplate= module.baseTemplate+"_ams/";

            //console.error("_snippetsURL", _snippetsURL)
            var _snippetsURL = self.options.snippets;

            var snippetArr = _snippetsURL//_snippetsURL.split(',');




            var promises = [],
                results = "";


            console.log("snippetArr", snippetArr);

            for (var i = 0; i < snippetArr.length; i++) {
                /* $.ajax returns a promise*/
                var request = $.ajax({
                    type: 'get',
                    dataType: 'html',
                    //url: snippet_href,
                    url: snippetArr[i] + "?v=" + new Date().getTime(),
                    success: function (resp) {


                        results += resp;
                    },
                    error: function (jqXHR) {
                        console.error('Error when getting snippets', jqXHR);
                    }
                })

                promises.push(request);
            }

            $.when.apply(null, promises).done(function () {

                buildSnippets(results)
            })



            function buildSnippets(results) {


                results = self.cleanHtmlSnippets(results);




                self.renderSnippets(results);

                self.initSnippets();
                self.initTabs();
                self.initTabsSwitcher();
                self.initSettingPanel();

                if (options.snippetsFilterEnabled) {
                    self.initSnippetsFilter('Container');
                    self.initSnippetsFilter('Component');
                }

                if (options.snippetsTooltipEnabled || options.tabTooltipEnabled) {
                    flog('Initialize Bootstrap tooltip plugin');
                    body.find('#keditor-snippets-list').find('[data-toggle="tooltip"]').tooltip();
                }

                if (typeof options.onReady === 'function') {
                    options.onReady.call(self);
                }

                self.checkContentArea($(self.body).find(".keditor-content-area"))

            }





            /*return $.ajax({
                type: 'get',
                dataType: 'html',
                //url: snippet_href,
                url: _rootTemplate+options.snippetsUrl+_snippetsURL+"?v="+window.parent._AMS.defaults.version,
                success: function(resp) {
                    flog('Success in getting snippets');
                    //console.log(resp)
                    var results = resp;

                    // load the collection snippet list
                    $.ajax({
                        type: 'get',
                        dataType: 'html',
                        //url: snippet_href,
                        url: _rootTemplate+"../../"+options.snippetsUrl+"snippets.html"+"?v="+window.parent._AMS.defaults.version,
                        success: function(resp) {
                                                        flog('Success in getting snippets');
                            var reference = resp;

                            // replace snippet with reference
                            results = self.referenceSnippets(results, reference);
                            loadGlobalSnippets();
                        },
                        error: function(e){
                            console.error("error", e)

                            loadGlobalSnippets();
                        }
                    })


                    function loadGlobalSnippets(){
                        // load the collection snippet list
                        $.ajax({
                            type: 'get',
                            dataType: 'html',
                            //url: snippet_href,
                            url: _rootTemplate+"../../../global_snippets/snippets.html"+"?v="+window.parent._AMS.defaults.version,
                            success: function(resp) {
                                                                flog('Success in getting snippets');
                                var reference = resp;

                                // replace snippet with reference
                                buildSnippets(self.referenceGlobalSnippets(results, reference));
                            },
                            error: function(e){
                                 console.error("error1", e)

                                buildSnippets(results);
                            }
                        })
                    }








                },
                error: function(jqXHR) {
                    flog('Error when getting snippets', jqXHR);
                }
            });*/
        } else {
            error('"snippetsUrl" must be not null!');
        }



    };

    KEditor.prototype.cleanHtmlSnippets = function (htmlString) {

        // Create a temporary div to parse the HTML
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;

        // Get the root section element
        var rootSection = tempDiv.querySelector('section');
        if (!rootSection) {
            return htmlString; // Return original if no section found
        }

        // 1. Delete elements with specific classes
        var classesToDelete = [
            'keditor-toolbar keditor-toolbar-component-settings',
            'keditor-toolbar keditor-toolbar-component',
            'component-btn btn-component-paddingTop',
            'component-btn btn-component-paddingBottom',
            'img-drag-handler'
        ];

        classesToDelete.forEach(function (className) {
            var elements = tempDiv.querySelectorAll('.' + className.replace(/\s+/g, '.'));
            for (var i = 0; i < elements.length; i++) {
                var element = elements[i];
                if (element && element.parentNode) {
                    element.parentNode.removeChild(element);
                }
            }
        });

        // 2. Remove classnames "fr-box", "fr-ltr" from all elements
        var elementsWithFrClasses = tempDiv.querySelectorAll('.fr-box, .fr-ltr');
        for (var i = 0; i < elementsWithFrClasses.length; i++) {
            var element = elementsWithFrClasses[i];
            element.classList.remove('fr-box', 'fr-ltr');
        }

        // 3. Replace ALL keditor-ui elements with their child content
        var keditorUiElements = tempDiv.querySelectorAll('.keditor-ui');

        for (var i = 0; i < keditorUiElements.length; i++) {
            var keditorUi = keditorUiElements[i];
            var keditorUiChild = keditorUi.firstElementChild;


            if (keditorUiChild) {
                var parent = keditorUi.parentNode;

                if (parent) {
                    // Move all child nodes from keditor-ui's child to the parent
                    while (keditorUiChild.firstChild) {
                        parent.insertBefore(keditorUiChild.firstChild, keditorUi);
                    }
                    // Remove the keditor-ui element
                    parent.removeChild(keditorUi);
                }
            }
        }

        // 4. Replace elements with classname "fr-wrapper" and their child "fr-element" with content inside "fr-element"
        var frWrapperElements = tempDiv.querySelectorAll('.fr-wrapper');
        for (var i = 0; i < frWrapperElements.length; i++) {
            var wrapper = frWrapperElements[i];
            var frElement = wrapper.querySelector('.fr-element');
            if (frElement) {
                var parent = wrapper.parentNode;
                if (parent) {
                    // Move all child nodes from fr-element to parent
                    while (frElement.firstChild) {
                        parent.insertBefore(frElement.firstChild, wrapper);
                    }
                    // Remove the wrapper
                    parent.removeChild(wrapper);
                }
            }
        }

        // 5. Remove classnames in root section that match data-wps-name attribute
        var dataWpsName = rootSection.getAttribute('data-wps-name');
        if (dataWpsName) {
            rootSection.classList.remove(dataWpsName);
        }

        // 6. Remove id attribute from root section
        rootSection.removeAttribute('id');
        $(rootSection).removeClass('keditor-component-sortable keditor-container keditor-sub-container keditor-initialized-container');

        // Return the cleaned HTML

        return tempDiv.innerHTML;
    }

    // replace snippet with reference
    KEditor.prototype.referenceSnippets = function (results, reference) {

        var self = this;
        var options = self.options;
        var body = self.body;

        // get dom with vanilla JS so it shows no error (scope has to be in iframe!)
        var _dom = self.window.document.createElement("div"),
            _dom_reference = self.window.document.createElement("div");
        _dom.innerHTML = results.trim();
        _dom_reference.innerHTML = reference.trim();

        // iterate snippets
        $(_dom).find('> section').each(function (i) {
            var snippet = $(this),
                _refAttr = snippet.attr('data-wps-snippet-reference');

            if (_refAttr) {
                // find reference and replace
                var _ref = $(_dom_reference).find("[data-wps-name='" + _refAttr + "']");
                snippet.replaceWith(_ref);
            }
        })

        return _dom.innerHTML;
    }


    // replace snippet with reference
    KEditor.prototype.referenceGlobalSnippets = function (results, reference) {




        var self = this;
        var options = self.options;
        var body = self.body;

        // get dom with vanilla JS so it shows no error (scope has to be in iframe!)
        var _dom = self.window.document.createElement("div"),
            _dom_reference = self.window.document.createElement("div");
        _dom.innerHTML = results.trim();
        _dom_reference.innerHTML = reference.trim();



        // iterate snippets
        $(_dom).find('[data-wps-global-snippet-reference]').each(function (i) {
            var snippet = $(this),
                _refAttr = snippet.attr('data-wps-global-snippet-reference');


            if (_refAttr) {
                // find reference and replace
                var _ref = $(_dom_reference).find("[data-wps-name='" + _refAttr + "']");
                snippet.replaceWith(_ref.html());
            }
        })

        return _dom.innerHTML;
    }




    KEditor.prototype.initSnippetsFilter = function (type) {
        flog('initSnippetsFilter for ' + type);

        var self = this;
        var options = self.options;
        var body = self.body;
        var lowerCaseType = type.toLowerCase();
        var categories = self['snippets' + type + 'Categories'];

        var filterHtml = '';

        var hideClass = '';



        if ((type == "Container" && !options.templateSearch) || (type == "Component" && !options.snippetSearch)) hideClass += "hideSearch ";
        if ((type == "Container" && !options.templateFilter) || (type == "Component" && !options.snippetFilter)) hideClass += "hideFilter ";


        filterHtml += '<div id="keditor-' + lowerCaseType + '-snippets-filter-wrapper" class="keditor-ui keditor-snippets-filter-wrapper">';
        filterHtml += '     <input type="text" id="keditor-' + lowerCaseType + '-snippets-search" class="keditor-ui keditor-snippets-search" value="" placeholder="' + self.labels.snippet_search + '..." />';

        if (!options.newSnippetList) {
            filterHtml += '     <select id="keditor-' + lowerCaseType + '-snippets-filter" class="keditor-ui keditor-snippets-filter">';
            filterHtml += '         <option value="" selected="selected">' + self.labels.all_snippets + '</option>';
            for (var i = 0; i < categories.length; i++) {
                filterHtml += '     <option value="' + categories[i] + '">' + categories[i] + '</option>';
            }
            filterHtml += '     </select>';
        }

        if (categories.length == 1) {
            body.find("#snippet-menu").addClass('snippetSearch');
        }

        filterHtml += '</div>';

        var tab = body.find('#keditor-' + lowerCaseType + '-snippets-tab');

        tab.addClass(hideClass)
        var snippets = tab.find('.keditor-snippet');
        tab.prepend(filterHtml);

        snippets.each(function () {
            var snippet = $(this);
            var categories = snippet.attr('data-wps-categories') || '';
            var filterCategories = categories.toLowerCase();
            categories = categories.split(options.snippetsCategoriesSeparator);
            filterCategories = filterCategories.split(options.snippetsCategoriesSeparator);

            snippet.data('categories', categories);
            snippet.data('categoriesFilter', filterCategories);
        });

        var txtSearch = tab.find('.keditor-snippets-search');
        var cbbFilter = tab.find('.keditor-snippets-filter');

        var doFilter = function () {
            var selectedCategory = (cbbFilter.val() || '').toLowerCase();
            var searchText = (txtSearch.val() || '').toLowerCase();

            flog('Do filter with selected category is "' + selectedCategory + '" and search text is "' + searchText + '"');
            //console.log('Do filter with selected category is "' + selectedCategory + '" and search text is "' + searchText + '"');

            if (selectedCategory || searchText) {
                flog('Filtering snippets');
                body.find("#snippet-menu").addClass('snippetSearch');
                snippets = tab.find('.keditor-snippet');

                snippets.each(function () {
                    var snippet = $(this);
                    var dataCategories = snippet.data('categoriesFilter');
                    if (!dataCategories) return;
                    var dataCategoriesString = dataCategories.join(';');
                    var error = 0;

                    if (selectedCategory) {
                        if ($.inArray(selectedCategory, dataCategories) === -1) {
                            error++;
                        }
                    }

                    if (searchText) {
                        var title = snippet.attr('title').toLowerCase();
                        var tags = snippet.attr('data-wps-tags').toLowerCase() || "";
                        var name = snippet.attr('data-wps-name').toLowerCase() || "";

                        if ((title.indexOf(searchText) === -1 && tags.indexOf(searchText) === -1 && name.indexOf(searchText) === -1) && dataCategoriesString.indexOf(searchText) === -1) {
                            error++;
                        }
                    }

                    snippet[error === 0 ? 'removeClass' : 'addClass']('not-matched');
                });


                //hide category where no snippets where found
                var _containers = tab.find('.snippetContainer');
                body.find("#sideMenu li").show();
                _containers.each(function () {
                    if ($(this).children('.keditor-snippet').length === $(this).children('.keditor-snippet.not-matched').length) {
                        body.find("#sideMenu li[data-menu-item='" + $(this).attr('id') + "']").hide();
                    }
                })
                // load Images
                body.find(".snippetContainer section:not(.not-matched) img:not([src])").each(function (index, el) {
                    $(el).attr("src", $(el).attr("data-src"))
                });



            } else {
                flog('Show all snippets');
                body.find("#snippet-menu").removeClass('snippetSearch');
                body.find("#sideMenu li").show();
                snippets.removeClass('not-matched');
            }
        };

        cbbFilter.on('change', function () {
            doFilter();
        });

        var timer;
        txtSearch.on('keydown', function () {
            clearTimeout(timer);
            timer = setTimeout(function () {
                doFilter();
            }, 200);
        });
    };

    KEditor.prototype.toggleSidebar = function (showSidebar) {
        flog('toggleSidebar', showSidebar);

        var self = this;
        var options = self.options;
        var body = self.body;
        var icon = body.find('#keditor-sidebar-toggler i');

        if (showSidebar) {
            body.addClass('opened-keditor-sidebar');
            icon.attr('class', 'fa fa-chevron-right')
        } else {
            body.removeClass('opened-keditor-sidebar');
            icon.attr('class', 'fa fa-chevron-left')
        }

        if (typeof options.onSidebarToggled === 'function') {
            options.onSidebarToggled.call(self, showSidebar);
        }
    };

    KEditor.prototype.initSidebarToggler = function () {
        flog('initSidebarToggler');

        var self = this;
        var body = self.body;

        body.find('#keditor-sidebar-toggler').on('click', function (e) {
            e.preventDefault();

            self.toggleSidebar(!body.hasClass('opened-keditor-sidebar'));
        });
    };

    KEditor.prototype.renderSnippets = function (resp) {



        var self = this;
        var options = self.options;
        var body = self.body;

        var snippetsContainerHtml = '';
        var snippetsComponentHtml = '';
        var snippetsContentHtml = $('<span></span>');
        var snippetWhitelist = (self.groupSettings.editorSettings && self.groupSettings.editorSettings.snippetWhitelist) ? self.groupSettings.editorSettings.snippetWhitelist : [];
        var snippetsTemplate = [];
        //console.log("self.groupSettings", self.groupSettings);
        self.snippetsContainerCategories = [];
        self.snippetsComponentCategories = [];
        self.elementSnippets = [];


        // change img and source tag so it not loads the files in the background
        var html = resp.trim().replace(/<img /g, "<img_wbmg ");
        html = html.replace(/<source/g, "<source_wbmg");
        html = html.replace(/poster="/g, 'poster_wbmg="');
        // html = html.replace(/<video/g,"<video_wbmg");
        var _dom = self.window.document.createElement("div");
        _dom.innerHTML = html;

        // var newHTMLDocument = document.implementation.createHTMLDocument('preview');
        // var _dom = newHTMLDocument.createElement('div').innerHTML = resp.trim();



        console.log("newHTMLDocument", _dom)

        $(_dom).find('section.section:not(.section .section)').each(function (i) {
            //$('<section />').html(resp).find('> section').each(function(i) {

            // var newHTMLDocument = document.implementation.createHTMLDocument('preview');
            // var snippet = newHTMLDocument.createElement('div').innerHTML = this.innerHTML;
            //snippet= $(snippet);



            var snippet = $(this);
            var version,
                name;
            var content = snippet.html().trim();

            var show = snippet.attr('data-show');






            var previewUrl = self.options.previewUrl + "1/" + snippet.attr('data-wps-preview');
            previewUrl = self.absolutePath(previewUrl); // change to absolute path so it works in iframe
            //previewUrl = "https://webmag.dev"+previewUrl;



            var type = snippet.attr('data-wps-type');
            var version = snippet.attr('data-wps-version');
            var name = snippet.attr('data-wps-name');
            var isContainer = (snippet.attr('data-wps-container')) ? "data-wps-container='true'" : "";
            var title = snippet.attr('data-wps-title_' + KEditor.language) || "";
            var style = snippet.attr('class');
            var style = snippet.attr('data-style');
            var tags = snippet.attr('data-wps-tags') || "";
            var _class = snippet.attr('class');
            var _classID = ""// snippet.attr('data-wps-name');

            // if there is a whitelist, delete snippet that are not in the whitelist
            if (snippetWhitelist.length > 0) {
                if ($.inArray(snippet.attr('data-wps-name'), snippetWhitelist) == -1) {
                    snippet.remove();
                    return;
                }
            }

            //console.log(_class)
            //console.log(_classID)

            var snippetHtml = '';
            var categories = snippet.attr('data-wps-categories') || '';

            //console.error("NEW CHANGE: make cloudimage from URL")
            //previewUrl = self.makeCloudImage(previewUrl,300,300);

            previewUrl = self.cloudImageFunction(previewUrl, { width: 325, height: 400 }, { width: 700, height: 700 }, 80, true);


            snippetHtml += '';
            snippetHtml += '<section class="keditor-ui keditor-snippet ' + _class + " " + _classID + '" data-wps-tags="' + tags + '" data-snippet="#keditor-snippet-' + i + '" data-style="' + style + '" ' + '" data-wps-version="' + version + '" ' + isContainer + ' " data-wps-type="' + type + '" ' + (options.snippetsTooltipEnabled ? 'data-toggle="tooltip" data-placement="' + options.snippetsTooltipPosition + '"' : '') + ' title="' + title + '" data-wps-categories="' + categories + '">';
            snippetHtml += '<span>' + title + '</span><img class="keditor-ui keditor-snippet-preview" src="' + previewUrl + '" />';
            snippetHtml += '</section>';

            categories = categories.split(options.snippetsCategoriesSeparator);

            if (type === 'container') {

                snippetsContainerHtml += snippetHtml;
                self.snippetsContainerCategories = self.snippetsContainerCategories.concat(categories);
            } else if (type.indexOf('component') !== -1) {

                var elementAttr = snippet.attr('data-wps-element');
                var isElement = elementAttr === 'true' || elementAttr === 'both';

                // Store element snippets separately (both "true" and "both")
                if (isElement) {
                    self.elementSnippets.push({
                        index: i,
                        snippet: snippet,
                        snippetHtml: snippetHtml,
                        content: content,
                        previewUrl: previewUrl,
                        title: snippet.attr('data-wps-title_' + KEditor.language) || "",
                        title_en: snippet.attr('data-wps-title_en') || "",
                        title_de: snippet.attr('data-wps-title_de') || "",
                        name: snippet.attr('data-wps-name') || "",
                        type: type,
                        version: version,
                        categories: categories,
                        style: style,
                        _class: _class,
                        tags: tags,
                        elementTags: self.parseElementTags(snippet.attr('data-wps-element-tags') || "", KEditor.language)
                    });
                }

                // dont show snippets with data-show="ignore" or data-wps-element="true"
                // but save them, so they can be updateable
                // Note: data-wps-element="both" should still show in normal list
                if (show != "ignore" && elementAttr !== 'true') {
                    snippetsComponentHtml += snippetHtml;
                    self.snippetsComponentCategories = self.snippetsComponentCategories.concat(categories);
                }

                version = snippet.attr('data-wps-version');
                name = snippet.attr('data-wps-name');
                style = snippet[0].classList;



                //compile snippet with handlebars and add it
                var compiledSnippet = self.compileHandlebars(snippet[0].innerHTML);





                // so no image errors in console (scope in iframe window)
                var _dom = self.window.document.createElement("div");
                _dom.innerHTML = compiledSnippet.trim();
                compiledSnippet = _dom.children[0];

                snippetsTemplate.push({
                    "name": name,
                    "version": version,
                    "element": compiledSnippet
                })
            }



            // add custom editor default classes from editorsettings
            var $html = $('<div />', { html: content });
            $.each($html.find("[data-wps-custom], [data-wps-custom2], [data-wps-custom3]"), function (index, el) {
                _custom = $(el).attr('data-wps-custom') || $(el).attr('data-wps-custom2') || $(el).attr('data-wps-custom3') || ""; // media, video, ...
                var _customEditorSettings = self.groupSettings?.editorSettings?.custom || false;
                if (_custom && _customEditorSettings) {
                    if (_customEditorSettings[_custom]) {
                        if (_customEditorSettings[_custom].default) {
                            $(el).addClass(_customEditorSettings[_custom].default)
                        }
                    }
                }
            })

            var dataAttributes = self.getDataAttributes(snippet, ['data-wps-preview', 'data-wps-type', 'data-wps-categories'], true);

            // console.log("dataAttributes", dataAttributes);

            // Save snippets that are not ignored, or are element snippets (both "true" and "both")
            var elementAttr = snippet.attr('data-wps-element');
            if (show != "ignore" || elementAttr === 'true' || elementAttr === 'both') {
                var $section = $('<script />'); // Replace with your div's ID or another selector

                // Iterate over the object and add each attribute to the div
                $.each(dataAttributes, function (key, value) {
                    $section.attr(key, value);
                });
                $section.addClass(style);
                // add data-wps-type
                $section.attr('type', "text/html");
                $section.attr('id', 'keditor-snippet-' + i);
                // add html
                $section.html($html[0].outerHTML);
                snippetsContentHtml.append($section);
                //console.log($html[0].outerHTML);
                //snippetsContentHtml += $section;

                //snippetsContentHtml += '<script class="'+style+'" id="keditor-snippet-' + i + '" type="text/html" ' + dataAttributes.join(' ') + '>' + $html[0].outerHTML + '</script>';
            }




        });


        if (self.options.newSnippetList) {
            snippetsComponentHtml2 = "";

            snippetsComponentHtml2 +=
                '<div id="snippet-menu" class="SFG hidden">' +
                '<div id="sideMenu"  class="ui-droppable">' +
                '<ul class="sideMenu" data-simplebar >';

            var categories = self.beautifyCategories(self.snippetsComponentCategories);
            var _icon = "",
                _style = "";
            for (var i = 0; i < categories.length; i++) {


                var result = $.grep(self.options.sortingArray, function (e) { return e.value == categories[i]; });

                if (result.length === 1) {
                    // property found, access the foo property using result[0].foo
                    _icon = result[0].icon;
                    if (result[0].style) {
                        _style = "border-primary border-1";
                    } else {
                        _style = "";
                    }
                }
                var labelCategory = categories[i].toLowerCase().replace(/\s/g, '_');
                labelCategory = (self.labels.categories[labelCategory]) ? self.labels.categories[labelCategory] : categories[i];

                //self.labels[

                snippetsComponentHtml2 += '<li data-menu-item="' + categories[i] + '" class="' + _style + '"><i class="fa ' + _icon + '" aria-hidden="true"></i><span>' + labelCategory + '</span></li>';
            }
            var _snippets = $(_dom).find('section.section:not(.section .section)');
            snippetsComponentHtml2 +=
                '</ul>' +
                '<div id="subMenu" class="generator-nano has-scrollbar hidden hide">' +
                '<div data-simplebar >';
            for (var i = 0; i < categories.length; i++) {
                snippetsComponentHtml2 += '<ul class="" data-id="' + categories[i] + '" id="' + categories[i] + '">';

                snippetsComponentHtml2 += '</ul>';
            }


            snippetsComponentHtml2 += '<div class="snippetContainer">';
            _snippets.each(function (a) {
                var snippet = $(this);

                var elementAttr = snippet.attr('data-wps-element');
                // Skip snippets with data-wps-element="true" (but include "both")
                if (elementAttr === 'true') {
                    return;
                }

                var _cat = snippet.attr('data-wps-categories') || '';
                _cat = _cat.split(options.snippetsCategoriesSeparator);
                var _found = (_cat.indexOf(categories[i]) > -1);
                if (_found || true) {
                    var version,
                        name;
                    var content = snippet.html().trim();
                    var show = snippet.attr('data-show') || "";
                    var version = snippet.attr('data-wps-version') || "";
                    var type = snippet.attr('data-wps-type') || "";
                    var previewUrl = self.options.previewUrl + "1/" + snippet.attr('data-wps-preview');
                    previewUrl = self.absolutePath(previewUrl); // change to absolute path so it works in iframe
                    //previewUrl = "https://webmag.dev"+previewUrl;
                    //console.error("NEW CHANGE: make cloudimage from URL")
                    previewUrl = self.cloudImageFunction(previewUrl, { width: 325, height: 400 }, { width: 700, height: 700 }, 80, true);
                    var title = snippet.attr('data-wps-title_' + KEditor.language) || "";
                    var name = (snippet.attr('data-wps-name')) ? snippet.attr('data-wps-name').split('-')[1] : "";
                    var isContainer = (snippet.attr('data-wps-container')) ? "data-wps-container='true'" : "";
                    var _categories = snippet.attr('data-wps-categories') || '';
                    var style = snippet.attr('data-style') || "";
                    var _class = snippet.attr('class') || "";
                    var tags = snippet.attr('data-wps-tags') || "";
                    snippetsComponentHtml2 += '<section class="keditor-ui keditor-snippet ' + _class + '" data-wps-name="' + name + '" data-wps-tags="' + tags + '" data-snippet="#keditor-snippet-' + a + '" data-style="' + style + '" ' + '" data-wps-version="' + version + '" ' + isContainer + ' " data-wps-type="' + type + '" ' + (options.snippetsTooltipEnabled ? 'data-toggle="tooltip" data-placement="' + options.snippetsTooltipPosition + '"' : '') + ' title="' + title + '" data-wps-categories="' + _categories + '">';
                    snippetsComponentHtml2 += '<img class="keditor-ui keditor-snippet-preview" data-src="' + previewUrl + '" /><span class="snippet_title">' + title + '</span><span class="snippet_name">(' + name + ')</span>';
                    snippetsComponentHtml2 += '</section>';
                    /*snippetsComponentHtml2 +=
                        '<li>'+
                            '<span>'+title+'</span>'+
                            '<img  src="'+previewUrl+'">'+
                        '</li>';*/
                }

            })
            snippetsComponentHtml2 += '</div>';




            snippetsComponentHtml2 +=
                '</div>' +
                '</div>' +
                '</div>';
        }









        self.snippetsTemplate = snippetsTemplate;

        self.snippetsContainerCategories = self.beautifyCategories(self.snippetsContainerCategories);
        self.snippetsComponentCategories = self.beautifyCategories(self.snippetsComponentCategories);

        /**/

        console.log("self", self);

        if (self.options.newSnippetList) {

            body.find('#keditor-snippets-list').html("").addClass('loaded-snippets');



            var _content = '<ul id="keditor-snippets-type-switcher" class="keditor-ui keditor-tabs">',
                _active = "";

            if ((self.privileges.includes('can_edit_page_layouts') && !self.privileges.includes('can_edit_page_snippets'))) _active = "active";

            if (self.privileges.includes('can_edit_page_snippets') || self.options.isSysAdmin) {
                _content += '    <li class="keditor-ui keditor-tab active keditor-component-snippets-tab"><a class="keditor-ui" href="#keditor-component-snippets-tab"' + (options.tabTooltipEnabled ? 'data-toggle="tooltip" data-placement="bottom"' : '') + ' title="' + self.labels.snippets_tab + '">' + self.labels.snippets_tab + '</a></li>';
            }
            var _hideLayout = (self.groupSettings.editorSettings && self.groupSettings.editorSettings.hideLayout) ? self.groupSettings.editorSettings.hideLayout : false;
            if ((self.privileges.includes('can_edit_page_layouts') && !_hideLayout) || self.options.isSysAdmin) {
                _content += '    <li class="keditor-ui keditor-tab ' + _active + ' keditor-container-snippets-tab"><a class="keditor-ui" href="#keditor-container-snippets-tab"' + (options.tabTooltipEnabled ? 'data-toggle="tooltip" data-placement="bottom"' : '') + ' title="' + self.labels.layout_tab + '">' + self.labels.layout_tab + '</a></li>';
            }
            _content += '</ul><div id="keditor-snippets-container" class="keditor-ui keditor-tabs-content">';

            if (self.privileges.includes('can_edit_page_layouts') || self.options.isSysAdmin) {
                _content += '   <div class="keditor-ui keditor-tab-content ' + _active + ' " id="keditor-container-snippets-tab"><div class="keditor-ui keditor-tab-content-inner" data-simplebar >' + snippetsContainerHtml + '</div></div>';
            }

            if (self.privileges.includes('can_edit_page_snippets') || self.options.isSysAdmin) {
                _content += '   <div class="keditor-ui keditor-tab-content active keditor-component-snippets-tab" id="keditor-component-snippets-tab"><div class="keditor-ui keditor-tab-content-inner">' + snippetsComponentHtml2 + '</div></div>';

            }


            _content += '</div>';


            body.find('#keditor-snippets-list').append(_content);



            self.addSnippetListerners()
        }








        if (snippetsContainerHtml == '') {
            console.warn("delete1")
            self.options.snippetsContainer = false;
            body.find('#keditor-container-snippets-tab, .keditor-container-snippets-tab').remove()
            body.find('#keditor-component-snippets-tab, .keditor-component-snippets-tab').addClass('active');
        } else {
            self.options.snippetsContainer = true;
        }

        //layout
        if (snippetsComponentHtml == '') {
            console.warn("delete2")
            self.options.snippetsComponent = false;
            body.find('#keditor-component-snippets-tab, .keditor-component-snippets-tab').remove()
            body.find('#keditor-container-snippets-tab, .keditor-container-snippets-tab').addClass('active');
        } else {
            self.options.snippetsComponent = true;
        }

        if (snippetsContainerHtml == '' && snippetsComponentHtml == '') {
            self.body.removeClass("opened-keditor-sidebar");
            self.body.addClass("hide-keditor-sidebar");
        } else {
            self.body.removeClass("hide-keditor-sidebar");
        }

        body.find('#keditor-snippets-content').html(snippetsContentHtml);

        body.find('[data-simplebar]').each(function (index, element) {
            new SimpleBar(element);
        })
    };


    KEditor.prototype.addSnippetListerners = function (categories) {
        var _timeout1;
        var _timeout2;
        var self = this;
        var body = self.body;

        body.find("#sideMenu .sideMenu li").mouseenter(function () {
            var that = this;
            clearTimeout(_timeout1);
            _timeout1 = setTimeout(function () {
                //your code here
                body.find("#subMenu").addClass('hide');
                body.find("#sideMenu .sideMenu li").removeClass("selected");

                var _attr = $(that).attr('data-menu-item');



                _timeout2 = setTimeout(function () {
                    doFilter(_attr);
                    body.find("#subMenu ul").removeClass('visible')
                    body.find(that).addClass('selected');
                    body.find("#subMenu").removeClass('hidden');
                    body.find("#subMenu").removeClass('hide');
                    body.find("#subMenu ul[data-id='" + _attr + "']").addClass('visible');

                    // load Images
                    body.find(".snippetContainer section:not(.not-matched) img:not([src])").each(function (index, el) {
                        $(el).attr("src", $(el).attr("data-src"))
                    });

                }, 150);

            }, 150);

        });
        body.find("#sideMenu ").mouseleave(function () {
            //your code here
            clearTimeout(_timeout1);
            clearTimeout(_timeout2);
            body.find("#sideMenu .sideMenu li").removeClass("selected");
            body.find("#subMenu ul").removeClass('visible')
            body.find("#subMenu").addClass('hide')

            setTimeout(function () {
                body.find("#subMenu").addClass('hidden')
            }, 300);
        });

        body.find("#subMenu").mouseenter(function () {
            //your code here
            clearTimeout(_timeout1);
            clearTimeout(_timeout2);

        });


        // filter snippets
        var doFilter = function (searchText) {

            var searchText = searchText.toLowerCase();

            //console.log('Do filter with search text is "' + searchText + '"');

            if (searchText) {
                snippets = body.find(".snippetContainer .keditor-snippet");



                snippets.each(function () {
                    var snippet = $(this);
                    var dataCategories = snippet.data('categoriesFilter');
                    if (!dataCategories) return;
                    var dataCategoriesString = dataCategories.join(';');
                    var error = 0;


                    if (searchText) {
                        var title = snippet.attr('title').toLowerCase();
                        var tags = snippet.attr('data-wps-tags').toLowerCase() || "";
                        var name = snippet.attr('data-wps-name').toLowerCase() || "";
                        if (dataCategoriesString.indexOf(searchText) === -1) {
                            error++;
                        }

                    }

                    snippet[error === 0 ? 'removeClass' : 'addClass']('not-matched');
                });

            } else {
                flog('Show all snippets');
                snippets.removeClass('not-matched');
            }
        };
    }






    KEditor.prototype.beautifyCategories = function (categories) {
        var newArray = [];
        for (var i = 0; i < categories.length; i++) {
            var category = categories[i] || '';

            if (category !== '' && $.inArray(category, newArray) === -1) {
                newArray.push(category);
            }
        }



        var sortingArray = ['Footers', 'Others', '', 'Navigations & Indexes', 'Modals', 'Forms', 'Sharing', 'Team & Signatures', 'Tables & Charts', 'Quotes & Testimonials', 'Call to actions', 'Features & Lists', 'Cards & Boxes', 'Videos', 'Images & Galleries', 'Titles & Texts', 'Headers', 'Covers', 'Layouts', 'All', 'Webmag', 'Haufe Akademie', 'Telefonica', 'Tennet', 'Universal', 'Fokus Layout', 'CNHI', 'CNHI - Case IH', 'CNHI - New Holland', 'CNHI - Steyr'];


        sortingArray = this.options.sortingArray;

        var index_a,
            index_b;

        newArray.sort(function (a, b) {

            index_a = sortingArray.map(function (x) { return x.value }).indexOf(a);
            index_b = sortingArray.map(function (x) { return x.value }).indexOf(b);


            return index_a - index_b;


            //return sortingArray.indexOf(a) - sortingArray.indexOf(b) ;
        });



        return newArray.reverse();
    };

    KEditor.prototype.getConnectedForContainerSnippets = function () {
        var self = this;
        var options = self.options;
        var body = self.body;

        var selector = '.keditor-content-area';
        if (options.nestedContainerEnabled) {
            selector += ',.keditor-container-content:not(.keditor-sub-container-content)';
        }




        return body.find(selector);
    };

    KEditor.prototype.initSnippets = function () {



        var self = this;
        var options = self.options;
        var body = self.body;
        var snippetsList = self.body.find('#keditor-snippets-list');
        var containerSnippets = self.containerSnippets = snippetsList.find('.keditor-snippet[data-wps-type=container]');
        var componentSnippets = self.componentSnippets = snippetsList.find('.keditor-snippet[data-wps-type^=component]');






        self.getContent().then(function (content) {
            // so no image errors in console (scope in iframe window)
            var _dom = self.window.document.createElement("div");
            _dom.innerHTML = content.trim();


            var _style = $(_dom).find("div[class^='mgz_'],div[class*=' mgz_']").addBack("div[class^='mgz_'],div[class*=' mgz_']"),
                _styleClass = "";

            containerSnippets.off('click').on('click', function (e) {

                // console.error("Style change")

                if ($(this).hasClass("active")) return;


                $(this.parentNode).find("section").removeClass("active");
                $(this).addClass("active")

                var style = $(this).attr("data-style");


                self.setContentTemplate(style);

                //self.save();
            })




            if (self.options.newSnippetList) {
                var _snippetContainers = snippetsList.find(".snippetContainer")

                _snippetContainers.each(function (index, el) {
                    var _scrollable = ($(self.iframeBody).find(".scrollable").length > 0) ? $(self.iframeBody).find(".scrollable")[0] : true;


                    //SnippetList sortable

                    var _connectWith = $(self.iframeBody).find("#sortableSnippets");

                    //console.log("_connectWith", _connectWith)

                    /* $(el).sortable({
                        appendTo: self.iframeBody,
                        placeholder: "drag_ghost",
                        connectWith: "#sortableSnippets",
                        helper: "clone",
                        items: 'section.keditor-snippet',
                        scroll: true,
                        //axis: "y",
                        //scrollSensitivity: 300,
                        //scrollSpeed: 50,
                        forcePlaceholderSize:true,
                        forceHelperSize:true,
                        sort: function(event, ui) {

                        }
                    });*/

                    var sort = Sortable.create(el, {
                        group: {
                            name: 'componentSnippets',
                            revertClone: true,
                            pull: 'clone'
                        },
                        ghostClass: 'drag_chosen',
                        sort: false,
                        //forceFallback: true,
                        scroll: _scrollable, // or HTMLElement
                        scrollSensitivity: 300, // px, how near the mouse must be to an edge to start scrolling.
                        scrollSpeed: 50, // px
                        ////forceFallback: true,
                        //delay: 100,
                        //animation: 150,
                        animation: 0,
                        //handle: '.btn-component-reposition', // Restricts sort start click/touch to the specified element
                        draggable: 'section.keditor-snippet', // Specifies which items inside the element should be sortable
                        // Called by any change to the list (add / update / remove)
                        onSort: function (evt) {
                            // same properties as onEnd
                            evt.preventDefault();
                            evt.stopPropagation();
                            //fix for insert dragged text on dropping hover other snippet
                            setTimeout(function () {
                                body.find(".fr-element").attr('contenteditable', 'true').css('pointerEvents', 'all');
                            }, 200);
                            var itemEl = evt.item;

                        },
                        // Element is dropped into the list from another list (receive)
                        onAdd: function (evt) {
                            evt.preventDefault();
                            evt.stopPropagation();


                        },
                        onMove: function (evt) {
                            evt.preventDefault();
                            evt.stopPropagation();
                            // console.log("onMove2", evt)
                            // dont drop container in container
                            if ($(evt.dragged).attr("data-wps-container") == "true" && $(evt.to).hasClass("keditor-sub-container-content")) return false;
                        },
                        // Element dragging started
                        onStart: function (evt) {
                            evt.preventDefault();
                            evt.stopPropagation();

                            $("#subMenu").addClass('hide')

                            setTimeout(function () {
                                $("#subMenu").addClass('hidden')
                            }, 300);
                            //console.log("start2", evt)

                            body.find(".fr-element").attr('contenteditable', 'false').css('pointerEvents', 'none');
                            //body.find("[data-wps-edit]").attr("contentEditable", false) //set to false, or it will try to insert it as plain text in hover snippet
                            body.find('[contenteditable]').blur();
                            //body.find("[data-wps-edit]").remove();
                            body.find('.showed-keditor-toolbar').removeClass('showed-keditor-toolbar');
                            body.addClass('highlighted-container-content');
                        },
                        // Element dragging ended
                        onEnd: function (evt) {
                            evt.preventDefault();
                            evt.stopPropagation();
                            //fix for insert dragged text on dropping hover other snippet
                            setTimeout(function () {
                                body.find(".fr-element").attr('contenteditable', 'true').css('pointerEvents', 'all');
                            }, 200);

                            body.removeClass('highlighted-container-content');

                            //self.save();
                        },
                    });


                });
            } else {
                //needed?
                if (componentSnippets[0]) {

                    return;
                    //console.log("componentSnippets",componentSnippets);



                    var _scrollable = ($(self.iframeBody).find(".scrollable").length > 0) ? $(self.iframeBody).find(".scrollable")[0] : true;
                    var _connectWith = $(self.iframeBody).find("#sortableSnippets");

                    console.log("_connectWith", _connectWith)

                    /*$(componentSnippets[0]).sortable({
                        appendTo: "parent",
                        placeholder: "drag_ghost",
                        connectWith: _connectWith[0],
                        helper: "clone",
                        items: 'section.keditor-snippet',
                        scroll: true,
                        axis: "y",
                        scrollSensitivity: 300,
                        scrollSpeed: 50,
                        forcePlaceholderSize:true,
                        forceHelperSize:true,
                        sort: function(event, ui) {

                        }
                    });*/

                    //not used?

                    console.log("componentSnippets[0].parentNode", componentSnippets[0].parentNode)

                    var sort = Sortable.create(componentSnippets[0].parentNode, {
                        group: {
                            name: 'componentSnippets',
                            revertClone: true,
                            pull: 'clone'
                        },
                        ghostClass: 'drag_chosen',
                        sort: false,
                        //forceFallback: true,
                        scroll: _scrollable, // or HTMLElement
                        scrollSensitivity: 300, // px, how near the mouse must be to an edge to start scrolling.
                        scrollSpeed: 50, // px
                        //delay: 100,
                        animation: 150,
                        //handle: '.btn-component-reposition', // Restricts sort start click/touch to the specified element
                        draggable: 'section.keditor-snippet', // Specifies which items inside the element should be sortable
                        // Called by any change to the list (add / update / remove)
                        onSort: function (evt) {
                            // same properties as onEnd
                            evt.preventDefault();
                            evt.stopPropagation();
                            //fix for insert dragged text on dropping hover other snippet
                            setTimeout(function () {
                                body.find(".fr-element").attr('contenteditable', 'true').css('pointerEvents', 'all');
                            }, 200);
                            var itemEl = evt.item;

                        },
                        // Element is dropped into the list from another list (receive)
                        onAdd: function (evt) {
                            evt.preventDefault();
                            evt.stopPropagation();


                        },
                        onMove: function (evt) {
                            evt.preventDefault();
                            evt.stopPropagation();
                            // console.log("onMove2", evt)

                            //console.log(evt.to)


                        },
                        // Element dragging started
                        onStart: function (evt) {
                            evt.preventDefault();
                            evt.stopPropagation();
                            //console.log("start2", evt)

                            body.find(".fr-element").attr('contenteditable', 'false').css('pointerEvents', 'none');
                            //body.find("[data-wps-edit]").attr("contentEditable", false) //set to false, or it will try to insert it as plain text in hover snippet
                            body.find('[contenteditable]').blur();
                            //body.find("[data-wps-edit]").remove();
                            body.find('.showed-keditor-toolbar').removeClass('showed-keditor-toolbar');
                            body.addClass('highlighted-container-content');
                        },
                        // Element dragging ended
                        onEnd: function (evt) {
                            evt.preventDefault();
                            evt.stopPropagation();
                            //fix for insert dragged text on dropping hover other snippet
                            setTimeout(function () {
                                body.find(".fr-element").attr('contenteditable', 'true').css('pointerEvents', 'all');
                            }, 200);

                            body.removeClass('highlighted-container-content');
                        },
                    });






                }
            }


            // set first template style on load
            if (self.options.snippetsContainer && _style[0]) {
                for (var i = 0; i < _style[0].classList.length; i++) {
                    if (_style[0].classList[i].indexOf('mgz_') == 0) {
                        if (_styleClass != "") {
                            _styleClass += " " + _style[0].classList[i];
                        } else {
                            _styleClass += _style[0].classList[i];
                        }
                    }
                }

                //set active thumbnail
                containerSnippets.find("section").addBack("section").removeClass("active");
                containerSnippets.find("section[data-style='" + _styleClass + "']").addBack("section[data-style='" + _styleClass + "']").addClass("active");
            }
        })


    };

    KEditor.prototype.setContentTemplate = function (style) {
        var self = this;
        self.getContent().then(function (content) {
            content = self.options.template.update(content, style, self);
            // add section wrapper
            content = $(content).wrap("<section></section>").parent();
            self.setContent(content[0].outerHTML);
            if (typeof self.options.template.afterUpdate == 'function') self.options.template.afterUpdate(self);
        })
    }

    KEditor.prototype.initTabs = function () {
        flog('initTabs');

        var self = this;
        var body = self.body;
        var options = self.options;
        var switcherWrapper = body.find('#keditor-snippets-type-switcher');
        var tabPaneWrapper = body.find('#keditor-snippets-container');

        if (options.extraTabs && $.isPlainObject(options.extraTabs)) {
            flog('Add extra tabs', options.extraTabs);

            for (var tabName in options.extraTabs) {
                var tabData = options.extraTabs[tabName];

                switcherWrapper.append('<li class="keditor-ui keditor-tab"><a class="keditor-ui" href="#keditor-extra-tab-' + tabName + '"' + (options.tabTooltipEnabled ? 'data-toggle="tooltip" data-placement="bottom" title="' + tabData.title + '"' : '') + '>' + tabData.text + '</a></li>');
                tabPaneWrapper.append('<div class="keditor-ui keditor-tab-content" id="keditor-extra-tab-' + tabName + '"><div class="keditor-tab-content-inner">' + tabData.content + '</div></div>');
            }
        }

        // self.initNiceScroll(tabPaneWrapper.find('.keditor-tab-content-inner'));
    };

    KEditor.prototype.initTabsSwitcher = function () {
        flog('initTabsSwitcher');

        var self = this;
        var body = self.body;
        var switcherLis = body.find('#keditor-snippets-type-switcher li');
        var tabContent = body.find('#keditor-snippets-container .keditor-tab-content');

        switcherLis.find('a').on('click', function (e) {
            e.preventDefault();

            var a = $(this);
            var li = a.parent();
            var href = a.attr('href');

            if (!li.hasClass('active')) {
                var activatedLi = switcherLis.filter('.active');
                var activatedPane = tabContent.filter('.active');
                var targetDiv = body.find(href);

                activatedLi.removeClass('active');
                activatedPane.removeClass('active');

                li.addClass('active');
                targetDiv.addClass('active');

                if ($.fn.niceScroll && self.options.niceScrollEnabled) {
                    activatedPane.getNiceScroll().hide();

                    var targetNiceScroll = targetDiv.getNiceScroll();
                    targetNiceScroll.show();
                    targetNiceScroll.resize();
                }
            }
        });
    };

    KEditor.prototype.initSettingPanel = function () {
        flog('initSettingPanel');

        var self = this;
        var options = self.options;
        var body = self.body;

        body.find('#keditor-setting-closer').on('click', function (e) {
            e.preventDefault();
            //delete iconpicker modal
            //console.log(body.find('.iconpicker-popover'));
            body.find('.iconpicker-popover').remove();
            self.hideSettingPanel();
        });

        body.find('#keditor-setting-maximizer').on('click', function (e) {
            e.preventDefault();
            self.sizeSettingPanel();
        });

        // click on sidebar overlay closes settings sidebar
        body.find('#keditor-sidebar-overlay').on('click', function (e) {

            body.find('#keditor-setting-closer').trigger('click');

        });

        var settingForms = body.find('#keditor-setting-forms');
        self.initNiceScroll(settingForms);
        settingForms.on('submit', 'form', function (e) {
            e.preventDefault();
            return false;
        });

        if (options.containerSettingEnabled === true) {
            // if (typeof options.containerSettingInitFunction === 'function') {

            //     var form = $('<div id="keditor-container-setting" class="keditor-ui keditor-setting-form clearfix"></div>');
            //     settingForms.append(form);

            //     flog('Initialize container setting panel');
            //     options.containerSettingInitFunction.call(self, form, self);
            // } else {
            //     error('"containerSettingInitFunction" is not function!');
            // }
        }
    };

    KEditor.prototype.setSettingContainer = function (container) {
        flog('setSettingContainer', container);

        var self = this;
        var body = self.body;

        if (container) {
            var idSettingContainer = container.attr('id');
            body.attr('data-setting-container', idSettingContainer);
        } else {
            body.removeAttr('data-setting-container');
        }
    };

    KEditor.prototype.getSettingContainer = function () {
        flog('getSettingContainer');

        var self = this;
        var body = self.body;
        var idSettingContainer = body.attr('data-setting-container');

        return body.find('#' + idSettingContainer);
    };

    KEditor.prototype.setSettingComponent = function (component) {
        flog('setSettingComponent', component);

        var self = this;
        var body = self.body;

        if (component) {
            var idSettingComponent = component.attr('id');
            body.attr('data-setting-component', idSettingComponent);
        } else {
            body.removeAttr('data-setting-component');
        }
    };

    KEditor.prototype.getSettingComponent = function () {
        flog('getSettingComponent');

        var self = this;
        var body = self.body;
        var idSettingComponent = body.attr('data-setting-component');

        return body.find('#' + idSettingComponent);
    };

    KEditor.prototype.showSettingPanel = function (target, event) {
        //console.log('showSettingPanel', target);
        // console.log("event",event)



        var self = this;
        var options = self.options;
        var body = self.body;
        var isComponent = target.is('.keditor-component');

        // If sidebar is rendered in parent, notify parent to open settings there
        if (options.renderSidebarInParent) {
            var editableData = self.collectEditableData(target);
            var componentType = self.getComponentType(target);
            // Components that lost their snippet wrapper attributes (no data-wps-type)
            // resolve to "blank" although their content still carries editable
            // data-wps-edit elements; treat them as "text" so settings can be built.
            if (componentType == 'blank' && target.find('[data-wps-edit]').length > 0) {
                componentType = 'text';
            }
            var settingName = target.attr("data-wps-name") ? target.attr("data-wps-name").split('-')[1] : "";

            self.notifyParent('keditor-open-settings', {
                componentId: target.attr('id'),
                componentName: target.attr('data-wps-name'),
                componentType: componentType,
                settingName: settingName,
                title: target.attr("data-wps-title_de") || target.attr("data-wps-title_en") || settingName,
                isComponent: isComponent,
                editableData: editableData,
                componentHtml: target[0].outerHTML
            });

            // Store reference to current component for updates
            self.setSettingComponent(target);
            return;
        }

        self.clickedSnippetTop = target.offset().top;

        var activeForm = body.find('#keditor-setting-forms').children('.active');
        activeForm.removeClass('active');

        if (isComponent) {
            self.setSettingComponent(target);
            self.setSettingContainer(null);

            var componentType = self.getComponentType(target);
            // Same fallback as above: degraded components without data-wps-type but
            // with editable content must use the "text" component data, otherwise
            // no setting form can be initialized.
            if (componentType == 'blank' && target.find('[data-wps-edit]').length > 0) {
                componentType = 'text';
            }
            var componentData;
            if (componentType != "blank") {
                componentData = KEditor.components["text"];
            } else {
                componentData = KEditor.components[componentType];
            }
            //componentType = "component-text";
            //var componentData = KEditor.components[componentType];

            var settingTitle = target.attr("data-wps-title_" + "de") || "";
            var settingName = target.attr("data-wps-name") ? target.attr("data-wps-name").split('-')[1] : "";
            body.find('#keditor-setting-title').html(settingTitle + " <span class='snippet_name'>(" + settingName + ")</span>");

            var settingForms = body.find('#keditor-setting-forms');
            var settingForm = body.find('#keditor-setting-' + settingName);

            if (settingForm.length === 0 || true) {

                if (typeof componentData.initSettingForm === 'function') {
                    settingForm = $('<div id="keditor-setting-' + settingName + '" data-wps-type="' + componentType + '" class="keditor-ui keditor-setting-form clearfix active"></div>');
                    var loadingText = $('<span />').html('Loading...');
                    settingForms.append(settingForm);
                    settingForm.append(loadingText);

                    flog('Initializing setting form for component type "' + componentType + '"');

                    var initFunction = componentData.initSettingForm.call(componentData, target, settingForm, self); // added target
                    $.when(initFunction).done(function () {
                        flog('Initialized setting form for component type "' + componentType + '"');

                        setTimeout(function () {
                            loadingText.remove();

                            if (typeof componentData.showSettingForm === 'function') {
                                flog('Show setting form of component type "' + componentType + '"');
                                componentData.showSettingForm.call(componentData, settingForm, target, self);
                            } else {
                                flog('"showSettingForm" function of component type "' + componentType + '" does not exist');
                            }
                        }, 100);
                    });
                } else {
                    flog('"initSettingForm" function of component type "' + componentType + '" does not exist');
                }
            } else {
                if (typeof componentData.showSettingForm === 'function') {
                    flog('Show setting form of component type "' + componentType + '"');
                    componentData.showSettingForm.call(componentData, settingForm, target, self);
                } else {
                    flog('"showSettingForm" function of component type "' + componentType + '" does not exist');
                }
                settingForm.addClass('active');
            }
        } else {
            self.setSettingContainer(target);
            self.setSettingComponent(null);
            //console.log("KEditor", KEditor);
            var componentData = KEditor.components["text"];

            body.find('#keditor-setting-title').html("Container Settings");

            var settingForms = body.find('#keditor-setting-forms');
            // var settingName = target.attr("data-wps-name").split('-')[1] || "";
            settingForm = $('<div id="keditor-container-settings' + '" class="keditor-ui keditor-setting-form clearfix active"></div>');
            settingForms.append(settingForm);


            var initFunction = componentData.initContainerForm.call(componentData, target, settingForm, self); // added target
            $.when(initFunction).done(function () {
                console.log('Initialized setting form for container');
            })

            // if (typeof options.containerSettingShowFunction === 'function') {
            //     flog('Show setting form of container');
            //     options.containerSettingShowFunction.call(self, settingForm, target, self);
            // } else {
            //     flog('"containerSettingShowFunction" does not exist');
            // }
            //settingForm.addClass('active');
        }

        self.toggleSidebar(true);
        self.toggleSettings(true, target);
        //
    };


    KEditor.prototype.toggleSettings = function (showSettings, target) {

        var self = this;
        var options = self.options;
        var body = self.body;
        //KEditor.scrollTarget = target;


        setTimeout(function () {
            var _a = self.iframeBody.width(),
                _b = body.find("#keditor-sidebar-settings").width();
            //_c = body.find("#keditor-snippets-list").width();

            var scrollWidth = getScrollbarWidth();

            //scrollbar fix
            _a = _a - (2 * scrollWidth);




            var _scale = (((_a - _b) * 100) / _a) / 100;



            _scrollTop = (self.clickedSnippetTop / 100) * (_scale * 100);



            if (showSettings) {
                body.addClass('opened-keditor-setting');
                //self.iframeBody.closest("html").css('cursor', 'pointer');
                self.iframeBody.find(".keditor-ui.keditor-content-areas-wrapper").css({
                    //   "transform": 'scale('+_scale+')',
                    //   "-webkit-transform": 'scale('+_scale+')',
                    //   "transform-origin": 'left top',
                    "height": '100%',
                    "pointer-events": "none",
                    "cursor": "pointer",
                });

                //self.iframeBody.scrollTop(_scrollTop)

                setTimeout(function () {
                    //self.iframeDoc.on('click.mynamespace', function(e) { e.preventDefault();self.toggleSettings(false); });

                    /*self.iframeBody.animate({
                       scrollTop: _scrollTop
                    })*/

                }, 210);






            } else {


                body.removeClass('opened-keditor-setting');
                if (!self.options.snippetsContainer && !self.options.snippetsComponent) body.removeClass('opened-keditor-sidebar');
                self.iframeBody.closest("html").css('cursor', 'auto');
                self.iframeBody.find(".keditor-ui.keditor-content-areas-wrapper").css({
                    //   "transform": 'none',
                    //   "-webkit-transform": 'none',
                    //   "transform-origin": 'left top',
                    "height": '100%',
                    "pointer-events": "all",
                    "cursor": "auto",
                });
                self.iframeDoc.off('click.mynamespace');

                //self.iframeBody.scrollTop(self.clickedSnippetTop)


            }
        }, 10);





    };

    KEditor.prototype.sizeSettingPanel = function () {

        var self = this;
        var body = self.body;

        body.find('#keditor-sidebar-settings').toggleClass('keditor-sidebar-settings-large');

    }

    KEditor.prototype.hideSettingPanel = function () {
        console.log('hideSettingPanel');


        var self = this;
        var options = self.options;
        var body = self.body;

        self.toggleSettings(false);

        var activeForm = body.find('#keditor-setting-forms').children('.active');
        if (activeForm.length > 0) {
            if (activeForm.is('#keditor-container-setting')) {
                if (typeof options.containerSettingHideFunction === 'function') {
                    flog('Hide setting form of container');
                    options.containerSettingHideFunction.call(self, activeForm, self);
                } else {
                    flog('"containerSettingHideFunction" does not exist');
                }
            } else {
                var activeType = activeForm.attr('data-wps-type');
                var activeType;
                if (activeType != "blank") {
                    componentData = KEditor.components["text"];
                } else {
                    componentData = KEditor.components[activeType];
                }
                //var componentData = KEditor.components[activeType];

                if (typeof componentData.hideSettingForm === 'function') {
                    flog('Hide setting form of component type "' + activeType + '"');
                    componentData.hideSettingForm.call(componentData, activeForm, self);
                } else {
                    flog('"hideSettingForm" function of component type "' + activeType + '" does not exist');
                }
            }

            activeForm.removeClass('active');
            activeForm.remove();

        }


        if (!self.options.snippetsContainer && !self.options.snippetsComponent) body.removeClass('opened-keditor-sidebar');
        body.removeClass('opened-keditor-setting');
        self.setSettingComponent(null);
        self.setSettingContainer(null);
    };



    KEditor.prototype.getContentAreas = function (target) {
        flog('getContentAreas', target);

        var self = this;
        var options = self.options;
        var contentAreas;
        if (options.contentAreasSelector) {
            contentAreas = target.find(options.contentAreasSelector);
        }

        if (!contentAreas || contentAreas.length === 0) {
            flog('Do not find any content area. Creating default content area...');
            contentAreas = $('<div />');

            var originalContent = target.html();

            contentAreas.html(originalContent);
            target.empty().append(contentAreas);
        }

        return contentAreas;
    };

    KEditor.prototype.eachObserveableElement = function (nodes, fn) {
        if (nodes) {
            [].slice.call(nodes).forEach(function (node) {
                if (node.nodeType === 1) {
                    var containers = [].slice.call(
                        node.querySelectorAll('[data-observe-resizes]'));
                    if (node.hasAttribute('data-observe-resizes')) {
                        containers.push(node);
                    }
                    for (var container, i = 0; container = containers[i]; i++) {
                        fn(container);
                    }
                }
            });
        }
    };

    KEditor.prototype.initObservers = function () {
        var self = this;
        // Only run if ResizeObserver is supported.
        if ('ResizeObserver' in window && !self.resizeObserver) {
            // Create a single ResizeObserver instance to handle all
            // container elements.
            self.resizeObserver = new ResizeObserver(function (entries) {
                var defaultBreakpoints = { ro_xs: 0, ro_sm: 576, ro_md: 768, ro_lg: 992, ro_xl: 1200 };

                entries.forEach(function (entry) {
                    var breakpoints = entry.target.dataset.breakpoints ?
                        JSON.parse(entry.target.dataset.breakpoints) :
                        defaultBreakpoints;

                    if (entry.contentRect.width === 0) {
                        entry.target.dataset.observing = false;
                    } else {
                        entry.target.dataset.observing = true;
                    }

                    Object.keys(breakpoints).forEach(function (breakpoint) {
                        var minWidth = breakpoints[breakpoint];
                        if (entry.contentRect.width >= minWidth) {
                            entry.target.classList.add(breakpoint);
                        } else {
                            entry.target.classList.remove(breakpoint);
                        }
                    });
                });
            });

            // Monitor the DOM for changes
            self.mutationObserver = new MutationObserver(function (entries) {
                entries.forEach(function (entry) {
                    self.eachObserveableElement(entry.addedNodes, self.resizeObserver.observe.bind(self.resizeObserver));
                });
            });
            self.mutationObserver.observe(self.body[0], { childList: true, subtree: true });
        }
    };

    KEditor.prototype.initContentAreas = function (target) {
        flog('initContentAreas', target);

        var self = this;
        var contentAreas = self.getContentAreas(target);


        contentAreas.each(function () {

            var contentArea = $(this);
            if (!contentArea.attr('id')) {
                contentArea.attr('id', self.generateId('content-area'));
            }

            self.initContentArea(contentArea);
            contentArea.data('keditor', self);
        });
    };

    KEditor.prototype.initContentArea = function (contentArea) {
        flog('initContentArea', contentArea);


        var self = this;
        var options = self.options;
        var body = self.body;






        contentArea.addClass('keditor-content-area');

        if (typeof options.onBeforeInitContentArea === 'function') {
            options.onBeforeInitContentArea.call(self, contentArea);
        }



        flog('Initialize existing containers in content area');
        contentArea.children('section').each(function () {
            self.convertToContainer(contentArea, $(this));
        });

        if (typeof options.onInitContentArea === 'function') {
            var contentData = options.onInitContentArea.call(self, contentArea);
            if (contentData && contentData.length > 0) {
                $.each(contentData, function () {
                    self.convertToContainer(contentArea, $(this));
                });
            }
        }



        self.window.imgCover.update(self.body[0], true);

        // Use singleton resize observer
        if (self.resizeObserver) {
            var elements = self.body.find('[data-observe-resizes]');
            for (var element, i = 0; element = elements[i]; i++) {
                self.resizeObserver.observe(element);
            }
        }

        if (window.universalParallax) {
            new universalParallax().init({
                speed: 100,
                container: self.body[0]
            });
        }

        self.checkTemplateUpdate();
    };

    KEditor.prototype.checkContentArea = function (contentArea) {


        var self = this;
        var options = self.options;
        var body = self.body;

        console.log("contentArea", contentArea);

        flog('Check snippet versions in content area');


        var sectionsArticle = contentArea.find("section[data-wps-name]"),
            version,
            name,
            snippetsArticle = [];



        sectionsArticle.each(function (index, val) {

            version = $(val).attr("data-wps-version");
            name = $(val).attr("data-wps-name");
            snippetsArticle.push({
                "name": name,
                "version": version,
                "element": val
            })



            if (self.snippetsTemplate) {
                var result = self.snippetsTemplate.filter(function (obj) {
                    return obj.name == name;
                });


                if (result.length > 0) {
                    if (result[0].version > version) {
                        // show update button in component
                        $(val).find(".keditor-toolbar .btn-component-update").css("display", "inline-block");
                    }
                }
            }
        });


        //console.error("checkContentArea", contentArea, contentArea.find("a"))

        //catch all a:href (no internal linkin in AMS Editor)
        contentArea.find("a").click(function (e) {
            href = $(this).attr("href");
            e.preventDefault();

            //alert("fix that")
            var result = [0]; // $.grep(window.parent._AMS.project.modules.content, function(e){ return e.path == href && e.status==1  && $.inArray('#hidden', e.category)== -1 ; });
            if (result.length > 0) {

            } else {
                if (parent.p$) parent.p$.utils.openUrl(href)
            }
            //if(parent.p$) parent.p$.utils.openUrl(href)
        });


        self.addImageHandler(contentArea);
        self.initPaddingDragHandlers(contentArea);

    };



    KEditor.prototype.convertToContainer = function (contentArea, target) {

        flog('convertToContainer', contentArea, target);

        var self = this;
        var isSection = target.is('section');
        var container;

        if (isSection) {
            target.addClass('keditor-container');
            target.removeClass("keditor-ui keditor-component keditor-initialized-component")
            if (target.find(".keditor-ui.keditor-container-inner").length == 0) target.wrapInner('<div class="keditor-ui keditor-container-inner"></div>');
            container = target;
        } else {
            //target.wrap('<section class="keditor-ui keditor-container"><pgs-article class="' + self.options.data.template + ' keditor-ui keditor-container-inner"></pgs-article></section>');
            target.wrap('<section class="keditor-ui keditor-container"><div class="' + self.options.data.template + ' keditor-ui keditor-container-inner"></div></section>');
            container = target.parent().parent();
        }
        self.initContainer(contentArea, container);
    };

    KEditor.prototype.initContainer = function (contentArea, container) {


        var self = this;
        var options = self.options;
        var isNested = options.nestedContainerEnabled && container.closest('[data-wps-type="container-content"]').length > 0;

        flog('initContainer - isNested=' + isNested, contentArea, container);

        if (!container.hasClass('keditor-initialized-container') || !container.hasClass('keditor-initializing-container')) {
            container.addClass('keditor-initializing-container');

            if (typeof options.onBeforeInitContainer === 'function') {
                options.onBeforeInitContainer.call(self, container, contentArea);
            }

            container.addClass('section');

            if (isNested) {
                container.addClass('keditor-sub-container keditor-component-sortable');
            }

            var settingBtn = '';
            if (options.containerSettingEnabled === true) {
                settingBtn = '<a href="javascript:void(0);" class="keditor-ui btn-container-setting">' + options.btnSettingContainerText + '</a>';
            }

            if (isNested && (self.privileges.includes('can_edit_page') || self.options.isSysAdmin)) {

                console.warn(container.find('[data-wps-edit-name2="spacing"]'));

                var _paddingTop = '';
                var _paddingBottom = '';

                var _paddingTopIcon = "fa-arrow-down";
                var _paddingBottomIcon = "fa-arrow-up";
                var _spacing = container.find('[data-wps-edit-name2="spacing"]')
                if (_spacing.length > 0 && _spacing.hasClass("pt-0i")) {
                    _paddingTopIcon = "fa-arrow-up";
                }
                if (_spacing.length > 0 && _spacing.hasClass("pb-0i")) {
                    _paddingBottomIcon = "fa-arrow-down";
                }
                if (_spacing.length > 0){
                    _paddingTop = '<button type="button" class="component-btn btn-component-paddingTop"><i class="fa ' + _paddingTopIcon + '"></i></button>';
                    _paddingBottom = '<button type="button" class="component-btn btn-component-paddingBottom"><i class="fa ' + _paddingBottomIcon + '"></i></button>';
                }

                var _lock = '';
                if (self.privileges.includes('can_lock_snippets') || self.options.isSysAdmin) {
                    self.body.addClass("webmag_lock_admin");
                    _lock = '<button class="dropdown-item btn-component-lock" type="button"><i class="fa fa-lock" aria-hidden="true"></i> ' + self.labels.lock + '</button>';
                }

                var _resize = '';
                if (container.find("[data-wps-resize-h]").length > 0) {
                    _resize = '<button type="button" class="component-btn btn-component-resize"><i class="fa fa-arrows-h"></i></button>';
                }

                // var _paddingLeftIcon = "fa-arrows-h";
                // var _paddingRightIcon = "fa-arrows-h";

                container.append(
                    _paddingTop +
                    _paddingBottom +
                    // '<button type="button" class="component-btn btn-component-paddingLeft"><i class="fa '+_paddingLeftIcon+'"></i></button>' +
                    // '<button type="button" class="component-btn btn-component-paddingRight"><i class="fa '+_paddingRightIcon+'"></i></button>' +
                    '<div class="keditor-toolbar keditor-toolbar-component">' +

                    '<div class="btn-group" role="group" aria-label="Button group with nested dropdown">' +
                    //'<button type="button" class="component-btn btn-component-add-element" title="Add element"><i class="fa fa-plus"></i></button>' +
                    //'<button type="button" class="component-btn keditor-toolbar-component-settings btn-component-setting"><i class="fa fa-pencil"></i></button>' +

                    //'<button title="New snippet update available" href="javascript:void(0);" class="component-btn btn-component-update">' + options.btnUpdateComponentText+  '</button>' +
                    _resize +
                    '<button type="button" class="component-btn btn-component-reposition"><i class="fa fa-arrows"></i></button>' +
                    '<button type="button" class="component-btn btn-component-moveup"><i class="fa fa-long-arrow-up" aria-hidden="true"></i></button>' +
                    '<button type="button" class="component-btn btn-component-movedown"><i class="fa fa-long-arrow-down" aria-hidden="true"></i></button>' +


                    '<div class="btn-group dropdown" role="group">' +
                    '<button id="btnGroupDrop2" type="button" class="component-btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="fa fa-sort-desc"></i></button>' +
                    '<div class="dropdown-menu dropdown-menu-right" aria-labelledby="btnGroupDrop2">' +

                    '<button class="dropdown-item btn-container-edit" type="button"><i class="fa fa-pencil" aria-hidden="true"></i> ' + self.labels.edit + '</button>' +
                    '<button class="dropdown-item btn-container-select" type="button"><i class="fa fa-check-square-o" aria-hidden="true"></i> ' + self.labels.select + '</button>' +
                    '<button class="dropdown-item btn-container-duplicate" type="button"><i class="fa fa-clone" aria-hidden="true"></i> ' + self.labels.duplicate + '</button>' +
                    '<button class="dropdown-item btn-component-copy" type="button"><i class="fa fa-files-o" aria-hidden="true"></i> ' + self.labels.copy + '</button>' +
                    '<button class="dropdown-item btn-component-paste" type="button"><i class="fa fa-clipboard" aria-hidden="true"></i> ' + self.labels.paste + '</button>' +
                    '<button class="dropdown-item btn-component-hide" type="button"><i class="fa fa-eye-slash" aria-hidden="true"></i> ' + self.labels.showhide + '</button>' +
                    _lock +
                    '<div class="dropdown-divider"></div>' +
                    '<button class="dropdown-item btn-component-delete" type="button"><i class="fa fa-trash" aria-hidden="true"></i> ' + self.labels.delete + '</button>' +
                    '</div>' +
                    '</div>' +
                    '<div class="d-none component-btn btn-component-checkbox d-flex justify-content-center align-items-center" style="">' +
                    '<input type="checkbox" class="" style="">' +
                    '</div>' +
                    '</div>' +
                    '</div>'
                )

                //toggle dropdown
                container.find('.dropdown-toggle').click(function () {

                    var _clone = JSON.parse(window.localStorage.getItem('clonedElements'));
                    if (!_clone) {
                        $(this).parent().find(".dropdown-menu .btn-component-paste").hide();
                    } else {
                        $(this).parent().find(".dropdown-menu .btn-component-paste").show();
                    }
                    //$(this).parent().find(".dropdown-menu").toggleClass("show")
                })



                container.append(
                    '<div title="Snippet Settings" class="keditor-toolbar keditor-toolbar-component-settings">' +
                    settingBtn +
                    //'   <a title="Update Snippet" href="javascript:void(0);" class="keditor-ui btn-component-update">' + options.btnUpdateComponentText + '</a>' +
                    '</div>'
                );

                container.find('[data-dynamic-href]').each(function () {
                    var dynamicElement = $(this);

                    self.initDynamicContent(dynamicElement);
                });




                var snip;
                var componentType = self.getComponentType(container);
                var componentData;
                if (componentType != "blank") {
                    componentData = KEditor.components["text"];
                } else {
                    componentData = KEditor.components[componentType];
                }

                console.error("componentType", componentType)
                var multipleTypes = componentType.split(',');
                console.log("multipleTypes", multipleTypes);
                $(multipleTypes).each(function (index, el) {
                    //console.log("el",el);
                    //console.log(p$.snippet[el])
                    if (self.window.p$.snippet && self.window.p$.snippet[el]) { //if this snippet has a js file
                        console.log("init snippet", el);
                        snip = new self.window.p$.snippet[el](); // create snippet
                        if (typeof snip.clear === 'function') snip.clear(container);
                        snip.init(container); // init snippet
                    }
                });

                //init editables in container too
                var componentData = KEditor.components["text"];
                if (typeof componentData.init === 'function') {
                    componentData.init.call(componentData, contentArea, container, container, self);
                }



            }

            // flog('Render KEditor toolbar for container', container);
            // container.append(
            //     '<div class="keditor-toolbar keditor-toolbar-container ' + (isNested ? 'keditor-toolbar-sub-container' : '') + '">' +
            //     '   <a href="javascript:void(0);" class="keditor-ui btn-container-moveup">' + options.btnMoveUp + '</a>' +
            //     '   <a href="javascript:void(0);" class="keditor-ui btn-container-movedown">' + options.btnMoveDown + '</a>' +
            //     '   <a href="javascript:void(0);" class="keditor-ui btn-container-reposition">' + options.btnMoveContainerText + '</a>' + settingBtn +
            //     '   <a href="javascript:void(0);" class="keditor-ui btn-container-duplicate">' + options.btnDuplicateContainerText + '</a>' +
            //     '   <a href="javascript:void(0);" class="keditor-ui btn-container-delete">' + options.btnDeleteContainerText + '</a>' +
            //     '</div>'
            // );



            container.attr('id', self.generateId(isNested ? 'sub-container' : 'container'));

            var containerContents = container.find('[data-wps-type="container-content"]');

            //console.log('Initialize ' + containerContents.length + ' container content(s)', containerContents);
            containerContents.each(function () {
                var containerContent = $(this);

                if (options.nestedContainerEnabled) {
                    if (isNested) {
                        self.initContainerContent(contentArea, container, containerContent, isNested);
                    } else {
                        if (containerContent.parents('[data-wps-type="container-content"]').length === 0) {
                            self.initContainerContent(contentArea, container, containerContent, isNested);
                        }
                    }
                } else {
                    self.initContainerContent(contentArea, container, containerContent, isNested);
                }
            });



            if (typeof options.onInitContainer === 'function') {
                options.onInitContainer.call(self, container, contentArea);
            }

            container.addClass('keditor-initialized-container');
            container.removeClass('keditor-initializing-container');
            // init drag of Layout on start
            if (typeof self.options.template.afterUpdate == 'function') self.options.template.afterUpdate(self);
        } else {
            if (container.hasClass('keditor-initialized-container')) {
                flog('Container is already initialized!');
            } else {
                flog('Container is initializing...');
            }
        }
    };

    KEditor.prototype.initContainerContent = function (contentArea, container, containerContent, isNested) {
        flog('initContainerContent - isNested=' + isNested, contentArea, container, containerContent);



        var self = this;
        var options = self.options;
        var body = self.body;

        containerContent.addClass('keditor-container-content');
        if (isNested) {
            containerContent.addClass('keditor-sub-container-content');
        }
        containerContent.attr('id', self.generateId('container-content'));

        // Add plus buttons for element snippets only if this is a container snippet (data-wps-container="true")
        if (container.attr('data-wps-container') === 'true') {
            self.addPlusButtonsToContainer(containerContent, contentArea, container);
        }






        flog('Initialize existing components inside container content');
        containerContent.children().each(function () {

            var child = $(this);
            // Skip plus buttons - they should not be converted to components
            if (child.hasClass('keditor-plus-button')) {
                return;
            }
            if (child.find('[data-wps-type="container-content"]').length > 0) {
                self.convertToContainer(contentArea, child);
            } else {
                //console.log("!isInitialised", child);
                // console.log all classnames of child element  (for debugging)
                //console.log("child", child[0].className.split(/\s+/));


                //if(child.hasClass("keditor-initialized-component"))
                self.convertToComponent(contentArea, container, child, true);
            }
        });

        /*containerContent.attr('id', 'sortableSnippets');
        $(containerContent[0]).sortable({
              appendTo: "parent",
              placeholder: "drag_ghost",
              handle:'.btn-component-reposition',
              items: 'section.keditor-component:not([data-wps-mode="fixed"])',
              scroll: true,
              axis: "y",
              scrollSensitivity: 100,
              scrollSpeed: 30,
              forcePlaceholderSize:true,
              forceHelperSize:true,
              sort: function(event, ui) {

              }
        });*/


        // sort snippets in editor
        if (containerContent.hasClass("keditor-no-drop")) return;
        //snippets in editor view
        //console.log("containerContent[0]", containerContent[0]);
        //containerContent = $("main.keditor-container-content");
        //console.log("TAG NAME",containerContent.prop("tagName"))

        // Destroy existing Sortable instance if it exists
        var existingSortable = Sortable.get(containerContent[0]);
        if (existingSortable) {
            existingSortable.destroy();
        }

        if (containerContent.prop("tagName") == "MAIN") {
            //console.log("containerContent[0]", containerContent[0]);
            var sort = Sortable.create(containerContent[0], {
                group: {
                    name: 'component',
                    put: true
                },
                ghostClass: 'drag_ghost',
                animation: 150,


                //forceFallback: true,
                //chosenClass: 'drag_chosen',
                handle: '.btn-component-reposition', // Restricts sort start click/touch to the specified element
                draggable: 'section.keditor-component-sortable:not([data-wps-mode="fixed"])', // Specifies which items inside the element should be sortable
                // Called by any change to the list (add / update / remove)
                onSort: function (evt) { return _onSort(evt) },
                // Element is dropped into the list from another list (receive)
                onAdd: function (evt) { return _onAdd(evt) },
                // Element dragging started
                onStart: function (evt) { return _onStart(evt) },
                onMove: function (evt) { return _onMove(evt) },
                // Element dragging ended
                onEnd: function (evt) { return _onEnd(evt) },
                setData: function (dataTransfer, dragEl) { _setData(dataTransfer, dragEl) }

            });
        } else {
            var sort = Sortable.create(containerContent[0], {
                group: {
                    name: 'component2',
                    put: true,
                },
                ghostClass: 'drag_ghost',
                animation: 150,


                //forceFallback: true,
                //chosenClass: 'drag_chosen',
                handle: '.btn-component-reposition', // Restricts sort start click/touch to the specified element
                draggable: 'section.keditor-component-sortable:not([data-wps-mode="fixed"])', // Specifies which items inside the element should be sortable
                // Called by any change to the list (add / update / remove)
                onSort: function (evt) { return _onSort(evt) },
                // Element is dropped into the list from another list (receive)
                onAdd: function (evt) { return _onAdd(evt) },
                // Element dragging started
                onStart: function (evt) { return _onStart(evt) },
                onMove: function (evt) { return _onMove(evt) },
                // Element dragging ended
                onEnd: function (evt) { return _onEnd(evt) }
            });
        }

        function _setData(dataTransfer, dragEl) {
            //dataTransfer.setData('Text', dragEl.textContent); // `dataTransfer` object of HTML5 DragEvent
            // Drag Image
        };

        function _onSort(evt) {

            // same properties as onEnd
            evt.preventDefault();
            evt.stopPropagation();
            var itemEl = evt.item;
            $(itemEl).removeClass('ui-state-default');
            //fix for insert dragged text on dropping hover other snippet
            setTimeout(function () {
                body.find(".fr-element").attr('contenteditable', 'true').css('pointerEvents', 'all');
            }, 200);
        }
        // Element is dropped into the list from another list (receive)
        function _onAdd(evt) {

            evt.preventDefault();
            evt.stopPropagation();
            // same properties as onEnd
            //console.log('On received snippet', evt);

            var helper = $(evt.item);
            var item = $(evt.item);
            var container;
            var isInitialised = false;

            //console.log("item", item)

            var isSnippet = item.is('.keditor-snippet');
            var isContainer = item.attr('data-wps-container');



            if (isSnippet) {

                var snippetContentElement = self.body.find(item.attr('data-snippet'));

                var snippetContent = snippetContentElement.html();

                // change to img and src again
                snippetContent = snippetContent.replace(/<img_wbmg/g, "<img").replace(/<source_wbmg/g, "<source").replace(/<video_wbmg/g, "<video").replace(/poster_wbmg="/g, 'poster="');

                var snippetType = item.attr('data-wps-type');

                snippetContent = self.compileHandlebars(snippetContent)
                var dataAttributes = self.getDataAttributes(snippetContentElement, null, true);
                var classNames = snippetContentElement[0].classList;
                var classNames2 = snippetContentElement.attr('data-wps-name');

                var $section = $('<section />'); // Replace with your div's ID or another selector

                // Iterate over the object and add each attribute to the div
                $.each(dataAttributes, function (key, value) {
                    $section.attr(key, value);
                });
                $section.addClass('keditor-ui keditor-component keditor-component-sortable ' + classNames + ' ' + classNames2);
                // add data-wps-type
                $section.attr('data-wps-type', snippetType);
                // add html
                $section.html('<div class="keditor-ui keditor-component-content">' + snippetContent + '</div>');

                var component = $section;

                // var component = $(
                //     '<section class="keditor-ui keditor-component keditor-component-sortable '+classNames+" "+classNames2+'" data-wps-type="' + snippetType + '" ' + dataAttributes.join(' ') + '>' +
                //     '   <section class="keditor-ui keditor-component-content">' + snippetContent + '</section>' +
                //     '</section>'
                // );
                isInitialised = component.hasClass("keditor-initialized-container") || component.hasClass("keditor-initialized-component");
                isInitialisedContainer = component.hasClass("keditor-initialized-container");

                if (isInitialised) {

                    component = self.cleanFroalaContent(component);
                    console.error("keditor-initialized-container", component.html());
                };
                // If the helper's parent has data-wps-container="true", do something (adjust as necessary for use case)
                if (helper.parent() && helper.parent().attr('data-wps-container') === "true") {
                    // Example: add a class to component, or adjust the drop, etc.
                    // component.addClass('dropped-in-wps-container');
                    // Check for an element with class 'col-lg-10 col-xl-9' and data-wps-edit-name="change width" in the component, only the first occurrence
                    var $editableCol = component.find('.col-lg-10.col-xl-9[data-wps-edit-name="change width"]').first();
                    if ($editableCol.length) {
                        $editableCol.removeClass('col-lg-10 col-xl-9').addClass('col-12 px-2');
                    }

                }

                helper.replaceWith(component);

                container = component.closest('.keditor-container');



                if (typeof options.onComponentSnippetDropped === 'function') {
                    options.onComponentSnippetDropped.call(self, evt, component, item, contentArea);
                }

                container = $(self.cleanContainerContent(container, true));
                if (!isInitialisedContainer) self.initComponent(contentArea, container, component);

            } else {
                // if (helper) {
                //     helper.remove();
                // }


                component = item;
                helper.replaceWith(component);
                container = item.closest('.keditor-container');
                self.initComponent(contentArea, container, component);
            }

            if (!container.hasClass('showed-keditor-toolbar')) {
                $('.keditor-container.showed-keditor-toolbar').removeClass('showed-keditor-toolbar');
                container.addClass('showed-keditor-toolbar');
            }

            if (typeof options.onContainerChanged === 'function') {
                options.onContainerChanged.call(self, evt, container, contentArea);
            }

            if (typeof options.onContentChanged === 'function') {
                options.onContentChanged.call(self, evt, contentArea);
            }

            item.removeClass('keditor-ui-dragging');
            contentArea.removeClass('keditor-highlighted-dropzone');

            //console.log("component", component)
            self.checkContentArea(component);

            if (window.universalParallax) {
                new universalParallax().init({
                    speed: 100,
                    container: component[0]
                });
            }
            var attr = item.attr('data-wps-container');
            // check if it is a container snippet
            if (typeof attr !== 'undefined' && attr !== false) {
                self.initContainerContent(contentArea, container, containerContent, false);
            }

            self.window.imgCover.update(self.body[0]);
            //
            self.save();

            // Refresh plus buttons after adding snippet
            // Only refresh if this is a container snippet
            if (container && container.attr('data-wps-container') === 'true') {
                self.addPlusButtonsToContainer(containerContent, contentArea, container);
            }

        }
        // Element dragging started
        function _onStart(evt) {

            evt.preventDefault();
            evt.stopPropagation();

            //fix for insert dragged text on dropping hover other snippet
            body.find(".fr-element").css('pointerEvents', 'none').attr('contenteditable', 'false');
            body.addClass('highlighted-container-content');

            // Store reference to dragged element for cleanup
            if (evt.item) {
                evt.item.setAttribute('data-keditor-dragging', 'true');
            }
        };
        function _onMove(evt) {

            //console.log("onMove", evt)
            evt.preventDefault();
            evt.stopPropagation();

            // dont drop container in container
            if ($(evt.dragged).hasClass("keditor-sub-container") && $(evt.to).hasClass("keditor-sub-container-content")) {
                // If move is cancelled, ensure cleanup happens
                setTimeout(function () {
                    var draggedEl = evt.dragged;
                    if (draggedEl) {
                        $(draggedEl).removeClass('sortable-drag sortable-ghost keditor-ui-dragging');
                        draggedEl.removeAttribute('data-keditor-dragging');
                    }
                    body.removeClass('highlighted-container-content');
                }, 50);
                return false;
            }

            return true; // Allow move
        }
        // Element dragging ended
        function _onEnd(evt) {

            evt.preventDefault();
            evt.stopPropagation();

            var itemEl = evt.item; // dragged HTMLElement

            // Remove dragging flag
            if (itemEl) {
                itemEl.removeAttribute('data-keditor-dragging');
            }

            body.removeClass('highlighted-container-content');
            containerContent.removeClass('keditor-highlighted-dropzone');

            // Remove all Sortable drag classes - Sortable.js adds these automatically
            if (itemEl) {
                $(itemEl).removeClass('sortable-drag sortable-ghost keditor-ui-dragging');
            }

            // Also remove from body/document in case they were added there
            body.find('.sortable-drag, .sortable-ghost').removeClass('sortable-drag sortable-ghost');

            // Clean up any remaining drag classes from all elements (safety net)
            body.find('[data-keditor-dragging="true"]').each(function () {
                $(this).removeClass('sortable-drag sortable-ghost keditor-ui-dragging').removeAttr('data-keditor-dragging');
            });

            //fix for insert dragged text on dropping hover other snippet
            setTimeout(function () {
                body.find(".fr-element").attr('contenteditable', 'true').css('pointerEvents', 'all');
            }, 200);

            self.save();

        }

        // Add global mouseup handler as safety net to clean up drag classes
        $(document).off('mouseup.keditorDragCleanup').on('mouseup.keditorDragCleanup', function () {
            // Small delay to let Sortable's onEnd fire first
            setTimeout(function () {
                body.find('.sortable-drag, .sortable-ghost, [data-keditor-dragging="true"]').each(function () {
                    $(this).removeClass('sortable-drag sortable-ghost keditor-ui-dragging').removeAttr('data-keditor-dragging');
                });
                body.removeClass('highlighted-container-content');
            }, 100);
        });




    };

    KEditor.prototype.addPlusButtonsToContainer = function (containerContent, contentArea, container) {
        var self = this;

        // Only add plus buttons for sysadmins
        var isSysAdmin = false;
        if (typeof window.user !== 'undefined' && window.user) {
            // Best practice: check for a meaningful property; fallback to boolean
            isSysAdmin = !!window.user.sysadmin;
        }

        if (!isSysAdmin) {
            // Don't add plus buttons for non-sysadmins
            return;
        }

        // Only add plus buttons to container snippets
        if (container.attr('data-wps-container') !== 'true') {
            return;
        }

        // Only get direct children components
        var children = containerContent.children('.keditor-component-sortable');
        var isEmpty = children.length === 0;

        // Check if plus button already exists
        var $plusBtn = containerContent.find('.keditor-plus-button');

        if ($plusBtn.length === 0) {
            // Create the plus button with consistent styles
            $plusBtn = $('<div class="keditor-plus-button">' +
                '<i class="fa fa-plus"></i>' +
                '</div>');

            // Always append - if container is empty, it becomes the first child; if not, it goes to the bottom
            containerContent.append($plusBtn);
        } else {
            // Button exists - ensure it's at the bottom
            if ($plusBtn.parent()[0] !== containerContent[0] || $plusBtn.next().length > 0) {
                containerContent.append($plusBtn);
            }
        }
    };

    /**
     * Parse element tags from JSON format: '{"de":["Text","Tabelle"],"en":["Text","Table"]}'
     * Returns tags for the specified language as comma-separated string
     */
    KEditor.prototype.parseElementTags = function (tagsString, language) {
        if (!tagsString || tagsString.trim() === '') {
            return '';
        }

        // Try to parse as JSON first
        try {
            var tagsByLang = JSON.parse(tagsString);

            // If it's an object with language keys
            if (typeof tagsByLang === 'object' && tagsByLang !== null && !Array.isArray(tagsByLang)) {
                // Return tags for specified language, or first available, or empty
                if (language && tagsByLang[language]) {
                    return Array.isArray(tagsByLang[language])
                        ? tagsByLang[language].join(',')
                        : tagsByLang[language];
                } else if (Object.keys(tagsByLang).length > 0) {
                    // Fallback to first available language
                    var firstLang = Object.keys(tagsByLang)[0];
                    return Array.isArray(tagsByLang[firstLang])
                        ? tagsByLang[firstLang].join(',')
                        : tagsByLang[firstLang];
                }
                return '';
            }
        } catch (e) {
            // Not valid JSON, fall through to backward compatibility
        }

        // Fallback: treat as simple comma-separated list (backward compatibility)
        return tagsString;
    };

    KEditor.prototype.showElementSnippetModal = function (containerContent, contentArea, container, insertBefore) {
        var self = this;
        var options = self.options;

        if (!self.elementSnippets || self.elementSnippets.length === 0) {
            console.log('No element snippets available');
            return;
        }

        // Collect element tags for filters (from current language only)
        var elementTagsMap = {};
        self.elementSnippets.forEach(function (elementSnippet) {
            // Split by comma (tags are comma-separated after parsing from JSON)
            var elementTags = (elementSnippet.elementTags || '').split(',');
            elementTags.forEach(function (tag) {
                tag = tag.trim();
                if (tag) {
                    elementTagsMap[tag] = true;
                }
            });
        });

        var elementTagsList = Object.keys(elementTagsMap).sort();
        var hasTabs = elementTagsList.length > 0;

        // Build modal HTML with filter links, search, and categorized sections
        var modalHtml = '<div class="keditor-element-modal" style="max-width: 900px; max-height: 85vh; overflow: hidden; background: white; border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.3); display: flex; flex-direction: column;">';

        // Header with filter links and search
        modalHtml += '<div style="border-bottom: 1px solid #e0e0e0; flex-shrink: 0;">';

        // Filter links
        if (hasTabs) {
            modalHtml += '<div class="keditor-element-filters" style="padding: 15px 15px 10px 15px; border-bottom: 1px solid #e0e0e0;">';
            modalHtml += '<a href="#" class="keditor-element-filter-link" data-tag="" style="display: inline-block; padding: 6px 12px; margin-right: 8px; margin-bottom: 8px; color: #007bff; text-decoration: none; border: 1px solid #007bff; border-radius: 4px; font-size: 13px; transition: all 0.2s; background: white;">Alle</a>';
            elementTagsList.forEach(function (tag) {
                modalHtml += '<a href="#" class="keditor-element-filter-link" data-tag="' + tag + '" style="display: inline-block; padding: 6px 12px; margin-right: 8px; margin-bottom: 8px; color: #666; text-decoration: none; border: 1px solid #ddd; border-radius: 4px; font-size: 13px; transition: all 0.2s; background: white;">' + tag + '</a>';
            });
            modalHtml += '</div>';
        }

        // Search bar
        modalHtml += '<div style="padding: 15px; border-bottom: 1px solid #e0e0e0;">';
        modalHtml += '<input type="text" class="keditor-element-search" placeholder="Search" style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 14px; box-sizing: border-box;" />';
        modalHtml += '</div>';
        modalHtml += '</div>';

        // Content area with element tags
        modalHtml += '<div class="keditor-element-content" style="flex: 1; overflow-y: auto; padding: 20px;">';

        // Group elements by element tags (each tag gets its own group, elements can appear in multiple groups)
        var elementsByTag = {};
        var elementsWithoutTag = [];

        self.elementSnippets.forEach(function (elementSnippet) {
            // Split by comma (tags are comma-separated after parsing from JSON)
            var elementTags = (elementSnippet.elementTags || '').split(',');
            var hasTag = false;

            elementTags.forEach(function (tag) {
                tag = tag.trim();
                if (tag) {
                    hasTag = true;
                    // Create a group for each individual tag
                    if (!elementsByTag[tag]) {
                        elementsByTag[tag] = [];
                    }
                    // Add element to this tag's group (elements can appear in multiple groups)
                    elementsByTag[tag].push(elementSnippet);
                }
            });

            if (!hasTag) {
                elementsWithoutTag.push(elementSnippet);
            }
        });

        // Render elements by element tag
        var sortedTags = Object.keys(elementsByTag).sort();
        sortedTags.forEach(function (tag) {
            modalHtml += '<div class="keditor-element-tag-group" data-tag="' + tag + '" style="margin-bottom: 30px;">';
            modalHtml += '<h4 style="margin: 0 0 15px 0; font-size: 16px; font-weight: 600; color: #333;">' + tag + '</h4>';
            modalHtml += '<div class="keditor-element-grid" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 15px;">';

            elementsByTag[tag].forEach(function (elementSnippet) {
                var previewUrl = elementSnippet.previewUrl || '';
                var title = elementSnippet.title || elementSnippet.name || 'Untitled';
                var name = elementSnippet.name || '';
                // elementTags is already parsed from JSON to comma-separated string
                var elementTags = elementSnippet.elementTags || '';
                var tags = elementSnippet.tags || '';
                var categories = (elementSnippet.categories || []).join(' ');

                // Build searchable data attributes
                var searchData = [
                    elementTags,
                    tags,
                    elementSnippet.name || '',
                    elementSnippet.title_en || '',
                    elementSnippet.title_de || '',
                    categories
                ].join(' ').toLowerCase();

                modalHtml += '<div class="keditor-element-item" data-snippet-index="' + elementSnippet.index + '" data-element-tags="' + elementTags + '" data-search="' + searchData.replace(/"/g, '&quot;') + '" style="cursor: pointer; border: 1px solid #e0e0e0; border-radius: 6px; padding: 12px; transition: all 0.2s; background: white; display: flex; flex-direction: column; align-items: center; text-align: center; min-height: 180px;">';
                modalHtml += '<div style="width: 100%; margin-bottom: 10px; flex: 1; display: flex; align-items: center; justify-content: center; min-height: 100px; overflow: hidden;">';
                modalHtml += '<img src="' + previewUrl + '" style="width: 100%; height: auto; max-height: 120px; object-fit: contain; display: block;" onerror="this.style.display=\'none\'" />';
                modalHtml += '</div>';
                modalHtml += '<div style="font-size: 13px; font-weight: 600; margin-bottom: 5px; color: #333; line-height: 1.3;">' + title + '</div>';
                modalHtml += '<div style="font-size: 11px; color: #999; margin-top: auto;">' + name + '</div>';
                modalHtml += '</div>';
            });

            modalHtml += '</div>';
            modalHtml += '</div>';
        });

        // Render elements without tags if any
        if (elementsWithoutTag.length > 0) {
            modalHtml += '<div class="keditor-element-tag-group" data-tag="" style="margin-bottom: 30px;">';
            modalHtml += '<h4 style="margin: 0 0 15px 0; font-size: 16px; font-weight: 600; color: #333;">Other</h4>';
            modalHtml += '<div class="keditor-element-grid" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 15px;">';

            elementsWithoutTag.forEach(function (elementSnippet) {
                var previewUrl = elementSnippet.previewUrl || '';
                var title = elementSnippet.title || elementSnippet.name || 'Untitled';
                var name = elementSnippet.name || '';
                // elementTags is already parsed from JSON to comma-separated string
                var elementTags = elementSnippet.elementTags || '';
                var tags = elementSnippet.tags || '';
                var categories = (elementSnippet.categories || []).join(' ');

                // Build searchable data attributes
                var searchData = [
                    elementTags,
                    tags,
                    elementSnippet.name || '',
                    elementSnippet.title_en || '',
                    elementSnippet.title_de || '',
                    categories
                ].join(' ').toLowerCase();

                modalHtml += '<div class="keditor-element-item" data-snippet-index="' + elementSnippet.index + '" data-element-tags="' + elementTags + '" data-search="' + searchData.replace(/"/g, '&quot;') + '" style="cursor: pointer; border: 1px solid #e0e0e0; border-radius: 6px; padding: 12px; transition: all 0.2s; background: white; display: flex; flex-direction: column; align-items: center; text-align: center; min-height: 180px;">';
                modalHtml += '<div style="width: 100%; margin-bottom: 10px; flex: 1; display: flex; align-items: center; justify-content: center; min-height: 100px; overflow: hidden;">';
                modalHtml += '<img src="' + previewUrl + '" style="width: 100%; height: auto; max-height: 120px; object-fit: contain; display: block;" onerror="this.style.display=\'none\'" />';
                modalHtml += '</div>';
                modalHtml += '<div style="font-size: 13px; font-weight: 600; margin-bottom: 5px; color: #333; line-height: 1.3;">' + title + '</div>';
                modalHtml += '<div style="font-size: 11px; color: #999; margin-top: auto;">' + name + '</div>';
                modalHtml += '</div>';
            });

            modalHtml += '</div>';
            modalHtml += '</div>';
        }

        modalHtml += '</div>';
        modalHtml += '</div>';

        // Create modal overlay and content
        var $modalOverlay = $('<div class="keditor-modal-overlay" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 10000; display: flex; align-items: center; justify-content: center;"></div>');
        var $modalContent = $(modalHtml);

        $modalOverlay.append($modalContent);
        self.body.append($modalOverlay);

        // Track active tag for filtering
        var currentActiveTag = '';

        // Filter link switching
        if (hasTabs) {
            $modalContent.find('.keditor-element-filter-link').on('click', function (e) {
                e.preventDefault();
                var selectedTag = $(this).attr('data-tag');
                currentActiveTag = selectedTag;

                console.log('[KEditor Filter] Selected tag:', selectedTag);
                console.log('[KEditor Filter] Current active tag:', currentActiveTag);

                // Update active state
                $modalContent.find('.keditor-element-filter-link').css({
                    'color': '#666',
                    'border-color': '#ddd',
                    'background': 'white'
                });
                $(this).css({
                    'color': '#007bff',
                    'border-color': '#007bff',
                    'background': '#f0f8ff'
                });

                // Get current search term
                var searchTerm = $modalContent.find('.keditor-element-search').val().toLowerCase().trim();
                console.log('[KEditor Filter] Search term:', searchTerm);

                // First, show all items and groups to reset state
                console.log('[KEditor Filter] Resetting: showing all items and groups');
                $modalContent.find('.keditor-element-item').show();
                $modalContent.find('.keditor-element-tag-group').show();

                // Filter elements by tag and search
                var visibleCount = 0;
                var hiddenCount = 0;
                $modalContent.find('.keditor-element-item').each(function () {
                    var $item = $(this);
                    var itemTags = $item.attr('data-element-tags') || '';
                    var searchData = $item.attr('data-search') || '';

                    // Split tags and trim each one for proper matching
                    var tagArray = itemTags ? itemTags.split(',').map(function (t) { return t.trim(); }) : [];
                    var matchesTag = (selectedTag === '' || selectedTag === null) ? true : (tagArray.indexOf(selectedTag) !== -1);
                    var matchesSearch = searchTerm === '' || searchData.indexOf(searchTerm) !== -1;

                    console.log('[KEditor Filter] Item tags:', itemTags, 'Tag array:', tagArray, 'Matches tag:', matchesTag, 'Matches search:', matchesSearch);

                    if (matchesTag && matchesSearch) {
                        $item.show();
                        visibleCount++;
                    } else {
                        $item.hide();
                        hiddenCount++;
                    }
                });

                console.log('[KEditor Filter] Visible items:', visibleCount, 'Hidden items:', hiddenCount);

                // Show/hide tag groups based on filter
                if (selectedTag === '' || selectedTag === null) {
                    // Show all tag groups when "Alle" is selected
                    console.log('[KEditor Filter] Showing all tag groups (Alle selected)');
                    $modalContent.find('.keditor-element-tag-group').show();
                } else {
                    // Hide empty tag groups when filtering by specific tag
                    var shownGroups = 0;
                    var hiddenGroups = 0;
                    $modalContent.find('.keditor-element-tag-group').each(function () {
                        var $group = $(this);
                        var visibleItems = $group.find('.keditor-element-item:visible').length;
                        console.log('[KEditor Filter] Group:', $group.attr('data-tag'), 'Visible items:', visibleItems);
                        if (visibleItems === 0) {
                            $group.hide();
                            hiddenGroups++;
                        } else {
                            $group.show();
                            shownGroups++;
                        }
                    });
                    console.log('[KEditor Filter] Shown groups:', shownGroups, 'Hidden groups:', hiddenGroups);
                }
            });
            // Set first filter link as active
            $modalContent.find('.keditor-element-filter-link').first().trigger('click');
        }

        // Search functionality
        $modalContent.find('.keditor-element-search').on('input', function () {
            var searchTerm = $(this).val().toLowerCase().trim();

            // Filter by search term and active filter
            $modalContent.find('.keditor-element-item').each(function () {
                var $item = $(this);
                var searchData = $item.attr('data-search') || '';
                var itemTags = $item.attr('data-element-tags') || '';

                // Split tags and trim each one for proper matching
                var tagArray = itemTags ? itemTags.split(',').map(function (t) { return t.trim(); }) : [];
                var matchesSearch = searchTerm === '' || searchData.indexOf(searchTerm) !== -1;
                var matchesTag = (currentActiveTag === '' || currentActiveTag === null) ? true : (tagArray.indexOf(currentActiveTag) !== -1);

                if (matchesSearch && matchesTag) {
                    $item.show();
                } else {
                    $item.hide();
                }
            });

            // Hide empty tag groups
            $modalContent.find('.keditor-element-tag-group').each(function () {
                var $group = $(this);
                var visibleItems = $group.find('.keditor-element-item:visible').length;
                if (visibleItems === 0) {
                    $group.hide();
                } else {
                    $group.show();
                }
            });

            // If "Alle" is selected, show all tag groups
            if (currentActiveTag === '' || currentActiveTag === null) {
                $modalContent.find('.keditor-element-tag-group').show();
            }
        });

        // Add hover effect to element items
        $modalContent.find('.keditor-element-item').on('mouseenter', function () {
            $(this).css({
                'border-color': '#007bff',
                'transform': 'translateY(-2px)',
                'box-shadow': '0 4px 12px rgba(0,0,0,0.1)',
                'background': '#f8f9fa'
            });
        }).on('mouseleave', function () {
            $(this).css({
                'border-color': '#e0e0e0',
                'transform': 'translateY(0)',
                'box-shadow': 'none',
                'background': 'white'
            });
        });

        // Handle element item clicks (removed Add button, clicking card adds element)
        $modalContent.find('.keditor-element-item').on('click', function (e) {
            e.stopPropagation();
            var snippetIndex = $(this).attr('data-snippet-index');
            $(document).off('keydown.keditorElementModal');
            self.addElementSnippetToContainer(containerContent, contentArea, container, insertBefore, snippetIndex);
            $modalOverlay.remove();
        });

        // Close modal on overlay click
        $modalOverlay.on('click', function (e) {
            if ($(e.target).is($modalOverlay)) {
                $(document).off('keydown.keditorElementModal');
                $modalOverlay.remove();
            }
        });

        // Close modal on Escape key
        $(document).on('keydown.keditorElementModal', function (e) {
            if (e.keyCode === 27) { // Escape key
                $(document).off('keydown.keditorElementModal');
                $modalOverlay.remove();
            }
        });

        // Focus search input
        setTimeout(function () {
            $modalContent.find('.keditor-element-search').focus();
        }, 100);
    };

    KEditor.prototype.addElementSnippetToContainer = function (containerContent, contentArea, container, insertBefore, snippetIndex) {
        var self = this;
        var body = self.body;

        // Find the element snippet
        var elementSnippet = null;
        for (var i = 0; i < self.elementSnippets.length; i++) {
            if (self.elementSnippets[i].index == snippetIndex) {
                elementSnippet = self.elementSnippets[i];
                break;
            }
        }

        if (!elementSnippet) {
            console.error('Element snippet not found:', snippetIndex);
            return;
        }

        // Get snippet content from the stored script tag
        var snippetContentElement = body.find('#keditor-snippet-' + snippetIndex);
        if (snippetContentElement.length === 0) {
            console.error('Snippet content element not found:', '#keditor-snippet-' + snippetIndex);
            return;
        }

        var snippetContent = snippetContentElement.html();

        // Change img_wbmg back to img
        snippetContent = snippetContent.replace(/<img_wbmg/g, "<img").replace(/<source_wbmg/g, "<source").replace(/<video_wbmg/g, "<video").replace(/poster_wbmg="/g, 'poster="');

        var snippetType = elementSnippet.type;
        snippetContent = self.compileHandlebars(snippetContent);

        var dataAttributes = self.getDataAttributes(snippetContentElement, null, true);
        var classNames = elementSnippet._class || '';
        var classNames2 = elementSnippet.name || '';

        // Create component element
        var $section = $('<section />');
        $.each(dataAttributes, function (key, value) {
            $section.attr(key, value);
        });
        $section.addClass('keditor-ui keditor-component keditor-component-sortable ' + classNames + ' ' + classNames2);
        $section.attr('data-wps-type', snippetType);
        $section.html('<div class="keditor-ui keditor-component-content">' + snippetContent + '</div>');

        var component = $section;

        // Adjust component width when adding to container (same logic as drag-and-drop)
        if (container && container.attr('data-wps-container') === 'true') {
            // Check for an element with class 'col-lg-10 col-xl-9' and data-wps-edit-name="change width" in the component, only the first occurrence
            var $editableCol = component.find('.col-lg-10.col-xl-9[data-wps-edit-name="change width"]').first();
            if ($editableCol.length) {
                $editableCol.removeClass('col-lg-10 col-xl-9').addClass('col-12 px-2');
            }
        }

        // Insert component
        if (insertBefore && insertBefore.length > 0) {
            insertBefore.before(component);
        } else {
            containerContent.append(component);
        }

        // Initialize component
        self.initComponent(contentArea, container, component);

        // Update plus buttons
        self.addPlusButtonsToContainer(containerContent, contentArea, container);

        // Show container toolbar
        if (!container.hasClass('showed-keditor-toolbar')) {
            $('.keditor-container.showed-keditor-toolbar').removeClass('showed-keditor-toolbar');
            container.addClass('showed-keditor-toolbar');
        }

        // Trigger callbacks
        var options = self.options;
        if (typeof options.onContainerChanged === 'function') {
            options.onContainerChanged.call(self, { item: component[0] }, container, contentArea);
        }

        if (typeof options.onContentChanged === 'function') {
            options.onContentChanged.call(self, { item: component[0] }, contentArea);
        }

        self.checkContentArea(component);
        self.window.imgCover.update(self.body[0]);
        self.save();
    };

    KEditor.prototype.convertToComponent = function (contentArea, container, target, isExisting) {
        flog('convertToComponent', contentArea, container, target, isExisting);


        var self = this;
        var isSection = target.is('section');
        var component;

        //console.error("target", target)

        if (isSection) {

            if (target.attr("data-class")) {
                target.addClass(target.attr("data-class"));
            }
            target.addClass('keditor-component keditor-component-sortable');

            if (!target.children().is('div.keditor-component-content')) target.wrapInner('<div class="keditor-ui keditor-component-content"></div>');

            component = target;
        } else {
            target.wrap('<div class="keditor-ui keditor-component keditor-component-sortable"><div class="keditor-ui keditor-component-content"></div></div>');
            if (target.attr("data-class")) {
                target.addClass(target.attr("data-class"));
            }
            component = target.parent().parent();
        }

        if (isExisting) {
            component.addClass('existing-component');
        }



        self.initComponent(contentArea, container, component);
    };

    KEditor.prototype.getDataAttributes = function (target, ignoreAttributes, isArray) {
        var dataAttributes = isArray ? [] : {};
        if (!ignoreAttributes) {
            ignoreAttributes = [];
        }
        //console.log("target", target)




        var attributes = target.get(0).attributes;

        var allAttributes = {};


        for (var i = 0; i < attributes.length; i++) {
            //console.log("attributes[i].value", attributes[i].value);
            var attrName = attributes[i].name;
            var attrValue = attributes[i].value;

            // Store attribute and its value
            allAttributes[attrName] = attrValue;

            // If you need to handle specific JSON-like values, add logic here
            if (attrValue.startsWith('{') && attrValue.endsWith('}')) {
                try {
                    allAttributes[attrName] = JSON.stringify(JSON.parse(attrValue));
                } catch (e) {
                    console.error('Error parsing JSON from attribute ' + attrName + ':', e);
                }
            }
        }
        //console.log("allAttributes",allAttributes);


        // $.each(target.get(0).attributes, function(i, attr) {
        //     if (attr.name.indexOf('data-') === 0 && $.inArray(attr.name, ignoreAttributes) === -1) {
        //         console.log("attr.value", attr.value);
        //         if (attr.value.startsWith('{') && attr.value.endsWith('}')) {
        //             try {
        //                 attr.value = JSON.stringify(JSON.parse(attr.value));
        //             } catch (e) {
        //                 console.error('Error parsing JSON from attribute ' + attrName + ':', e);
        //             }
        //         }
        //         console.log("attr.value", attr.value);
        //         if (isArray) {
        //             dataAttributes.push(attr.name + '="' + attr.value + '"');
        //         } else {
        //             dataAttributes[attr.name] = attr.value;
        //         }
        //     }
        // });
        //console.log("dataAttributes",allAttributes);
        return allAttributes;
    };

    KEditor.prototype.getComponentType = function (component) {
        flog('getComponentType', component);

        var self = this;
        var options = self.options;


        var dataType = component.attr('data-wps-type');
        var componentType = dataType ? dataType.replace(/component-/g, '') : '';
        if (componentType) {
            return componentType;
        } else {
            if (componentType) {
                flog('Component type "' + componentType + '" does not exist');
            } else {
                flog('This component does not contain data-wps-type attribute');
            }

            if (typeof options.defaultComponentType === 'string') {
                componentType = options.defaultComponentType;
            } else if (typeof options.defaultComponentType === 'function') {

                componentType = options.defaultComponentType.call(self, component);
            }

            if (!componentType) {
                error('Component type is undefined!');
            }

            flog('Fallback to defaultComponentType: ' + componentType);

            return componentType;
        }
    };



    KEditor.prototype.initComponent = function (contentArea, container, component) {
        flog('initComponent', contentArea, container, component);

        // console.log('initComponent', contentArea, container, component);



        var self = this;
        var options = self.options;
        var body = self.body;



        if (!component.hasClass('keditor-initialized-component') || !component.hasClass('keditor-initializing-component')) {

            component.addClass('keditor-initializing-component');
            component.attr('id', self.generateId('component'));

            if (typeof options.onBeforeInitComponent === 'function') {
                options.onBeforeInitComponent.call(self, component, contentArea);
            }

            var componentContent = component.children('.keditor-component-content');
            componentContent.attr('id', self.generateId('component-content'));
            console.log("component", component);
            var componentType = self.getComponentType(component);
            console.log("componentType", componentType);
            flog('Component type: ' + componentType);




            var componentData;

            if (componentType != "blank") {
                componentData = KEditor.components["text"];
            } else {
                componentData = KEditor.components[componentType];
            }




            var isSettingEnabled = componentData.settingEnabled;
            // Components without data-wps-type fall back to the "blank" type; still
            // show the settings button when the content carries editable elements.
            if (!isSettingEnabled && component.find('[data-wps-edit]').length > 0) {
                isSettingEnabled = true;
            }
            var settingBtn = '';
            if (isSettingEnabled) {
                settingBtn = '<a href="javascript:void(0);" class="keditor-ui btn-component-setting">' + options.btnSettingComponentText + '</a>';
            }

            flog('Render KEditor toolbar for component', component);

            /*component.append(
                '<div class="keditor-toolbar keditor-toolbar-component">' +
                '   <a title="Reposition" href="javascript:void(0);" class="keditor-ui btn-component-reposition">' + options.btnMoveComponentText + '</a>' +
                '   <a title="Move up" href="javascript:void(0);" class="keditor-ui btn-component-moveup">' + options.btnMoveUp + '</a>' +
                '   <a title="Move down" href="javascript:void(0);" class="keditor-ui btn-component-movedown">' + options.btnMoveDown + '</a>' +

                //settingBtn +
                '   <a title="Duplicate" href="javascript:void(0);" class="keditor-ui btn-component-duplicate">' + options.btnDuplicateComponentText + '</a>' +
                '   <a title="Delete" href="javascript:void(0);" class="keditor-ui btn-component-delete">' + options.btnDeleteComponentText + '</a>' +
                //'   <a href="javascript:void(0);" class="keditor-ui btn-component-update">' + options.btnUpdateComponentText + '</a>' +
                '</div>'
            );*/




            if (self.privileges.includes('can_edit_page') || self.options.isSysAdmin) {

                console.warn(component.find('[data-wps-edit-name2="spacing"]'));

                var _paddingTop = '';
                var _paddingBottom = '';
                var _paddingTopIcon = "fa-arrow-down";
                var _paddingBottomIcon = "fa-arrow-up";
                var _spacing = component.find('[data-wps-edit-name2="spacing"]')
                if (_spacing.length > 0 && _spacing.hasClass("pt-0i")) {
                    _paddingTopIcon = "fa-arrow-up";
                }
                if (_spacing.length > 0 && _spacing.hasClass("pb-0i")) {
                    _paddingBottomIcon = "fa-arrow-down";
                }
                if (_spacing.length > 0){
                    _paddingTop = '<button type="button" class="component-btn btn-component-paddingTop"><i class="fa ' + _paddingTopIcon + '"></i></button>';
                    _paddingBottom = '<button type="button" class="component-btn btn-component-paddingBottom"><i class="fa ' + _paddingBottomIcon + '"></i></button>';
                }
                var _lock = '';
                if (self.privileges.includes('can_lock_snippets') || self.options.isSysAdmin) {
                    self.body.addClass("webmag_lock_admin");
                    _lock = '<button class="dropdown-item btn-component-lock" type="button"><i class="fa fa-lock" aria-hidden="true"></i> ' + self.labels.lock + '</button>';
                }

                // var _paddingLeftIcon = "fa-arrows-h";
                // var _paddingRightIcon = "fa-arrows-h";
                var _resize = '';
                if (component.find("[data-wps-resize-h]").length > 0) {
                    _resize = '<button type="button" class="component-btn btn-component-resize"><i class="fa fa-arrows-h"></i></button>';
                }

                component.append(
                    _paddingTop +
                    _paddingBottom +
                    // '<button type="button" class="component-btn btn-component-paddingLeft"><i class="fa '+_paddingLeftIcon+'"></i></button>' +
                    // '<button type="button" class="component-btn btn-component-paddingRight"><i class="fa '+_paddingRightIcon+'"></i></button>' +
                    '<div class="keditor-toolbar keditor-toolbar-component">' +

                    '<div class="btn-group" role="group" aria-label="Button group with nested dropdown">' +
                    //'<button type="button" class="component-btn btn-component-add-element" title="Add element"><i class="fa fa-plus"></i></button>' +
                    //'<button type="button" class="component-btn keditor-toolbar-component-settings btn-component-setting"><i class="fa fa-pencil"></i></button>' +

                    //'<button title="New snippet update available" href="javascript:void(0);" class="component-btn btn-component-update">' + options.btnUpdateComponentText+  '</button>' +
                    _resize +
                    '<button type="button" class="component-btn btn-component-reposition"><i class="fa fa-arrows"></i></button>' +
                    '<button type="button" class="component-btn btn-component-moveup"><i class="fa fa-long-arrow-up" aria-hidden="true"></i></button>' +
                    '<button type="button" class="component-btn btn-component-movedown"><i class="fa fa-long-arrow-down" aria-hidden="true"></i></button>' +


                    '<div class="btn-group dropdown" role="group">' +
                    '<button id="btnGroupDrop1" type="button" class="component-btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="fa fa-sort-desc"></i></button>' +
                    '<div class="dropdown-menu dropdown-menu-right" aria-labelledby="btnGroupDrop1">' +
                    '<button class="dropdown-item btn-component-edit" type="button"><i class="fa fa-pencil" aria-hidden="true"></i> ' + self.labels.edit + '</button>' +
                    '<button class="dropdown-item btn-component-select" type="button"><i class="fa fa-check-square-o" aria-hidden="true"></i> ' + self.labels.select + '</button>' +
                    '<button class="dropdown-item btn-component-duplicate" type="button"><i class="fa fa-clone" aria-hidden="true"></i> ' + self.labels.duplicate + '</button>' +
                    '<button class="dropdown-item btn-component-copy" type="button"><i class="fa fa-files-o" aria-hidden="true"></i> ' + self.labels.copy + '</button>' +
                    '<button class="dropdown-item btn-component-paste" type="button"><i class="fa fa-clipboard" aria-hidden="true"></i> ' + self.labels.paste + '</button>' +
                    '<button class="dropdown-item btn-component-hide" type="button"><i class="fa fa-eye-slash" aria-hidden="true"></i> ' + self.labels.showhide + '</button>' +
                    _lock +
                    '<div class="dropdown-divider"></div>' +
                    '<button class="dropdown-item btn-component-delete" type="button"><i class="fa fa-trash" aria-hidden="true"></i> ' + self.labels.delete + '</button>' +
                    '</div>' +
                    // Add a checkbox inside the dropdown menu for enabling/disabling something, for example a "fixed width" feature.
                    '</div>' +
                    '<div class="d-none component-btn btn-component-checkbox d-flex justify-content-center align-items-center" style="">' +
                    '<input type="checkbox" class="" style="">' +
                    '</div>' +
                    '</div>' +
                    '</div>'
                )

                //toggle dropdown
                component.find('.dropdown-toggle').click(function () {

                    var _clone = JSON.parse(window.localStorage.getItem('clonedElements'));
                    if (!_clone) {
                        $(this).parent().find(".dropdown-menu .btn-component-paste").hide();
                    } else {
                        $(this).parent().find(".dropdown-menu .btn-component-paste").show();
                    }

                })



                component.append(
                    '<div title="Snippet Settings" class="keditor-toolbar keditor-toolbar-component-settings">' +
                    settingBtn +
                    //'   <a title="Update Snippet" href="javascript:void(0);" class="keditor-ui btn-component-update">' + options.btnUpdateComponentText + '</a>' +
                    '</div>'
                );

                component.find('[data-dynamic-href]').each(function () {
                    var dynamicElement = $(this);

                    self.initDynamicContent(dynamicElement);
                });


            }

            var snip;



            //self.options.template.init(false, component);

            //console.error("componentType", componentType)
            var multipleTypes = componentType.split(',');
            console.log("multipleTypes", multipleTypes);
            $(multipleTypes).each(function (index, el) {
                //console.log("el",el);
                //console.log(p$.snippet[el])
                if (self.window.p$.snippet && self.window.p$.snippet[el]) { //if this snippet has a js file
                    console.log("init snippet", el);
                    snip = new self.window.p$.snippet[el](); // create snippet
                    if (typeof snip.clear === 'function') snip.clear(component);
                    snip.init(component); // init snippet
                }
            });

            if (typeof self.options.template.afterUpdate == 'function') self.options.template.afterUpdate(self);



            if (typeof componentData.init === 'function') {
                componentData.init.call(componentData, contentArea, container, component, self);

            } else {
                body.removeClass('highlighted-container-content');
                flog('"init" function of component type "' + componentType + '" does not exist');
            }

            if (typeof options.onInitComponent === 'function') {
                options.onInitComponent.call(self, component, contentArea);
            }

            component.addClass('keditor-initialized-component');
            component.removeClass('keditor-initializing-component');
        } else {
            if (component.hasClass('keditor-initialized-component')) {
                flog('Component is already initialized!');
            } else {
                flog('Component is initializing...');
            }
        }


    };

    KEditor.prototype.reinitComponent = function (contentArea, container, component) {
        flog('initComponent', contentArea, container, component);

        //console.log('reinitComponent', contentArea, container, component);

        var self = this;
        var options = self.options;
        var body = self.body;


        if (!component.hasClass('keditor-initialized-component') || !component.hasClass('keditor-initializing-component')) {
            component.addClass('keditor-initializing-component');
            component.attr('id', self.generateId('component'));

            if (typeof options.onBeforeInitComponent === 'function') {
                options.onBeforeInitComponent.call(self, component, contentArea);
            }

            var componentContent = component.children('.keditor-component-content');
            componentContent.attr('id', self.generateId('component-content'));

            var componentType = self.getComponentType(component);
            flog('Component type: ' + componentType);


            var componentData;

            if (componentType != "blank") {
                componentData = KEditor.components["text"];
            } else {
                componentData = KEditor.components[componentType];
            }

            var isSettingEnabled = componentData.settingEnabled;
            // Same fallback as in initComponent for components without data-wps-type.
            if (!isSettingEnabled && component.find('[data-wps-edit]').length > 0) {
                isSettingEnabled = true;
            }
            var settingBtn = '';
            if (isSettingEnabled) {
                settingBtn = '<a href="javascript:void(0);" class="keditor-ui btn-component-setting">' + options.btnSettingComponentText + '</a>';
            }

            flog('Render KEditor toolbar for component', component);

            var toolbar = component.find(".keditor-toolbar");
            if (toolbar.length > 0) {
                toolbar.remove();
            }

            var _lock = '';
            if (self.privileges.includes('can_lock_snippets') || self.options.isSysAdmin) {
                self.body.addClass("webmag_lock_admin");
                _lock = '<button class="dropdown-item btn-component-lock" type="button"><i class="fa fa-lock" aria-hidden="true"></i> ' + self.labels.lock + '</button>';
            }


            /*component.append(
                '<div class="keditor-toolbar keditor-toolbar-component">' +
                '   <a href="javascript:void(0);" class="keditor-ui btn-component-reposition">' + options.btnMoveComponentText + '</a>' +
                settingBtn +
                '   <a href="javascript:void(0);" class="keditor-ui btn-component-duplicate">' + options.btnDuplicateComponentText + '</a>' +
                '   <a href="javascript:void(0);" class="keditor-ui btn-component-delete">' + options.btnDeleteComponentText + '</a>' +
                '   <a href="javascript:void(0);" class="keditor-ui btn-component-update">' + options.btnUpdateComponentText + '</a>' +
                '</div>'
            );*/
            component.append(
                '<div class="keditor-toolbar keditor-toolbar-component">' +
                '<div class="btn-group" role="group" aria-label="Button group with nested dropdown">' +
                //'<button type="button" class="component-btn btn-component-add-element" title="Add element"><i class="fa fa-plus"></i></button>' +
                '<button type="button" class="component-btn keditor-toolbar-component-settings btn-component-setting"><i class="fa fa-pencil"></i></button>' +

                //'<button type="button" title="New snippet update available"  href="javascript:void(0);" class="component-btn btn-component-update">' + options.btnUpdateComponentText + '</button>' +
                '<button type="button" class="component-btn btn-component-resize"><i class="fa fa-arrows-h"></i></button>' +
                '<button type="button" class="component-btn btn-component-reposition"><i class="fa fa-arrows"></i></button>' +
                '<button type="button" class="component-btn btn-component-moveup"><i class="fa fa-long-arrow-up" aria-hidden="true"></i></button>' +
                '<button type="button" class="component-btn btn-component-movedown"><i class="fa fa-long-arrow-down" aria-hidden="true"></i></button>' +


                '<div class="btn-group dropdown" role="group">' +
                '<button id="btnGroupDrop1" type="button" class="component-btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="fa fa-sort-desc"></i></button>' +
                '<div class="dropdown-menu dropdown-menu-right" aria-labelledby="btnGroupDrop1">' +
                '<button class="dropdown-item btn-component-edit" type="button"><i class="fa fa-pencil" aria-hidden="true"></i> ' + self.labels.edit + '</button>' +
                '<button class="dropdown-item btn-component-select" type="button"><i class="fa fa-check-square-o" aria-hidden="true"></i> ' + self.labels.select + '</button>' +
                '<button class="dropdown-item btn-component-duplicate" type="button"><i class="fa fa-clone" aria-hidden="true"></i> ' + self.labels.duplicate + '</button>' +
                '<button class="dropdown-item btn-component-copy" type="button"><i class="fa fa-files-o" aria-hidden="true"></i> ' + self.labels.copy + '</button>' +
                '<button class="dropdown-item btn-component-paste" type="button"><i class="fa fa-clipboard" aria-hidden="true"></i> ' + self.labels.paste + '</button>' +
                '<button class="dropdown-item btn-component-hide" type="button"><i class="fa fa-eye-slash" aria-hidden="true"></i> ' + self.labels.showhide + '</button>' +
                _lock +
                '<div class="dropdown-divider"></div>' +
                '<button class="dropdown-item btn-component-delete" type="button"><i class="fa fa-trash" aria-hidden="true"></i> ' + self.labels.delete + '</button>' +
                '</div>' +
                '</div>' +
                '<div class="d-none component-btn btn-component-checkbox d-flex justify-content-center align-items-center" style="">' +
                '<input type="checkbox" class="" style="">' +
                '</div>' +
                '</div>' +
                '</div>');
            //toggle dropdown
            component.find('.dropdown-toggle').click(function () {
                return;
                var _clone = window.parent._AMS.clonedElements;

                if (!_clone) {
                    $(this).parent().find(".dropdown-menu .btn-component-paste").hide();
                } else {
                    $(this).parent().find(".dropdown-menu .btn-component-paste").show();
                }
                $(this).parent().find(".dropdown-menu").toggleClass("show")
            })

            /*component.append(
                '<div class="keditor-toolbar keditor-toolbar-component">' +
                '   <a title="Reposition" href="javascript:void(0);" class="keditor-ui btn-component-reposition">' + options.btnMoveComponentText + '</a>' +
                '   <a title="Move up" href="javascript:void(0);" class="keditor-ui btn-component-moveup">' + options.btnMoveUp + '</a>' +
                '   <a title="Move down" href="javascript:void(0);" class="keditor-ui btn-component-movedown">' + options.btnMoveDown + '</a>' +

                //settingBtn +
                '   <a title="Duplicate" href="javascript:void(0);" class="keditor-ui btn-component-duplicate">' + options.btnDuplicateComponentText + '</a>' +
                '   <a title="Delete" href="javascript:void(0);" class="keditor-ui btn-component-delete">' + options.btnDeleteComponentText + '</a>' +
                //'   <a href="javascript:void(0);" class="keditor-ui btn-component-update">' + options.btnUpdateComponentText + '</a>' +
                '</div>'
            );*/

            component.append(
                '<div title="Snippet Settings" class="keditor-toolbar keditor-toolbar-component-settings">' +
                settingBtn +
                //'   <a title="Update Snippet" href="javascript:void(0);" class="keditor-ui btn-component-update">' + options.btnUpdateComponentText + '</a>' +
                '</div>'
            );

            component.find('[data-dynamic-href]').each(function () {
                var dynamicElement = $(this);

                self.initDynamicContent(dynamicElement);
            });

            var snip;


            var multipleTypes = componentType.split(',');

            $(multipleTypes).each(function (index, el) {

                if (self.window.p$.snippet && self.window.p$.snippet[el]) { //if this snippet has a js file
                    snip = new self.window.p$.snippet[el](); // create snippet
                    if (typeof snip.clear === 'function') snip.clear(component);
                    snip.init(component) // init snippet
                }
            });






            if (typeof componentData.init === 'function') {
                componentData.init.call(componentData, contentArea, container, component, self);
            } else {
                body.removeClass('highlighted-container-content');
                flog('"init" function of component type "' + componentType + '" does not exist');
            }

            if (typeof options.onInitComponent === 'function') {
                options.onInitComponent.call(self, component, contentArea);
            }

            component.addClass('keditor-initialized-component');
            component.removeClass('keditor-initializing-component');
        } else {
            if (component.hasClass('keditor-initialized-component')) {
                flog('Component is already initialized!');

            } else {
                flog('Component is initializing...');
            }
        }

        self.checkContentArea(contentArea);

        //console.log(self.body[0])
        self.window.imgCover.update(self.body[0]);


        if (window.universalParallax) {
            new universalParallax().init({
                speed: 100,
                container: self.body[0]
            });
        }

        self.save();

    };



    KEditor.prototype.getClickedElement = function (event, selector) {
        var target = $(event.target);
        var closest = target.closest(selector);

        if (target.is(selector)) {
            return target;
        } else if (closest.length > 0) {
            return closest;
        } else {
            return null;
        }
    };

    KEditor.prototype.initKEditorClicks = function () {
        flog('initKEditorClicks');

        var self = this;
        var options = self.options;
        var body = self.body;

        body.on('click', function (e) {
            var sidebar = self.getClickedElement(e, '#keditor-sidebar');

            var container = self.getClickedElement(e, '.keditor-container');
            if (container) {
                if (!container.hasClass('showed-keditor-toolbar')) {
                    body.find('.keditor-container.showed-keditor-toolbar').removeClass('showed-keditor-toolbar');
                    body.find('.keditor-component.showed-keditor-toolbar').removeClass('showed-keditor-toolbar');
                    container.addClass('showed-keditor-toolbar');

                    var contentArea = container.parent();
                    if (typeof options.onContainerSelected === 'function') {
                        options.onContainerSelected.call(self, e, container, contentArea);
                    }
                }
            } else {
                if (!sidebar) {
                    body.find('.keditor-container.showed-keditor-toolbar').removeClass('showed-keditor-toolbar');
                    body.find('.keditor-component.showed-keditor-toolbar').removeClass('showed-keditor-toolbar');
                }
            }

            var component = self.getClickedElement(e, '.keditor-component');
            if (component) {
                if (!component.hasClass('showed-keditor-toolbar')) {
                    body.find('.keditor-component.showed-keditor-toolbar').removeClass('showed-keditor-toolbar');
                    component.addClass('showed-keditor-toolbar');

                    var contentArea = component.parent();
                    if (typeof options.onComponentSelected === 'function') {
                        options.onComponentSelected.call(self, e, component, contentArea);
                    }
                }
            } else {
                if (!sidebar) {
                    body.find('.keditor-component.showed-keditor-toolbar').removeClass('showed-keditor-toolbar');
                }
            }
        });

        body.on('click', '.btn-container-setting', function (e) {
            e.preventDefault();

            var btn = $(this);
            flog('Click on .btn-container-setting', btn);

            var container = btn.closest('.keditor-container');
            if (body.hasClass('opened-keditor-setting') && body.hasClass('opened-keditor-sidebar')) {
                if (!container.is(self.getSettingContainer())) {
                    self.hideSettingPanel();
                    setTimeout(function () {
                        self.showSettingPanel(component, e);
                    }, 300);
                } else {
                    self.hideSettingPanel();
                }
            } else {
                self.showSettingPanel(container, e);
            }
        });

        body.on('click', '.keditor-plus-button', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $plusBtn = $(this);
            var containerContent = $plusBtn.parent();
            var container = containerContent.closest('.keditor-container');
            var contentArea = container.parent();

            // Insert before the plus button so it stays visible underneath
            self.showElementSnippetModal(containerContent, contentArea, container, $plusBtn);
        });

        body.on('click', '.btn-component-add-element', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var btn = $(this);
            var component = btn.closest('.keditor-component-sortable');
            var container = component.closest('.keditor-container');

            // Find containerContent - it's the direct child of container that contains components
            var containerContent = container.find('.keditor-container-content').first();
            if (containerContent.length === 0) {
                // Fallback: if no .keditor-container-content, use the container's direct child that contains the component
                containerContent = component.parent();
            }

            var contentArea = container.parent();

            // Insert before the component so it appears above
            self.showElementSnippetModal(containerContent, contentArea, container, component);
        });

        // body.on('click', '.btn-container-duplicate2', function(e) {
        //     e.preventDefault();


        //     var btn = $(this);
        //     flog('Click on .btn-container-duplicate', btn);

        //     var container = btn.closest('.keditor-container');
        //     var contentArea = container.parent();
        //     var newContainer = $(self.getContainerContent(container, btn.parent().hasClass('keditor-toolbar-sub-container')));
        //     container.after(newContainer);
        //     self.convertToContainer(contentArea, newContainer);

        //     var snippetsList = body.find('#keditor-snippets-list');
        //     var componentSnippets = snippetsList.find('.keditor-snippet[data-wps-type^=component]');
        //     //var currentLinkedContainerContents = componentSnippets.draggable('option', 'connectToSortable');
        //    // componentSnippets.draggable('option', 'connectToSortable', currentLinkedContainerContents.add(newContainer.find('.keditor-container-content')));

        //     flog('Container is duplicated');

        //     if (typeof options.onContainerDuplicated === 'function') {
        //         options.onContainerDuplicated.call(self, container, newContainer, contentArea);
        //     }

        //     if (typeof options.onContentChanged === 'function') {
        //         options.onContentChanged.call(self, e, contentArea);
        //     }
        // });
        // Modify the existing click handler for select button
        body.on('click', '.btn-container-select', function (e) {
            e.preventDefault();
            var btn = $(this);
            var component = btn.closest('.keditor-container');

            if (component.hasClass("webmag_selected")) {
                component.removeClass("webmag_selected");
            } else {
                component.addClass("webmag_selected");
            }

            //hide dropdown
            component.find('.dropdown-toggle').trigger("click");

            // Update selection widget
            self.updateSelectionWidget();

        });
        body.on('click', '.btn-container-edit', function (e) {
            e.preventDefault();
            var btn = $(this);
            var container = btn.closest('.keditor-container');
            $(container).children(".keditor-toolbar-component-settings").find(".btn-container-setting").trigger("click");

        })

        body.on('click', '.btn-container-duplicate', function (e) {
            e.preventDefault();

            var btn = $(this);
            flog('Click on .btn-container-duplicate', btn);

            var container = btn.closest('.keditor-container');
            var contentArea = container.parent();
            var _clone = container.clone(true, true);

            _clone = self.cleanFroalaContent(_clone);

            // var newContainer = container.clone(true, true);

            var newContainer = $(self.cleanContainerContent(container, true));
            var snippetContent = newContainer.html();
            if (newContainer.find("> .keditor-component-content").length == 0) {
                newContainer.html('<div class="keditor-ui keditor-component-content">' + snippetContent + '</div>');
            }

            container.after(newContainer);
            // container = newContainer.closest('.keditor-container');
            // self.initContainerContent(contentArea, container, newContainer, false);

            self.addImageHandler(newContainer);
            self.initPaddingDragHandlers(newContainer);

            self.convertToContainer(contentArea, newContainer);

            self.checkContentArea(contentArea);

            flog('Container is duplicated');


            //hide dropdown
            container.find('.dropdown-toggle').trigger("click");

            self.save();
        });
        body.on('click', '.btn-container-paste', function (e) {
            e.preventDefault();
            var btn = $(this);

            self.save();
        });

        body.on('click', '.btn-container-delete', function (e) {
            e.preventDefault();

            var btn = $(this);
            flog('Click on .btn-container-delete', btn);

            if (confirm('Wollen Sie das Snippet wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!')) {
                var container = btn.closest('.keditor-container');
                var components = container.find('.keditor-component');
                var contentArea = container.parent();

                if (typeof options.onBeforeContainerDeleted === 'function') {
                    options.onBeforeContainerDeleted.call(self, e, container, contentArea);
                }

                var settingComponent = self.getSettingComponent();
                if (settingComponent) {
                    var settingComponentParent = settingComponent.closest('.keditor-container');
                    if (settingComponentParent.is(container)) {
                        flog('Deleting container is container of setting container. Close setting panel for this setting component', settingComponent);
                        self.hideSettingPanel();
                    }
                } else if (self.getSettingContainer().is(container)) {
                    flog('Deleting container is setting container. Close setting panel for this container', container);
                    self.hideSettingPanel();
                }

                if (components.length > 0) {
                    components.each(function () {
                        self.deleteComponent($(this));
                    });
                }




                container.remove();


                if (typeof options.onContainerDeleted === 'function') {
                    options.onContainerDeleted.call(self, e, container, contentArea);
                }

                if (typeof options.onContentChanged === 'function') {
                    options.onContentChanged.call(self, e, contentArea);
                }
            }
        });

        body.on('click', '.btn-component-setting', function (e) {
            e.preventDefault();

            var body = self.body;

            var btn = $(this);
            flog('Click on .btn-component-setting', btn);

            var component = btn.closest('.keditor-component-sortable');
            if (body.hasClass('opened-keditor-setting') && body.hasClass('opened-keditor-sidebar')) {
                if (!component.is(self.getSettingComponent())) {

                    self.hideSettingPanel();
                    setTimeout(function () {
                        self.showSettingPanel(component, e);
                    }, 300);

                } else {

                    self.hideSettingPanel();
                }
                self.hideSettingPanel();
            } else {
                self.showSettingPanel(component, e);
            }
        });


        body.on('click', '.btn-component-moveup', function (e) {

            e.preventDefault();

            var btn = $(this);
            flog('Click on .btn-component-moveup', btn);

            var component = btn.closest('.keditor-component-sortable');
            var container = component.closest('.keditor-container');
            var contentArea = container.parent();

            component.prev().insertAfter(component);


            self.iframeBody.scrollTop(component.offset().top)


            flog('Component is moved up');


            self.save();

        });

        body.on('click', '.btn-component-movedown', function (e) {

            e.preventDefault();

            var btn = $(this);
            flog('Click on .btn-component-moveup', btn);

            var component = btn.closest('.keditor-component-sortable');
            var container = component.closest('.keditor-container');
            var contentArea = container.parent();

            component.next().insertBefore(component);
            self.iframeBody.scrollTop(component.offset().top)

            flog('Component is moved down');


            self.save();

        });

        body.on('click', '.btn-component-resize', function (e) {

            e.preventDefault();

            var btn = $(this);
            flog('Click on .btn-component-resize', btn);

            var component = btn.closest('.keditor-component-sortable');
            var container = component.closest('.keditor-container');
            var contentArea = container.parent();
            var _rh, _cc, _options, _start, _classArray = [];


            //console.log(component, container, contentArea);

            _rh = component.find("[data-wps-resize-h]");
            // console.log("_rh",_rh);
            if (_rh.length > 0) {
                //console.log("_rh[0]",_rh[0]);
                _rh = _rh.eq(0);

                _cc = _rh.attr("data-wps-class-change");
                //console.log("_cc",_cc);
                if (_cc) {
                    _options = _cc.split('|');
                    //console.log("_options",_options);
                    $.each(_options, function (index, val) {
                        _classArray.push(val.split('=')[1]);
                    });
                    //console.log("_classArray", _classArray);
                    $.each(_classArray, function (index, val) {
                        if (_rh.hasClass(val)) {
                            _start = val;
                            return;
                        }
                    });
                    //console.log("_start", _start);
                    var next = _classArray[($.inArray(_start, _classArray) + 1) % _classArray.length];
                    _rh.removeClass(_start).addClass(next);
                    //console.log("next", next);
                }
            }





            self.save();

        });



        // Modify the existing click handler for select button
        body.on('click', '.btn-component-select', function (e) {
            e.preventDefault();
            var btn = $(this);
            var component = btn.closest('.keditor-component-sortable');

            if (component.hasClass("webmag_selected")) {
                component.removeClass("webmag_selected");
                component.find('.btn-component-checkbox input[type="checkbox"]').prop('checked', false);
            } else {
                component.addClass("webmag_selected");
                component.find('.btn-component-checkbox input[type="checkbox"]').prop('checked', true);
            }

            //hide dropdown
            component.find('.dropdown-toggle').trigger("click");

            // Update selection widget (this will show all checkboxes if any are selected)
            self.updateSelectionWidget();

        });

        // Handle checkbox click to toggle selection
        body.on('click', '.btn-component-checkbox input[type="checkbox"]', function (e) {
            e.stopPropagation();
            var checkbox = $(this);
            var component = checkbox.closest('.keditor-component-sortable');

            if (checkbox.is(':checked')) {
                component.addClass("webmag_selected");
            } else {
                component.removeClass("webmag_selected");
            }

            // Update selection widget
            self.updateSelectionWidget();
        });


        body.on('click', '.btn-component-edit', function (e) {
            e.preventDefault();
            var btn = $(this);
            // Scope to the component itself instead of 'section.section': components
            // without the snippet's "section" class would otherwise resolve to the
            // surrounding container and trigger the setting buttons of ALL siblings.
            var component = btn.closest('.keditor-component-sortable');
            component.find(".btn-component-setting").first().trigger("click");

        })
        body.on('click', '.btn-component-duplicate', function (e) {
            e.preventDefault();

            var btn = $(this);
            flog('Click on .btn-component-duplicate', btn);

            var component = btn.closest('.keditor-component-sortable');
            var container = component.closest('.keditor-container');
            var contentArea = container.parent();
            var _clone = component.clone(true, true);

            _clone = self.cleanFroalaContent(_clone);
            _clone = self.regenerateInlineCollapsibleIds(_clone);

            var newComponent = $(self.getComponentContent(_clone));

            component.after(newComponent);

            self.addImageHandler(newComponent);
            self.initPaddingDragHandlers(newComponent);


            self.convertToComponent(contentArea, container, newComponent);

            self.checkContentArea(contentArea);

            flog('Component is duplicated');

            if (typeof options.onComponentDuplicated === 'function') {
                options.onComponentDuplicated.call(self, component, newComponent, contentArea);
            }

            if (typeof options.onContainerChanged === 'function') {
                options.onContainerChanged.call(self, e, container, contentArea);
            }

            if (typeof options.onContentChanged === 'function') {
                options.onContentChanged.call(self, e, contentArea);
            }
            //hide dropdown
            component.find('.dropdown-toggle').trigger("click");

            self.save();
        });

        body.on('click', '.btn-component-delete', function (e) {
            e.preventDefault();

            var btn = $(this);
            flog('Click on .btn-component-delete', btn);


            if (typeof self.options.callFromKeditor === 'function') self.options.callFromKeditor("deleteSnippetModal", null, function () {
                var component = btn.closest('.keditor-component-sortable');
                var container = component.closest('.keditor-container');
                var contentArea = component.closest('.keditor-content-area');

                if (typeof options.onBeforeComponentDeleted === 'function') {
                    options.onBeforeComponentDeleted.call(self, e, component, contentArea);
                }

                if (self.getSettingComponent().is(component)) {
                    self.hideSettingPanel();
                }

                // clone body
                var clonedBody = body.clone(true);
                // delete current component
                clonedBody.find("#" + component.attr('id')).remove();

                var _imgs = component.find("img[data-wps-edit]"),
                    _allimgs = clonedBody.find("img[data-wps-edit]"),
                    _allimgs_arr = [];


                var _id;
                $.each(_allimgs, function (index, el) {
                    _id = $(el).attr("data-id");
                    if (_id) _allimgs_arr.push(_id);
                })

                $.each(_imgs, function (index, el) {
                    var _id = $(el).attr("data-id");
                });

                self.deleteComponent(component);


                self.save();

                if (typeof options.onComponentDeleted === 'function') {
                    options.onComponentDeleted.call(self, e, component, contentArea);
                }

                if (typeof options.onContainerChanged === 'function') {
                    options.onContainerChanged.call(self, e, container, contentArea);
                }

                if (typeof options.onContentChanged === 'function') {
                    options.onContentChanged.call(self, e, contentArea);
                }
            });


        });
        body.on('click', '.btn-component-hide', function (e) {
            e.preventDefault();
            var btn = $(this);
            var component = btn.closest('.keditor-component-sortable');
            var container = component.closest('.keditor-container');
            var contentArea = container.parent();
            if (component.hasClass("webmag_hide")) component.removeClass("webmag_hide");
            else component.addClass("webmag_hide");
            //hide dropdown
            component.find('.dropdown-toggle').trigger("click");
            self.save();
        });
        body.on('click', '.btn-component-lock', function (e) {
            e.preventDefault();
            var btn = $(this);
            var component = btn.closest('.keditor-component-sortable');
            var container = component.closest('.keditor-container');
            var contentArea = container.parent();
            if (component.hasClass("webmag_lock")) component.removeClass("webmag_lock");
            else component.addClass("webmag_lock");
            //hide dropdown
            component.find('.dropdown-toggle').trigger("click");
            self.save();
        });
        body.on('click', '.btn-component-copy', function (e) {
            e.preventDefault();
            var btn = $(this);
            var component = btn.closest('.keditor-component-sortable');
            var container = component.closest('.keditor-container');
            var contentArea = container.parent();


            _ls = [
                {
                    clone: component.clone(true, true).wrap("<div />").parent().html()
                }
            ]

            try {
                window.localStorage.setItem('clonedElements', JSON.stringify(_ls));
            } catch (storageErr) {
                console.warn('[KEditor] localStorage full on copy, clearing editor history and retrying:', storageErr);
                try {
                    window.localStorage.removeItem('v2_editor_history');
                    window.localStorage.setItem('clonedElements', JSON.stringify(_ls));
                } catch (retryErr) {
                    console.warn('[KEditor] Retry failed, clearing all editor storage:', retryErr);
                    try {
                        window.localStorage.removeItem('v2_editor_history');
                        window.localStorage.removeItem('webmag_clipboard');
                        window.localStorage.setItem('clonedElements', JSON.stringify(_ls));
                    } catch (finalErr) {
                        console.error('[KEditor] Cannot write to localStorage:', finalErr);
                    }
                }
            }


            if (typeof self.options.callFromKeditor === 'function') self.options.callFromKeditor("makeToast", {
                message: self.labels.copySnippet

            }, function (data) {

            })


            //hide dropdown
            component.find('.dropdown-toggle').trigger("click");

        });
        body.on('click', '.btn-component-paste', function (e) {
            e.preventDefault();
            var btn = $(this);

            var _clone = JSON.parse(window.localStorage.getItem('clonedElements'));
            if (!_clone && _clone.length == 0) {
                return;
            }


            var item = btn.closest('.keditor-component-sortable');
            var container = item.closest('.keditor-container');
            var contentArea = container.parent();
            var isContainer = false;

            $.each(_clone, function (index, val) {
                //iterate through array or object
                _clone = $(val.clone);
                //console.log("_clone", _clone[0].outerHTML);
                _clone = self.cleanFroalaContent(_clone);
                _clone = self.regenerateInlineCollapsibleIds(_clone);

                isContainer = _clone.hasClass("keditor-sub-container");
                //console.log("isContainer",isContainer, _clone);
                //console.log("item", item);


                if (isContainer) {
                    //var newItem = $(self.getContainerContent(_clone , true));
                    var newContainer = $(self.cleanContainerContent(_clone, true));
                    var snippetContent = newContainer.html();
                    if (newContainer.find("> .keditor-component-content").length == 0) {
                        console.log("add comnpnent content")
                        newContainer.html('<div class="keditor-ui keditor-component-content">' + snippetContent + '</div>');
                    }
                    // console.log("newItem", newItem);
                    // if item is in a container (closest .keditor-sub-container)
                    console.log("item", item);
                    if (item.parent().closest('section').hasClass('keditor-sub-container')) {
                        if (typeof self.options.callFromKeditor === 'function') self.options.callFromKeditor("makeToast", {
                            message: self.labels.pasteSnippetDenial
                        }, function (data) {

                        })
                    } else {
                        item.before(newContainer);
                    }



                } else {
                    var newItem = $(self.getComponentContent(_clone));
                    //console.log("newItem2", newItem);
                    item.before(newItem);
                }

                // Use the appropriate element based on whether it's a container or component
                var elementToProcess = isContainer ? newContainer : newItem;

                if (elementToProcess && elementToProcess.length) {
                    self.addImageHandler(elementToProcess);
                    self.initPaddingDragHandlers(elementToProcess);
                }

                if (isContainer) {

                    self.convertToContainer(contentArea, newContainer);

                } else {
                    self.convertToComponent(contentArea, container, newItem);
                }

                self.checkContentArea(contentArea);

            });
            //hide dropdown
            item.find('.dropdown-toggle').trigger("click");

            self.save();
        });


        body.on('click', '.btn-component-paddingTop', function (e) {
            e.preventDefault();
            var btn = $(this);
            var component = btn.closest('.keditor-component-sortable');
            var container = component.closest('.keditor-container');
            var contentArea = container.parent();
            var _spacing = component.find('[data-wps-edit-name2="spacing"]');

            if (_spacing.length > 0) {
                if (btn.find("i").hasClass("fa-arrow-up")) {
                    _spacing.eq(0).removeClass("pt-0i")
                    btn.find("i").removeClass("fa-arrow-up").addClass("fa-arrow-down");
                }
                else if (btn.find("i").hasClass("fa-arrow-down")) {
                    _spacing.eq(0).addClass("pt-0i")
                    btn.find("i").removeClass("fa-arrow-down").addClass("fa-arrow-up");
                }
                self.save();
            }
        })

        body.on('click', '.btn-component-paddingBottom', function (e) {
            e.preventDefault();
            var btn = $(this);
            var component = btn.closest('.keditor-component-sortable');
            var container = component.closest('.keditor-container');
            var contentArea = container.parent();

            var _spacing = component.find('[data-wps-edit-name2="spacing"]')
            //console.log("_spacing",_spacing);
            if (_spacing.length > 0) {
                if (btn.find("i").hasClass("fa-arrow-up")) {
                    _spacing.eq(0).addClass("pb-0i")
                    btn.find("i").removeClass("fa-arrow-up").addClass("fa-arrow-down");
                }
                else if (btn.find("i").hasClass("fa-arrow-down")) {
                    _spacing.eq(0).removeClass("pb-0i")
                    btn.find("i").removeClass("fa-arrow-down").addClass("fa-arrow-up");
                }
                self.save();
            }
        })

        body.on('click', '.btn-component-update', function (e) {
            return;
            e.preventDefault();

            var btn = $(this);
            flog('Click on .btn-component-update', btn);

            if (confirm('Are you sure that you want to update this component? This action can not be undo!')) {
                var component = btn.closest('.keditor-component-sortable');
                var container = component.closest('.keditor-container');
                var contentArea = component.closest('.keditor-content-area');

                if (typeof options.onBeforeComponentUpdated === 'function') {
                    options.onBeforeComponentUpdated.call(self, e, component, contentArea);
                }

                if (self.getSettingComponent().is(component)) {
                    self.hideSettingPanel();
                }

                self.updateComponent(contentArea, container, component);

                if (typeof options.onComponentUpdated === 'function') {
                    options.onComponentUpdated.call(self, e, component, contentArea);
                }

                if (typeof options.onContainerChanged === 'function') {
                    options.onContainerChanged.call(self, e, container, contentArea);
                }

                if (typeof options.onContentChanged === 'function') {
                    options.onContentChanged.call(self, e, contentArea);
                }
            }
        });
    };

    KEditor.prototype.initSelectionWidget = function () {
        var self = this;
        var selectionWidget = $(
            '<div class="keditor-selection-widget" style="display: none;">' +
            '<span class="selection-count">' + self.labels.selected + ': <span class="count">0</span></span>' +
            '<button class="selection-btn btn-delete">' + self.labels.delete + '</button>' +
            '<button class="selection-btn btn-copy">' + self.labels.copy + '</button>' +
            '<button class="selection-btn btn-done">' + self.labels.done + '</button>' +
            '</div>'
        );

        console.log("initSelectionWidget", self);
        self.body.append(selectionWidget);

        self.body.find('.webmag_selected').length > 0 && self.updateSelectionWidget();

        // Handle selection widget buttons
        selectionWidget.on('click', '.btn-delete', function () {
            if (typeof self.options.callFromKeditor === 'function') self.options.callFromKeditor("deleteSnippetModal", null, function () {
                self.body.find('.webmag_selected').each(function () {
                    $(this).remove();
                });
                self.hideSelectionWidget();
                self.save();
            });

        });

        selectionWidget.on('click', '.btn-copy', function () {
            var selectedElements = [];


            self.body.find('.webmag_selected').each(function () {
                $(this).removeClass('webmag_selected');
                selectedElements.push({
                    clone: $(this).clone(true, true).wrap("<div />").parent().html()
                });
            });

            try {
                window.localStorage.setItem('clonedElements', JSON.stringify(selectedElements));
            } catch (storageErr) {
                console.warn('[KEditor] localStorage full on multi-copy, clearing editor history and retrying:', storageErr);
                try {
                    window.localStorage.removeItem('v2_editor_history');
                    window.localStorage.setItem('clonedElements', JSON.stringify(selectedElements));
                } catch (retryErr) {
                    console.warn('[KEditor] Retry failed, clearing all editor storage:', retryErr);
                    try {
                        window.localStorage.removeItem('v2_editor_history');
                        window.localStorage.removeItem('webmag_clipboard');
                        window.localStorage.setItem('clonedElements', JSON.stringify(selectedElements));
                    } catch (finalErr) {
                        console.error('[KEditor] Cannot write to localStorage:', finalErr);
                    }
                }
            }
            if (typeof self.options.callFromKeditor === 'function') self.options.callFromKeditor("makeToast", {
                message: self.labels.copySnippet

            }, function (data) {

            })
            self.hideSelectionWidget();
        });

        selectionWidget.on('click', '.btn-done', function () {
            self.body.find('.webmag_selected').removeClass('webmag_selected');
            self.hideSelectionWidget();
        });
    };

    // Show selection widget when elements are selected
    KEditor.prototype.updateSelectionWidget = function () {
        var self = this;
        var selectedCount = self.body.find('.webmag_selected').length;

        if (selectedCount > 0) {
            var widget = self.body.find('.keditor-selection-widget');
            widget.find('.count').text(selectedCount);
            widget.show();
            // Show ALL checkboxes when any snippet is selected
            self.body.find('.btn-component-checkbox').removeClass('d-none');
            // Update checkbox states for all components
            self.body.find('.keditor-component-sortable').each(function () {
                var $component = $(this);
                var checkbox = $component.find('.btn-component-checkbox input[type="checkbox"]');
                checkbox.prop('checked', $component.hasClass('webmag_selected'));
            });
        } else {
            self.hideSelectionWidget();
        }
    };

    // Hide selection widget
    KEditor.prototype.hideSelectionWidget = function () {
        var self = this;
        self.body.find('.keditor-selection-widget').hide();
        // Hide all checkboxes
        self.body.find('.btn-component-checkbox').addClass('d-none');
        self.body.find('.btn-component-checkbox input[type="checkbox"]').prop('checked', false);
    };

    KEditor.prototype.deleteComponent = function (component) {
        flog('deleteComponent', component);

        var self = this;

        var componentType = self.getComponentType(component);
        if (componentType != "blank") {
            var componentData = KEditor.components["text"];
        } else {
            var componentData = KEditor.components[componentType];
        }
        if (typeof componentData.destroy === 'function') {
            componentData.destroy.call(componentData, component, self);
        } else {
            flog('"destroy" function of component type "' + componentType + '" does not exist');
        }

        component.remove();
    };

    KEditor.prototype.updateComponent = function (contentArea, container, component) {
        flog('updateComponent', component);

        //console.log("updateComponent")

        var self = this;
        var options = self.options;
        var body = self.body;
        var target = options.iframeMode ? self.body : self.element;

        var componentType = self.getComponentType(component);
        if (componentType != "blank") {
            var componentData = KEditor.components["text"];
        } else {
            var componentData = KEditor.components[componentType];
        }
        if (typeof componentData.update === 'function') {
            componentData.update.call(componentData, component, self);
        } else {
            flog('"update" function of component type "' + componentType + '" does not exist');
        }


        version = component.attr("data-wps-version");
        var name = component.attr("data-wps-name");

        var snippetsArticle = {
            "name": name,
            "version": version,
            "element": self.cleanFroalaContent(component.find(".keditor-component-content").children())[0]
        };




        var result = self.snippetsTemplate.filter(function (obj) {
            return obj.name == name;
        });






        if (result.length > 0) {
            if (result[0].version > version) {
                self.updateSnippet(snippetsArticle, result[0]);
                component.attr("data-wps-version", result[0].version);
                // show update button in component
                $(component).find(".keditor-toolbar .btn-component-update").css("display", "none");

                self.reinitComponent(contentArea, container, component);
            }
        } else {

        }
    };

    // update a snippet (chcked by version code)
    KEditor.prototype.updateSnippet = function (oldSnippet, newSnippet) {

        //console.log("updateSnippet", oldSnippet, newSnippet)

        oldSnippet = $(oldSnippet.element);
        newSnippet = $(newSnippet.element);


        // clone snippet
        newSnippet = newSnippet.clone(true, true);
        //console.log("newSnippet0",newSnippet.html())

        templateDivs = [];

        // prepare <template> and template divs
        prepareTemplates(oldSnippet, newSnippet);
        //console.log("newSnippet1",newSnippet.html())



        // update snippet without template divs
        // everything else gets updated
        updateSnippet(oldSnippet, newSnippet);
        //console.log("newSnippet2",newSnippet.html())

        // update and add templateDivs from <template>
        addTemplates();


        // console.log("newSnippet3",newSnippet.html())

        // replace old snippet with new snippet
        $(oldSnippet).replaceWith(newSnippet);


        function prepareTemplates(oldSnippet, newSnippet) {
            /*
                1. delete template divs from new snippet
                    - Save where to insert
                2. get template Divs from old template
                    - Save content
                3. update old template divs with template from new snippet
                4. Whole Update of remaining snippet
                5. insert  updated template divs into new snippet

                Pretty complicated stuff...this could be done much easier!
            */

            var templateDivs_new,
                templateDivs_old;


            // get template IDs
            var templates_new = newSnippet.find("template").addBack("template"),
                pgs_template;

            // iterate <template> of new snippet
            $.each(templates_new, function (index, _template_new) {



                // get content of <template> documentFragment
                _template_new = $($(_template_new).html());

                //console.log("_template_new", _template_new)

                // get template Divs of new Snippet (to get container aka where to put divs later)
                var _id = $(_template_new).attr("pgs-ams-template");
                templateDivs_new = newSnippet.find("[pgs-ams-template='" + _id + "']").addBack("[pgs-ams-template='" + _id + "']");

                // get template Divs of old Snippet
                templateDivs_old = oldSnippet.find("[pgs-ams-template='" + _id + "']").addBack("[pgs-ams-template='" + _id + "']").not("template");
                //console.log("templateDivs_old", templateDivs_old)

                templateDivs.push({
                    el: templateDivs_old,
                    el_new: [],
                    container: templateDivs_old.parent(),
                    container_new: templateDivs_new.parent(),
                    id: templateDivs_old.attr("pgs-ams-template")
                });





                // iterate through old templateDivs and clone new <template> script each time
                $.each(templateDivs_old, function (index2, _templateDivs_old) {

                    var clone = _template_new.clone(true, true);
                    var editable = clone.find("[data-wps-edit]"),
                        _attr,
                        _name,
                        timestamp;

                    // change data-wps-edit="{i}" to data-wps-edit="1"
                    $.each(editable, function (index, _el) {
                        _el = $(_el);
                        _attr = _el.attr("data-wps-edit").replace("{i}", index2 + 1);
                        _name = _el.attr("data-wps-edit-name").replace("{i}", index2 + 1);
                        timestamp = Math.random().toString().slice(2, 11);
                        _el.attr("data-wps-edit", _attr)
                        _el.attr("data-wps-edit-name", _name)
                    })
                    // save in array
                    templateDivs[index].el_new.push(clone[0])
                })

                // remove template Divs
                $(templateDivs_new).remove();
                $(templateDivs_old).remove();

            })
        }

        function addTemplates() {
            var _templateEl_new;

            // iterate through <template>
            //console.log("templateDivs",templateDivs)
            $.each(templateDivs, function (index, _templateDivs) {

                // iterate through each templateDiv (old Snippet) of a <template>
                $.each(_templateDivs.el, function (index2, _templateEl) {
                    // console.log("_templateDivs",_templateDivs)
                    //console.log("_templateEl",_templateEl)

                    // get cloned templateDiv from <template> (new Snippet)
                    _templateEl_new = _templateDivs.el_new[index2];

                    //console.error("_templateEl_new",_templateEl_new)

                    // update content
                    updateSnippet(_templateEl, _templateEl_new);



                    // append updated template divs to newSnippet in new container
                    _templateDivs.container_new.append(_templateEl_new)

                })
            })
        }

        function updateSnippet(oldSnippet, newSnippet) {

            var self = this;
            var options = self.options;

            oldSnippet = $(oldSnippet)
            newSnippet = $(newSnippet)

            //get all editable tags from article snippet
            oldEditable = $(oldSnippet).find("[data-wps-edit]").addBack("[data-wps-edit]").not("template [data-wps-edit]");

            // put old snippet content into new snippet
            $.each(oldEditable, function (index, _elOld) {




                _elOld = $(_elOld);
                // get editable value
                _attr = _elOld.attr("data-wps-edit");

                //find same value in snippet code
                _elNew = newSnippet.find("[data-wps-edit=" + _attr + "]").addBack("[data-wps-edit=" + _attr + "]");
                //console.log(newSnippet)
                //console.log(_attr)

                //console.log(_elNew)

                // change elements
                if (_elNew.length > 0) {
                    updateEditable(_elOld, _elNew);
                }
            });
        }

        function updateEditable(_elOld, _elNew) {

            var _src,
                _pb,
                _focus,
                _size,
                _href,
                _classChange = $(_elOld).attr('data-wps-class-change'),
                _classOptions;


            //console.log("ChangeEL", _elOld[0], _elNew[0]);
            // image
            if ($(_elOld).is("img")) {
                // get src from old snippet
                _src = $(_elOld).attr("src");
                _elNew.attr("src", _src);
                //get padding-bottom from old snippet
                _pb = _elOld.parent().css("padding-bottom");
                _elNew.parent().css("padding-bottom", _pb);
                //get focus from old snippet
                _focus = _elOld.parent().attr("data-focus");
                _elNew.parent().attr("data-focus", _focus);
                //get size from old snippet
                _size = _elOld.parent().attr("data-size");
                _elNew.parent().attr("data-size", _size);

                if (_elOld.parent().hasClass('auto-fit')) {
                    _elNew.parent().addClass('auto-fit')
                }

            }
            // link
            else if ($(_elOld).is("a")) {
                //get href from old snippet
                _href = $(_elOld).attr("href");
                _elNew.attr("href", _href);
            }

            //class change
            else if (_classChange) {

                // set classchange option
                _classOptions = _classChange.split('|');
                var _val;

                $.each(_classOptions, function (index, val) {
                    _val = val.split('=');
                    //add set class to new snippet
                    if ($(_elOld).hasClass(_val[1])) {
                        $(_elNew).addClass(_val[1]);
                    }
                });
            }

            // normal text
            else {
                //get html from old snippet
                _elNew.html(_elOld.html());
            }
        }
    }

    // check if index.html template was updated
    KEditor.prototype.checkTemplateUpdate = function () {
        var self = this;
        var options = self.options;
        var body = self.body;


        _templateVersion = $(self.template).attr("data-wps-version");


        var _dom = self.window.document.createElement("div");
        self.getContent().then(function (content) {
            _dom.innerHTML = content.trim();

            _currentVersion = $(_dom).attr("data-wps-version");


            if (_templateVersion > _currentVersion) self.addTemplateUpdate();
            else $(body).find("#templateUpdate").remove();
        })

    }

    // update current content with default template
    KEditor.prototype.addTemplateUpdate = function () {
        var self = this;
        var options = self.options;
        var body = self.body;


        if ($(body).find("#templateUpdate").length == 0) {
            var _button = $(
                '<button id="templateUpdate">' +
                '<i class="fa fa-refresh"></i>' +
                '</button>'
            )

            $(body).append(_button)

            _button.on('click', function (e) {
                if (confirm('Are you sure that you want to update the template? It will revert the template to the default style. Your content will stay. This action can not be undo!')) {

                    var _template = $(self.template);
                    self.getContent().then(function (content) {
                        var _content = $(content)
                        // set template to default first
                        // could be that a default element was appended somewhere else
                        if (typeof self.options.template.default == 'function') self.options.template.default(_content);

                        var snippets_t = _template.find('[data-wps-type="container-content"]');
                        var snippets_c = _content.find('[data-wps-type="container-content"]');

                        $.each(snippets_t, function (index, val) {

                            $(val).html("");
                            $.each($(snippets_c[index]).children(), function (index2, val2) {

                                // insert all children
                                // if()
                                $(val).append(val2)
                            });


                        });

                        self.setContent(_template.prop("outerHTML"));

                        _button.remove();
                    })



                }

            })
        }
    }




    KEditor.prototype.initDynamicContent = function (dynamicElement) {
        flog('initDynamicContent', dynamicElement);

        var self = this;
        var options = self.options;
        var component = dynamicElement.closest('.keditor-component-sortable');
        var contentArea = dynamicElement.closest('.keditor-content-area');

        dynamicElement.attr('id', self.generateId('dynamic-element'));

        if (typeof options.onBeforeDynamicContentLoad === 'function') {
            options.onBeforeDynamicContentLoad.call(self, dynamicElement, component, contentArea);
        }

        var dynamicHref = dynamicElement.attr('data-dynamic-href');
        var data = self.getDataAttributes(component, ['data-wps-type', 'data-dynamic-href'], false);
        data = $.param(data);
        flog('Dynamic href: ' + dynamicHref, 'Data: ' + data);

        return $.ajax({
            url: dynamicHref,
            data: data,
            type: 'GET',
            dataType: 'HTML',
            success: function (response, status, xhr) {
                flog('Dynamic content is loaded', dynamicElement, response, status, xhr);
                dynamicElement.html(response);

                if (typeof options.onDynamicContentLoaded === 'function') {
                    options.onDynamicContentLoaded.call(self, dynamicElement, response, status, xhr, contentArea);
                }
            },
            error: function (response, status, xhr) {
                flog('Error when loading dynamic content', dynamicElement, response, status, xhr);

                if (typeof options.onDynamicContentError === 'function') {
                    options.onDynamicContentError.call(self, dynamicElement, response, status, xhr, contentArea);
                }
            }
        });
    };

    KEditor.prototype.getComponentContent = function (component) {
        flog('getComponentContent', component);



        var self = this;
        component = component.clone();



        var componentType = self.getComponentType(component);
        if (componentType != "blank") {
            var componentData = KEditor.components["text"];
        } else {
            var componentData = KEditor.components[componentType];
        }




        var _classNames = component[0].classList;
        _classNames.remove("keditor-component", "existing-component", "keditor-initialized-component");


        var _cl = "";
        for (var i = 0; i <= _classNames.length; i++) {
            if (_classNames[i] != "undefined") _cl += _classNames[i] + " ";

        }

        var _data_class = component.attr('data-wps-class');



        _cl += _data_class;

        //var componentData = KEditor.components[componentType];
        var dataAttributes = self.getDataAttributes(component, null, true);

        var content;


        if (!componentData) return;
        if (typeof componentData.getContent === 'function') {
            content = componentData.getContent.call(componentData, component, self);
        } else {
            //never gets called!
            flog('"getContent" function of component type "' + componentType + '" does not exist. Using default getContent method');
            var componentContent = component.children('.keditor-container-inner');
            content = componentContent.html();

            console.log("content", content);
            console.log("componentContent", componentContent);
        }

        // get dom with vanilla JS so it shows no error (scope has to be in iframe!)
        var _dom = self.window.document.createElement("div");
        if (!content) {
            return '';
        }
        _dom.innerHTML = content.trim();
        _dom = $(_dom);
        _dom.find('[data-dynamic-href]').each(function () {
            $(this).html('');
        });
        content = _dom.html();
        /*var tempDiv = $('<div />').html(content);
        tempDiv.find('[data-dynamic-href]').each(function() {
            $(this).html('');
        });
        content = tempDiv.html();*/
        var $section = $('<section />'); // Replace with your div's ID or another selector

        // Iterate over the object and add each attribute to the div
        $.each(dataAttributes, function (key, value) {
            $section.attr(key, value);
        });
        $section.addClass(_cl);
        $section.html(content);


        return $section;

        return '<section  class="' + _cl + '" ' + dataAttributes.join(' ') + '>' + content + '</section>';
    };


    KEditor.prototype.cleanFroalaContent = function (container, all) {
        var self = this;
        var containerContent;

        function escapeHtml(s) {
            return String(s == null ? '' : s)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        }

        container.find("[data-wps-edit]").each(function () {
            // console.log("cleanFroalaContent 1", this)
            // console.log("cleanFroalaContent 1", this.innerHTML)

            // dont clean when value is false (ClassChange i.e.)
            if (!all) {
                if ($(this).attr("data-wps-edit").indexOf("false") != -1) return;
                if ($(this).attr("data-wps-edit") == "false") return;
                if ($(this).attr("data-wps-edit-disable")) return;

            }

            containerContent = $(this);

            if (!$(containerContent).is("img")
                && !$(containerContent).is("a")
                && !$(containerContent).is("button")
                && !containerContent[0].hasAttribute("data-wps-edit-disable")) {


                var _el = $(containerContent).find(".fr-element");


                if (_el.length > 0) {
                    var inner = _el.last().html();
                    // console.warn("i",_el, _el.html());

                    // console.warn("o",containerContent, containerContent.html());
                    if (inner == undefined || inner == null) {
                        console.error("An error occured. Please reload the page and contact support.");
                        return;
                    } else {
                        containerContent.html(inner);
                    }
                    $(this).removeClass('fr-box fr-inline fr-ltr');
                    $(this).removeAttr('role');
                }

            }
            //console.error("cleanFroalaContent 2", this.innerHTML);
            //console.log("cleanFroalaContent 2", this)
        })


        //console.log(" return cleanFroalaContent container", container.html())

        // Content-bloat guard: replace mounted preview DOM in .wbmg_form elements
        // with the lean placeholder so full form HTML never reaches saved content.
        var formsData = (self.options && self.options.formsData) || [];
        container.find('.wbmg_form').each(function () {
            var $el = $(this);
            var formId = $el.attr('data-wps-form-id');
            var name = 'Formular';
            for (var fi = 0; fi < formsData.length; fi++) {
                if (formsData[fi] && String(formsData[fi].form_id) === String(formId)) {
                    name = escapeHtml(formsData[fi].name || 'Formular');
                    break;
                }
            }
            $el.html('<div class="wbmg_form__placeholder">📋 ' + name + '</div>');
        });

        return container;
    }

    KEditor.prototype.regenerateInlineCollapsibleIds = function (container) {
        var self = this;
        // Find all inline collapsible triggers
        container.find('[data-toggle="collapse"][data-target]').each(function() {
            var $trigger = $(this);
            var targetId = $trigger.attr('data-target');
            if (!targetId) return;

            // Remove # from target if present
            targetId = targetId.replace('#', '');

            // Generate new unique ID
            var newId = 'inlineCollapse' + Date.now() + Math.random().toString().slice(2, 11);

            // Find the corresponding collapse element
            var $target = container.find('#' + targetId).first();

            if ($target.length > 0) {
                // Update target element
                $target.attr('id', newId);
                if ($target.attr('aria-controls')) {
                    $target.attr('aria-controls', newId);
                }

                // Update trigger element
                $trigger.attr('data-target', '#' + newId);
                if ($trigger.attr('aria-controls')) {
                    $trigger.attr('aria-controls', newId);
                }
            }
        });

        return container;
    }



    KEditor.prototype.cleanContainerContent = function (container, isNested, min) {
        flog('getContainerContent - isNested=' + isNested, container);
        var self = this;
        var containerInner = container.clone(true, true);
        containerInner = self.cleanFroalaContent(containerInner);
        containerInner = self.regenerateInlineCollapsibleIds(containerInner);
        containerInner.find('[data-wps-type]').each(function () {
            var component = this;
            var componentType = self.getComponentType($(component));
            var multipleTypes = componentType.split(',');

            $(multipleTypes).each(function (index, el) {
                if (self.window.p$.snippet && self.window.p$.snippet[el]) { //if this snippet has a js file
                    snip = new self.window.p$.snippet[el](); // create snippet
                    if (typeof snip.destroy === 'function') snip.destroy(component);
                }
            });
        })




        console.log("containerInner", containerInner.attr('data-wps-container'));
        if (containerInner.attr('data-wps-container')) {
            // search for classname keditor-component-content
            var _containerInner = containerInner.find('> .keditor-container-inner > .keditor-component-content > div');
            if (_containerInner.length > 0) {
                containerInner.html(_containerInner.clone(true, true))
            }
            console.log("containerInner", containerInner[0].outerHTML);
        }



        // console.log("containerInner", containerInner)
        // console.log("containerInner", containerInner[0].outerHTML);
        // console.log("dsa",containerInner.find(".keditor-container-inner"));
        // console.log("dsa",containerInner.find(".keditor-container-inner  .keditor-component-content"));
        // console.log("dsa",containerInner.find(".keditor-container-inner  .keditor-component-content > div"));
        // //containerInner.replaceWith(containerInner.find(".keditor-container-inner  .keditor-component-content > div"));
        // containerInner.find(".keditor-container-inner").each(function() {

        //     var containerContent = $(this);
        //     console.log("containerContent", containerContent.parent()[0].outerHTML);
        //      console.log("containerContent > div", containerContent.find(".keditor-component-content > div")[0].outerHTML);
        //     //containerContent.parent().html(containerContent.find(".keditor-component-content > div"));
        //    console.log("containerContent2", containerContent[0].outerHTML);
        // })



        //




        containerInner.find('main[data-wps-type=container-content]').not(isNested ? '' : '.keditor-sub-container-content').each(function () {
            var containerContent = $(this);
            containerContent.removeClass('keditor-container-content keditor-highlighted-dropzone keditor-sub-container-content ui-droppable ui-sortable').removeAttr('id');
            containerContent.children().each(function () {
                var child = $(this);
                if (child.is('.keditor-component')) {
                    //console.error("!!keditor-component");
                    child.replaceWith(self.getComponentContent(child));
                } else if (child.is('.keditor-sub-container')) {
                    child.find(".keditor-ui.keditor-container-inner").replaceWith(child.find(".keditor-container-inner").last().children());
                }
            });
        });

        var containerContent;



        // delete id of keditor-component-content class
        containerInner.find('.keditor-component-content').each(function () {
            containerContent = $(this);
            containerContent.removeAttr('id');
        });


        // clean all contenteditable
        containerInner.find('[contenteditable]').each(function () {
            containerContent = $(this);
            if (!containerContent.hasClass('wbmg_variable') && !containerContent.hasClass('wbmg_form') && !containerContent.hasClass('wbmg_editable')) {
                containerContent.removeAttr('contenteditable');
            }
        })

        // clean all editables
        containerInner.find('.cke_editable').each(function () {
            containerContent = $(this);
            containerContent.removeClass('cke_editable cke_editable_inline cke_contents_ltr cke_show_borders');
        })

        containerInner.find('.keditor-toolbar').each(function () {
            containerContent = $(this);
            containerContent.remove();

        })
        containerInner.find('.btn-component-paddingBottom').each(function () {
            containerContent = $(this);
            containerContent.remove();
        })
        containerInner.find('.btn-component-paddingTop').each(function () {
            containerContent = $(this);
            containerContent.remove();
        })
        containerInner.find('.btn-component-paddingRight').each(function () {
            containerContent = $(this);
            containerContent.remove();
        })
        containerInner.find('.btn-component-paddingLeft').each(function () {
            containerContent = $(this);
            containerContent.remove();
        })

        containerInner.find('.keditor-ui').each(function () {
            containerContent = $(this);
            containerContent.removeClass('keditor-ui');
        })

        containerInner.find('.showed-keditor-toolbar').each(function () {
            containerContent = $(this);
            containerContent.removeClass('showed-keditor-toolbar');
        })

        containerInner.find('.divToolImg').each(function () {
            containerContent = $(this);
            containerContent.remove();

        });

        return containerInner[0].outerHTML;
    };



    KEditor.prototype.getContainerContent = function (container, isNested, min) {
        flog('getContainerContent - isNested=' + isNested, container);



        var self = this;



        // deletes dynamic snippet input!

        // Function to check and remove empty elements from live editor data
        function removeIfEmpty(element) {
            // Check if the element is one of the specified tags, is empty, and has no classname
            if (!$(element).attr('class') && $(element).is('span, div, strong, em, u, s, sub, sup, p, h1, h2, h3, h4, h5, h6, table, li, ul') && $.trim($(element).text()) === '' && $(element).children().length === 0) {
                $(element).remove();
                return true; // Indicates the element was removed
            }
            return false; // Indicates the element was not removed
        }
        // Iterate over the specified elements, starting from the deepest child
        // container.children('.keditor-container-inner').find('span:not([class]), div:not([class]), strong:not([class]), em:not([class]), u:not([class]), s:not([class]), sub:not([class]), sup:not([class]), p:not([class]), h1:not([class]), h2:not([class]), h3:not([class]), h4:not([class]), h5:not([class]), h6:not([class]), table:not([class]), li:not([class]), ul:not([class])').get().reverse().forEach(function(el) {
        //     // If the current element is removed, check its parent
        //     if (removeIfEmpty(el) && el.parentNode) {
        //         removeIfEmpty(el.parentNode);
        //     }
        // });


        //console.log(container.children('.keditor-container-inner').clone().html());


        //var containerInner = container.children('.keditor-container-inner').clone();

        //console.log(containerInner.html())


        //return containerInner.html();


        var containerInner = container.children('.keditor-container-inner').clone(true, true);




        // this scritp deletes all froala additional elements (there is no getCleanContents() function)
        // start this before all other because of crazy errors!
        /* containerInner.find("[data-wps-edit]").each(function() {
             containerContent = $(this);
             $(this).removeClass('fr-box fr-inline');
             $(this).removeAttr('role');
              if (!$(containerContent).is("img") && !$(containerContent).is("a") && !$(containerContent).is("button")) {
                 var _el = $(containerContent).find(".fr-element").addBack(".fr-element");
                 if(_el.length>0){
                    var inner = $(containerContent).find(".fr-element").addBack(".fr-element")[0].innerHTML;
                    $(this)[0].innerHTML=inner;
                 }

              }
         })*/



        containerInner = self.cleanFroalaContent(containerInner);





        //container.children('.keditor-container-inner').find('[data-wps-type]').each(function() {

        containerInner.find('[data-wps-type]').each(function () {
            var component = this;

            var componentType = self.getComponentType($(component));

            //var componentType = $(this).attr('data-wps-type');

            var multipleTypes = componentType.split(',');

            $(multipleTypes).each(function (index, el) {

                /* console.error("DESTROY");
                 console.log($(component).find(".flickity-enabled"))
                 console.log($(component).find(".flickity-enabled").data("flickity"))*/
                if (self.window.p$.snippet && self.window.p$.snippet[el]) { //if this snippet has a js file
                    snip = new self.window.p$.snippet[el](); // create snippet
                    if (typeof snip.destroy === 'function') snip.destroy(component);
                }
            });
        })







        containerInner.find('main[data-wps-type=container-content]').not(isNested ? '' : '.keditor-sub-container-content').each(function () {
            var containerContent = $(this);
            containerContent.removeClass('keditor-container-content keditor-highlighted-dropzone keditor-sub-container-content ui-droppable ui-sortable').removeAttr('id');

            //   console.log(containerContent.html())

            containerContent.children().each(function () {
                var child = $(this);

                if (child.is('.keditor-component')) {
                    //console.error("!!keditor-component");
                    child.replaceWith(self.getComponentContent(child));

                } else if (child.is('.keditor-sub-container')) {

                    child.find(".keditor-ui.keditor-container-inner").replaceWith(child.find(".keditor-container-inner").last().children());

                    //console.error("!!keditor-sub-container");
                    //     var _classNames = child[0].classList;
                    //    // _classNames.remove("keditor-container", "existing-container", "keditor-initialized-container", "keditor-component-sortable", "undefined");
                    //     child.find('.cke_editable').each(function() {
                    //         containerContent = $(this);
                    //         containerContent.removeClass('cke_editable cke_editable_inline cke_contents_ltr cke_show_borders');
                    //     })
                    //     child.removeAttr('id');
                    //     console.log(child);
                    //     console.log(child.find(".keditor-ui.keditor-container-inner"))
                    //child.replaceWith(child.find(".keditor-container-inner").children[0]);
                    //child.replaceWith(self.getComponentContent(child));
                    //child.replaceWith(self.getContainerContent(child, true));
                }
            });
        });

        //console.error(containerInner.html())


        var containerContent;

        // clean all contenteditable
        containerInner.find('[contenteditable]').each(function () {
            containerContent = $(this);
            if (!containerContent.hasClass('wbmg_variable') && !containerContent.hasClass('wbmg_form')) {
                containerContent.removeAttr('contenteditable');
            }
        })


        // clean all editables
        containerInner.find('.cke_editable').each(function () {
            containerContent = $(this);
            containerContent.removeClass('cke_editable cke_editable_inline cke_contents_ltr cke_show_borders');

        })

        containerInner.find('.keditor-toolbar').each(function () {
            containerContent = $(this);
            containerContent.remove();

        })
        containerInner.find('.btn-component-paddingBottom').each(function () {
            containerContent = $(this);
            containerContent.remove();
        })
        containerInner.find('.btn-component-paddingTop').each(function () {
            containerContent = $(this);
            containerContent.remove();
        })
        containerInner.find('.btn-component-paddingRight').each(function () {
            containerContent = $(this);
            containerContent.remove();
        })
        containerInner.find('.btn-component-paddingLeft').each(function () {
            containerContent = $(this);
            containerContent.remove();
        })

        containerInner.find('.keditor-ui').each(function () {
            containerContent = $(this);
            containerContent.removeClass('keditor-ui');

        })

        containerInner.find('.showed-keditor-toolbar').each(function () {
            containerContent = $(this);
            containerContent.removeClass('showed-keditor-toolbar');
        })

        containerInner.find('.divToolImg').each(function () {
            containerContent = $(this);
            containerContent.remove();

        });



        // Function to check and remove empty elements
        function removeIfEmpty(element) {
            // Check if the element is one of the specified tags, is empty, and has no classname
            if (!$(element).attr('class') && $(element).is('span, div, strong, em, u, s, sub, sup, h1, h2, h3, h4, h5, h6, table, li, ul') && $.trim($(element).text()) === '' && $(element).children().length === 0) {
                $(element).remove();
                return true; // Indicates the element was removed
            }
            return false; // Indicates the element was not removed
        }

        // // Iterate over the specified elements, starting from the deepest child
        // containerInner.find('span:not([class]), div:not([class]), strong:not([class]), em:not([class]), u:not([class]), s:not([class]), sub:not([class]), sup:not([class]), h1:not([class]), h2:not([class]), h3:not([class]), h4:not([class]), h5:not([class]), h6:not([class]), table:not([class]), li:not([class]), ul:not([class])').get().reverse().forEach(function(el) {
        //     // If the current element is removed, check its parent
        //     if (removeIfEmpty(el) && el.parentNode) {
        //         removeIfEmpty(el.parentNode);
        //     }
        // });

        function removeEmptyElements(containerInner) {
            // Define the list of target elements to check
            const targetTags = [
                'span', 'div', 'strong', 'em', 'u', 's', 'sub', 'sup',
                'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'li', 'ul'
            ];

            // Define the list of removable class names
            const removableClassNames = [
                'btn', 'btn-outline-dark', 'btn-outline-white', 'btn-outline-secondary',
                'btn-outline-primary', 'btn-dark', 'btn-white', 'btn-primary',
                'btn-secondary', 'btn-tertiary', 'btn-quaternary', 'text-dark',
                'text-white', 'text-primary', 'text-secondary', 'text-tertiary',
                'text-quaternary', 'text-decoration-underline', 'text-decoration-none',
                'small', 'font-weight-normal', 'font-weight-light', 'rounded', 'border-2',
                'shadow', 'shadow-sm', 'mt-2', 'ml-2', 'mr-2', 'mb-2', 'align-middle',
                'hidden-sm-down', 'float-sm-left', 'mb-3', 'mr-sm-3', 'mt-0',
                'float-sm-right', 'ml-sm-3', 'rounded-circle', 'stretched-link',
                'mt-auto', 'w-100', 'customTypo1', 'customTypo2', 'customTypo3',
                'display-1', 'display-2', 'display-3', 'display-4', 'wbmg-mark',
                'pb-0', 'wmag_collapse', 'wmag_footnote', 'text-uppercase',
                'align-top', 'align-bottom', 'no-hyphen', 'wps-aos-fade-in',
                'wps-aos-fade-up', 'wps-aos-fade-right', 'wps-aos-fade-left',
                'wps-aos-fade-down', 'wps-aos-zoom-in', 'wps-aos-zoom-out', 'mb-0'
            ];

            // Define the list of removable IDs
            const removableIds = ['isPasted'];

            // Get all target elements within the containerInner
            const elements = Array.from($(containerInner).find(targetTags.join(',')));

            // Reverse the array to process elements bottom-up
            elements.reverse().forEach(element => {
                if (isEmpty(element)) {
                    console.log('Removing empty element:', element); // Optional: log removed elements for debugging
                    $(element).remove();
                }
            });

            function isEmpty(element) {
                // Check for &nbsp; entities
                if (element.innerHTML.includes('&nbsp;') || element.innerHTML.includes(' ')) {
                    return false;
                }

                // Check if element has meaningful style attributes
                const style = element.style;
                if (style.padding || style.paddingTop || style.paddingBottom ||
                    style.paddingLeft || style.paddingRight ||
                    style.margin || style.marginTop || style.marginBottom ||
                    style.marginLeft || style.marginRight) {
                    return false;
                }

                // Check if element contains any <br> tags
                if (element.getElementsByTagName('br').length > 0) return false;

                const hasProtectedAttrs = Array.from(element.attributes).some(attr => {
                    const name = attr.name.toLowerCase();
                    return name.startsWith('data-');
                });
                if (hasProtectedAttrs) return false;

                const elementClasses = Array.from(element.classList);
                const hasOnlyRemovableClasses = elementClasses.length === 0 ||
                    elementClasses.every(cls => removableClassNames.includes(cls));
                if (!hasOnlyRemovableClasses) return false;

                const id = element.getAttribute('id');
                if (id && !removableIds.includes(id)) return false;

                const hasOnlyAllowedAttrs = Array.from(element.attributes).every(attr => {
                    const name = attr.name.toLowerCase();
                    return ['class', 'style', 'id', 'title', 'aria-label', 'role'].includes(name);
                });
                if (!hasOnlyAllowedAttrs) return false;

                // Modified text content check to preserve &nbsp;
                const textContent = element.textContent;
                if (textContent && textContent.trim() && textContent !== ' ') return false;

                if (element.childNodes.length === 0) return true;

                return Array.from(element.childNodes).every(child => {
                    if (child.nodeType === Node.TEXT_NODE) {
                        const text = child.textContent;
                        // Preserve if text contains &nbsp;
                        return !text.trim() && text !== ' ';
                    }
                    if (child.nodeType === Node.ELEMENT_NODE) {
                        if (child.tagName.toLowerCase() === 'br') return false;

                        const childClasses = Array.from(child.classList);
                        const childHasOnlyRemovableClasses = childClasses.length === 0 ||
                            childClasses.every(cls => removableClassNames.includes(cls));
                        return childHasOnlyRemovableClasses && isEmpty(child);
                    }
                    return true;
                });
            }
        }

        // Example usage:
        // Assuming `containerInner` is a jQuery element
        removeEmptyElements(containerInner);



        containerInner.find('.webmag_selected').each(function () {
            containerContent = $(this);
            containerContent.removeClass('webmag_selected');
        })



        // minimal version of article data for the frontend
        if (min) {


            var _src;
            //change all imgs src for lazyloading
            containerInner.find('img').each(function () {
                containerContent = $(this);
                if (containerContent[0].hasAttribute('data-no-lazy')) return;
                _src = containerContent.attr("src");

                // if(!self.checkForCloudImage(_src)){
                //     var _w = 600;
                //     var _h = 400;
                //     _src = self.cloudImageFunction(_src, { width: 600, height: 400 }, {width:1200, height:1200 }, 10);
                // }

                // Check if it's a cloudimg.io URL
                var isCloudImg = _src.includes('cloudimg.io');

                if (isCloudImg) {
                    // Use cloudimg.io specific parameters: q, w, h
                    console.log("isCloudImg", _src)
                    // Check if URL has a quality parameter and update it
                    if (_src.includes('&q=')) {
                        _src = _src.replace(/&q=\d+/g, '&q=10');
                    } else if (_src.includes('?q=')) {
                        _src = _src.replace(/\?q=\d+/g, '?q=10');
                    } else {
                        // Check if URL already has parameters to determine separator
                        var separator = _src.includes('?') ? '&' : '?';
                        _src += separator + 'q=10';
                    }

                    // Check if URL has a width parameter and update it
                    if (_src.includes('&w=')) {
                        _src = _src.replace(/&w=\d+/g, '&w=600');
                    } else if (_src.includes('?w=')) {
                        _src = _src.replace(/\?w=\d+/g, '?w=600');
                    } else {
                        // Check if URL already has parameters to determine separator
                        var widthSeparator = _src.includes('?') ? '&' : '?';
                        _src += widthSeparator + 'w=600';
                    }

                    // Check if URL has a height parameter and update it
                    if (_src.includes('&h=')) {
                        _src = _src.replace(/&h=\d+/g, '&h=400');
                    } else if (_src.includes('?h=')) {
                        _src = _src.replace(/\?h=\d+/g, '?h=400');
                    } else {
                        // Check if URL already has parameters to determine separator
                        var heightSeparator = _src.includes('?') ? '&' : '?';
                        _src += heightSeparator + 'h=400';
                    }
                } else {
                    // Use standard parameters: quality, width

                    // Check if URL has a quality parameter and update it
                    if (_src.includes('&quality=')) {
                        _src = _src.replace(/&quality=\d+/g, '&quality=10');
                    } else if (_src.includes('?quality=')) {
                        _src = _src.replace(/\?quality=\d+/g, '?quality=10');
                    } else {
                        // Check if URL already has parameters to determine separator
                        var separator = _src.includes('?') ? '&' : '?';
                        _src += separator + 'quality=10';
                    }

                    // Check if URL has a width parameter and update it
                    if (_src.includes('&width=')) {
                        _src = _src.replace(/&width=\d+/g, '&width=600');
                    } else if (_src.includes('?width=')) {
                        _src = _src.replace(/\?width=\d+/g, '?width=600');
                    } else {
                        // Check if URL already has parameters to determine separator
                        var widthSeparator = _src.includes('?') ? '&' : '?';
                        _src += widthSeparator + 'width=600';
                    }
                }
                containerContent.attr("src", _src);
                containerContent.attr('data-src', _src);
                containerContent.attr('data-url', _src);
                containerContent.addClass("wps-lazy");

            })


            var _original_embed;
            containerInner.find('.fr-embedly').each(function () {
                //$(this).addClass("wbmg_embedly");
                //_original_embed = $(this).attr("data-original-embed");
                $(this).html("");
            })



            // find links with classname 'inlineCollapse'
            $(containerInner).find("a.inlineCollapse").each(function (index, obj) {
                var _contentId = $(this).attr("data-target");
                $(this).addClass("collapsed").attr("aria-expanded", "false");
                if (_contentId) {
                    var _content = $(containerInner).find(_contentId);
                    _content.removeClass("show");
                }
            })



            $(containerInner).find("[class^='wps-aos'],div[class*=' wps-aos']").each(function (index, obj) {
                className = this.className.match(/wps\-aos\-[^\s]*/);
                if (className.length > 0) {
                    $(this).removeClass(className);
                    $(this).attr("data-aos", className[0].replace("wps-aos-", ""));
                }
            })


            // delete all data-wps-attributes from elements with data-wps-edit attribute
            containerInner.find('[data-wps-edit], section').each(function () {
                var attrs = this.attributes;
                var toRemove = [];
                // cache the jquery object containing the element for better performance
                var element = $(this);

                // iterate the attributes
                for (attr in attrs) {
                    if (typeof attrs[attr] === 'object' &&
                        typeof attrs[attr].name === 'string' &&
                        (/(^data-wps)(?!(-type|-modal|-tf-widget|-chart|-context|-dynamic-page|-variable|-countup|-toc|-fade|-laterpay|-edit-variable|-form-id|-form-data|-index|-attr))/).test(attrs[attr].name)) {
                        // Unfortunately, we can not call removeAttr directly in here, since it
                        // hurts the iteration.
                        toRemove.push(attrs[attr].name);
                    }
                }


                for (var i = 0; i < toRemove.length; i++) {
                    element.removeAttr(toRemove[i]);
                }
            })


            //custom aos
            containerInner.find('section.section').each(function () {
                containerContent = $(this);
                containerContent.attr("data-aos", "true");
                containerContent.attr("data-aos-id", "scroll-snippet-tracking");
                containerContent.removeAttr('id');
            })




            //Variables
            containerInner.find('.wbmg_variable').each(function () {
                // containerContent = $(this);
                // if(containerContent.html()=="") containerContent.remove()
                //     else{
                //         containerContent.html("{{{"+containerContent.html()+"}}}");
                //     }
            })

            //create Footnotes

            containerInner.find('.wmag_footnote').each(function () {
                containerContent = $(this);
                if (containerContent.html() == "") containerContent.remove()
                else {
                    containerContent.attr({
                        'data-toggle': "tooltip",
                        'title': containerContent.html()
                    });
                    containerContent.html("");
                }
            })

            containerInner.find('.wmag_modal').each(function () {
                containerContent = $(this);
                if (containerContent.html() == "") containerContent.remove()
                else {
                    containerContent.attr({
                        'data-original-title': containerContent.html()
                    });
                    containerContent.html("");
                }
            })




            containerInner.find('.padding-drag-handler-top').each(function () {
                containerContent = $(this);
                containerContent.remove();
            })
            containerInner.find('.padding-drag-handler-bottom').each(function () {
                containerContent = $(this);
                containerContent.remove();
            })

            containerInner.find('.img-drag-handler').each(function () {
                containerContent = $(this);
                containerContent.remove();
            })
            containerInner.find('.keditor-plus-button').each(function () {
                containerContent = $(this);
                containerContent.remove();
            })
            containerInner.find('.chartjs-size-monitor').each(function () {
                containerContent = $(this);
                containerContent.remove();
            })

            containerInner.find('.webmag_hide').each(function () {
                containerContent = $(this);
                containerContent.remove();

            })
            containerInner.find('[data-wps-version]').each(function () {
                containerContent = $(this);
                containerContent.removeAttr('data-wps-version');
            })

            containerInner.find('[data-wps-type]').each(function () {
                containerContent = $(this);
                //console.error("Found type", containerContent)
                //containerContent.removeAttr('data-wps-type');
            })

            // needed to make snippets interactive!!
            containerInner.find('[data-wps-name]').each(function () {
                containerContent = $(this);
                //containerContent.removeAttr('data-wps-name');
            })

            // needed
            containerInner.find('[data-toolbar]').each(function () {
                containerContent = $(this);
                //containerContent.removeAttr('data-toolbar');
            })

            // needed
            containerInner.find('[data-toolbar-duplicate]').each(function () {
                containerContent = $(this);
                //containerContent.removeAttr('data-toolbar-duplicate');
            })

            // needed
            containerInner.find('[data-toolbar-delete]').each(function () {
                containerContent = $(this);
                //containerContent.removeAttr('data-toolbar-delete');
            })

            containerInner.find('template.pgs-cb-template').each(function () {
                containerContent = $(this);
                containerContent.remove();
            });

            containerInner.find('[data-wps-edit-variable]').each(function () {
                containerContent = $(this);
                //containerContent.removeAttr('data-wps-edit-variable');
            });

            containerInner.find('[spellcheck]').each(function () {
                containerContent = $(this);
                containerContent.removeAttr('spellcheck');
            });

            containerInner.find('[pgs-ams-template]').each(function () {
                containerContent = $(this);
                containerContent.removeAttr('pgs-ams-template');
            });
            // fix handlebars clearing on data-original-title (from data-wps-variable) -> set template again
            //custom aos
            // needed
            containerInner.find('.footnode_modal[data-wps-variable]').each(function () {
                containerContent = $(this);
                var _var = containerContent.attr("data-wps-variable");
                console.log("var", _var);

                if (_var && _var != "Custom Text") containerContent.attr("data-original-title", "{{" + _var.replace(/\s/g, "") + "}}");
                //containerContent.removeAttr('data-toolbar');
            })


            // console.log("containerInner.html()", containerInner.html())

        }








        return containerInner.html();
        //return '<pgs-article class="' + self.options.data.template + '">' + containerInner.html() + '</pgs-article>';
    };

    KEditor.prototype.getContent = function (inArray, min) {
        var deferred = $.Deferred();
        var self = this;
        var options = self.options;
        var result = [];
        var target = options.iframeMode ? self.body : self.element;

        setTimeout(function () {
            if (target.is('textarea')) {
                target = $(target.attr('data-keditor-wrapper'));
            }


            //console.error(target.find('.keditor-content-area').html())


            target.find('.keditor-content-area').each(function () {
                var html = '';
                $(this).children('.keditor-container').each(function () {


                    var container = $(this);

                    html += self.getContainerContent(container, false, min);

                });

                result.push(html);
            });
            deferred.resolve(inArray ? result : result.join('\n'));

        }, 100);




        return deferred.promise();

    };

    KEditor.prototype.setContent = function (content, contentArea) {
        var self = this;
        var options = self.options;
        var body = self.body;
        var target = options.iframeMode ? self.body : self.element;




        if (!contentArea) {
            contentArea = target.children();
            contentArea = $(target).find(".keditor-content-area")
        } else {
            if (!contentArea.jquery) {
                contentArea = target.find(contentArea);
            }
        }

        if (contentArea.length === 0) {
            error('Content area does not exist!');
        }

        if (content) {
            // so no image errors in console (scope in iframe window)
            var _dom = self.window.document.createElement("div");
            _dom.innerHTML = content.trim();
            _dom = _dom.children[0];

            var isSection = $(_dom).is('section');
            if (!isSection) {
                content = "<section>" + $(_dom).prop("outerHTML") + "</section>";
            }
            originalContent = content;

            target.find("main section").remove();
        }




        var html = self.compileHandlebars(content);


        //$(".opened-keditor-setting").removeClass("opened-keditor-setting");
        self.toggleSettings(false)


        contentArea.html(html);


        self.initContentArea(contentArea);

        self.initSnippets();

        self.checkContentArea(contentArea);



        if (options.nestedContainerEnabled) {
            //self.containerSnippets.draggable('option', 'connectToSortable', self.getConnectedForContainerSnippets());
        }

        // Only save if not restoring from history
        if (!self.historyState || !self.historyState.isRestoring) {
            self.save();
        }
        //

        //if(self.componentSnippets) self.componentSnippets.draggable('option', 'connectToSortable', body.find('.keditor-container-content'));
    };



    // Also set all Helpers in p$.utils.compileHandlebars!!
    KEditor.prototype.compileHandlebars = function (content) {
        var self = this;



        _siblings = self.options.allPageSiblings;
        var prevNextSiblings = self.options.prevNextSiblings;




        var self = this;


        function getCategory(arr) {
            if (!arr) return "";
            for (var x = 0; x < arr.length; x++) {
                if (arr[x].charAt(0) != "#") return arr[x];
            }
            return "";
        }


        Handlebars.registerHelper('ams_each', function (context, options) {
            var ret = "",
                _arr;


            var i = options.hash.start || 0;
            var end;

            // only return articles with menu true
            if (context == 'articles') {
                _arr = _siblings;
                //_arr = p$.data.current.modules.content;



                end = options.hash.end || _arr.length;

                // Number by visible position, not by raw array position: hidden
                // (unlisted) pages must not consume a page number.
                var _visible = [];
                for (var i, j = end; i < j; i++) {
                    if (_arr[i] && !_arr[i].isHidden) _visible.push(_arr[i]);
                }

                for (var n = 0; n < _visible.length; n++) {
                    options.data.index = n + 1;
                    options.data.first = n === 0;
                    options.data.last = n === (_visible.length - 1);
                    options.data.link = new Handlebars.SafeString(_visible[n].slug);
                    options.data.category = new Handlebars.SafeString(getCategory(_visible[n].keywords)); // get first value in category[] as category
                    ret = ret + options.fn(_visible[n]);
                }

                return ret;
            }

        });




        Handlebars.registerHelper('times', function (n, block) {
            var accum = '';
            for (var i = 1; i <= n; ++i) {
                block.data.index = i;
                block.data.first = i === 0;
                block.data.last = i === (n - 1);
                accum += block.fn(this);
            }
            return accum;
        });

        Handlebars.registerHelper('ams_ArticleLink', function (n, block) {
            var _m_id = $.grep(_siblings, function (e) { return e.id == n && e.isPublished; });

            //if (!_m_id) _m_id = p$.theme.popup.activePopup.data;
            if (_m_id.length > 0) {
                return new Handlebars.SafeString(_m_id[0].slug);
            } else {
                return new Handlebars.SafeString("");
            }
        });

        Handlebars.registerHelper('ams-nextArticle', function (n, block) {
            var accum = '';
            // not working in V2??
            //if ( window.parent._AMS && window.parent._AMS.project) {
            // var _content = _siblings;

            // var index = _content.map(function(e) {
            //     return e.id;
            // }).indexOf(self.options.data.id); //get index of clicked module
            // //find next article
            // // _m_next == undefined when there is no next article
            // var _m_next;

            // for (var i = index + 1; i < _content.length; i++) {
            //     _m_next = _content[i];
            //     if (!_m_next.isHidden) {
            //         break;
            //     } else {
            //         _m_next = false
            //     }
            // };

            _m_next = prevNextSiblings.next;




            if (_m_next) {
                n = n.split("."); //n could be image.url, so iterate through object
                var _obj = _m_next;
                var _obj2 = _obj;
                $.each(n, function (index, val) {
                    /* iterate through array or object */
                    if (val == "path") val = "slug";
                    if (val == "title") _obj2 = _obj.name;
                    if (val == "description") _obj2 = _obj.description;
                    if (val == "focalpoint") _obj2 = _obj.thumbnails.focalpoint.x + "," + _obj.thumbnails.focalpoint.y;
                    if (val == "width") _obj2 = _obj.thumbnails.width;
                    if (val == "height") _obj2 = _obj.thumbnails.height;
                    if (val == "image") _obj2 = _obj.thumbnails.url;
                    if (_obj[val] || _obj[val] == "") _obj2 = _obj[val];

                    if (_obj2 == null || typeof _obj2 === 'object') _obj2 = "";

                });
                //if (n == "path") _obj =_obj;
                return new Handlebars.SafeString(_obj2);
            }

            //}

        });

        Handlebars.registerHelper('ams-prevArticle', function (n, block) {
            var accum = '';

            //if (window.parent._AMS && window.parent._AMS.project) {
            // var _content = _siblings;

            // var index = _content.map(function(e) {
            //     return e.id;
            // }).indexOf(self.options.data.id); //get index of clicked module


            // //find next article
            // // _m_prev == undefined when there is no next article
            // var _m_prev;
            // for (var j = index-1 ; j >= 0; j--) {
            //     _m_prev = _content[j];
            //     if (!_m_prev.isHidden ) {
            //         break;
            //     } else {
            //         _m_prev = false
            //     }
            // };


            //if (!_m_prev) _m_prev = self.options.data;
            // _m_prev = prevNextSiblings.prev;
            // if(_m_prev){
            //     n = n.split("."); //n could be image.url
            //     var _obj = _m_prev;
            //     $.each(n, function(index, val) {
            //         /* iterate through array or object */
            //         if(_obj[val] || _obj[val]=="") _obj = _obj[val]
            //     });

            //     if (n == "path") _obj = _obj
            //     return new Handlebars.SafeString(_obj);
            // }

            _m_prev = prevNextSiblings.prev;
            if (_m_prev) {
                n = n.split("."); //n could be image.url, so iterate through object
                var _obj = _m_prev;
                var _obj2 = _obj;
                $.each(n, function (index, val) {
                    /* iterate through array or object */
                    if (val == "path") val = "slug";
                    if (val == "title") _obj2 = _obj.name;
                    if (val == "description") _obj2 = _obj.description;
                    if (val == "focalpoint") _obj2 = _obj.thumbnails.focalpoint.x + "," + _obj.thumbnails.focalpoint.y;
                    if (val == "width") _obj2 = _obj.thumbnails.width;
                    if (val == "height") _obj2 = _obj.thumbnails.height;
                    if (val == "image") _obj2 = _obj.thumbnails.url;
                    if (_obj[val] || _obj[val] == "") _obj2 = _obj[val]

                    if (_obj2 == null || typeof _obj2 === 'object') _obj2 = "";

                });
                //if (n == "path") _obj =_obj;
                return new Handlebars.SafeString(_obj2);
            }


            //}

        });


        Handlebars.registerHelper('ams-settings', function (n, block) {
            var accum = '';

            if (false && window.parent._AMS && window.parent._AMS.project) {
                var _content = _siblings;

                n = n.split("."); //n could be image.url, so iterate through object
                var _obj = _content;
                $.each(n, function (index, val) {

                    if (_obj[val]) _obj = _obj[val]
                });

                if (n == "path") _obj = _obj;
                return new Handlebars.SafeString(_obj);
            }

        });



        Handlebars.registerHelper('logo', function (n, block) {
            var _content = self.corporateIdentity.logo ? self.corporateIdentity.logo.image.url : "";
            return new Handlebars.SafeString(_content);
        });




        //var _content = $(content);
        //console.error(_content)

        var _dom = self.window.document.createElement("div");
        _dom.innerHTML = content.trim();
        var _content = $(_dom);



        var _edit,
            _editVar,
            _editTemplate;
        // replace content of data-wps-edit-variable with elements content so the handlebars var will always get updated
        _variables = _content.find("[data-wps-edit-variable]").addBack("[data-wps-edit-variable]");
        //console.error("_variables",_variables)
        if (_variables.length > 0) {

            $.each(_variables, function (index, el) {
                _editVar = $(el).attr("data-wps-edit-variable");
                _edit = "{{" + $(el).attr("data-wps-edit-variable") + "}}";



                //cleaning v1 Templates to v2
                switch (_editVar) {
                    case "ams-nextArticle 'path'":
                        _editVar = "ams-nextArticle 'page.slug'"
                        break;
                    case "ams-nextArticle 'slug'":
                        _editVar = "ams-nextArticle 'page.slug'"
                        break;
                    case "ams-nextArticle 'subtitle'":
                        _editVar = "ams-nextArticle 'page.description'"
                        break;
                    case "ams-nextArticle 'image.medium'":
                        _editVar = "ams-nextArticle 'page.image.url'"
                        break;
                    case "ams-prevArticle 'path'":
                        _editVar = "ams-prevArticle 'page.slug'"
                        break;
                    case "ams-prevArticle 'path'":
                        _editVar = "ams-prevArticle 'page.slug'"
                        break;
                    case "ams-prevArticle 'subtitle'":
                        _editVar = "ams-prevArticle 'page.description'"
                        break;
                    case "ams-prevArticle 'image.medium'":
                        _editVar = "ams-prevArticle 'page.image.url'"
                        break;

                }
                $(el).attr("data-wps-edit-variable", _editVar); // add new data-wps-edit-variable attribute to snippet


                if (el.tagName.toLowerCase() == "img") {
                    var defaultImage = $(el).attr("data-wps-image-default") || $(el).attr("src");
                    // if no next/previous article, add default src
                    $(el).attr("src", "{{#if (" + _editVar + ")}}{{" + _editVar + "}}{{else}}" + defaultImage + "{{/if}}");
                    $(el).attr("data-src", "{{#if (" + _editVar + ")}}{{" + _editVar + "}}{{else}}" + defaultImage + "{{/if}}");

                    //set focalpoint and width/height
                    $(el).parent().attr("data-focus", "{{#if (" + _editVar + ")}}{{" + _editVar.replace(/(["'])(?:(?=(\\?))\2.)*?\1/g, "'image.focalpoint.x'") + "}} {{" + _editVar.replace(/(["'])(?:(?=(\\?))\2.)*?\1/g, "'image.focalpoint.y'") + "}}{{else}}" + "50 50" + "{{/if}}");
                    $(el).parent().attr("data-size", "{{#if (" + _editVar + ")}}{{" + _editVar.replace(/(["'])(?:(?=(\\?))\2.)*?\1/g, "'image.width'") + "}},{{" + _editVar.replace(/(["'])(?:(?=(\\?))\2.)*?\1/g, "'image.height'") + "}}{{else}}" + "1024,600" + "{{/if}}");





                    //$(el).attr("src", _edit)
                }
                else if (el.tagName.toLowerCase() == "a") {
                    // if no next/previous article, add default href
                    $(el).attr("href", "{{#if (" + _editVar + ")}}{{" + _editVar + "}}{{else}}" + $(el).attr("href") + "{{/if}}")
                }
                else if ($(el).css('background-image') != 'none' && $(el).css('background-image') != '') {
                    // change background image
                    _editTemplate = Handlebars.compile(_edit);
                    _edit = _editTemplate();
                    var backgroundImage = el.style.backgroundImage;
                    var url = backgroundImage.slice(4, -1).replace(/["']/g, "")
                    $(el).css('background-image', 'url(' + "{{#if (" + _editVar + ")}}{{" + _editVar + "}}{{else}}" + url + "{{/if}}" + ')')
                }
                else {
                    if ($(el).children().length > 0) {
                        // Has child elements - preserve HTML structure
                        var existingHtml = $(el).html();
                        console.log("existingHtml", existingHtml);

                        // Create a temporary DOM element to parse the HTML
                        var tempDiv = $('<div>').html(existingHtml);
                        var textContent = tempDiv.text();
                        console.log("textContent", textContent);

                        $(el).html(existingHtml.replace(
                            textContent,
                            _edit
                        ));
                    } else {
                        // No child elements - simple replacement
                        $(el).html(_edit);
                    }
                }
            });
        }



        if ($(_content).children().length == 0) {
            _content = $(_content).html();
        } else {
            _content = $(_content).children()[0].outerHTML; //to string again
        }



        //compile and fill template with handlebars
        var template = Handlebars.compile(_content);
        var html = template(self.options.data);




        // Also set all Helpers in p$.utils.compileHandlebars!!
        return html;


    }


    KEditor.prototype.addImageHandler = function (contentArea) {
        var self = this;

        // check priviledge for user
        if (!self.privileges.includes('can_edit_page') && !self.options.isSysAdmin) return;

        var _img = $(contentArea).find("img[data-wps-edit]").not(".fr-image"),
            _src = _img.attr("src")

        var imgTool = $('<div class="divToolImg" style="display: block;"><i id="lnkEditImage" class="fa fa-camera"></i></div>')

        console.log("_img addImageHandler", _img);
        // Add drag handler div after each editable image
        _img.each(function () {
            var $img = $(this);
            var $figure = $img.closest('figure');
            $figure.find('.img-drag-handler').remove();
            // Create drag handler if it doesn't exist
            if ($figure.find('.img-drag-handler').length === 0) {
                var dragHandler = $('<div class="img-drag-handler"></div>');
                var percentageDisplay = $('<span class="percentage-display"></span>');
                dragHandler.append(percentageDisplay);
                $figure.append(dragHandler);

                // Add transition to figure element
                $figure.css({
                    'transition': 'padding-bottom 0.1s ease-out',
                    'will-change': 'padding-bottom' // Optimize performance
                });

                // Add styles for drag handler
                dragHandler.css({
                    'position': 'absolute',
                    'bottom': '0',
                    'left': '0',
                    'right': '0',
                    'height': '20px',
                    'background': 'rgba(0,0,0,0.3)',
                    'cursor': 'ns-resize',
                    'opacity': '0',
                    'transition': 'opacity 0.2s',
                    'z-index': '9'
                });

                percentageDisplay.css({
                    'position': 'absolute',
                    'right': '8px',
                    'bottom': '2px',
                    'color': '#fff',
                    'font-size': '12px',
                    'font-family': 'monospace',
                    'opacity': '0',
                    'transition': 'opacity 0.2s'
                });

                // Show/hide handler on hover
                $figure.hover(
                    function () {
                        dragHandler.css('opacity', '1');
                        if (isDragging) percentageDisplay.css('opacity', '1');
                    },
                    function () {
                        if (!isDragging) {
                            dragHandler.css('opacity', '0');
                            percentageDisplay.css('opacity', '0');
                        }
                    }
                );

                // Initialize drag functionality
                var isDragging = false;
                var startY, startPadding;
                var lastUpdate = 0;
                var rafId = null;

                dragHandler.on('mousedown', function (e) {
                    console.log("mousedown");
                    isDragging = true;
                    startY = e.pageY;
                    startPadding = parseFloat($figure.css('padding-bottom')) / $figure.width() * 100;
                    percentageDisplay.css('opacity', '1');
                    console.log("startPadding", startPadding);

                    // Handle mousemove on both documents
                    function handleMouseMove(e) {
                        if (!isDragging) return;

                        // Use requestAnimationFrame for smooth updates
                        if (rafId) cancelAnimationFrame(rafId);

                        rafId = requestAnimationFrame(function () {
                            var currentTime = performance.now();
                            // Throttle updates to every 16ms (approximately 60fps)
                            if (currentTime - lastUpdate > 16) {
                                var deltaY = e.pageY - startY;
                                // Reduce sensitivity for smoother changes
                                var sensitivity = Math.max(0.5, startPadding / 200);
                                var deltaPercent = (deltaY / $figure.width()) * 100 * sensitivity;
                                var newPadding = Math.max(0, startPadding + deltaPercent);

                                newPadding = Math.round(newPadding * 100) / 100;

                                // Update display and apply new padding
                                percentageDisplay.text(Math.round(newPadding) + '%');
                                $figure.css('padding-bottom', newPadding + '%');

                                lastUpdate = currentTime;
                            }
                        });
                    }

                    function handleMouseUp() {
                        if (isDragging) {
                            isDragging = false;
                            if (rafId) {
                                cancelAnimationFrame(rafId);
                                rafId = null;
                            }
                            // Get current padding in percentage
                            var currentPadding = parseFloat($figure.css('padding-bottom')) / $figure.width() * 100;
                            var snappedPadding = Math.round(currentPadding);
                            console.log("currentPadding", currentPadding);
                            var snappedPadding = Math.round(currentPadding);
                            console.log("snappedPadding", snappedPadding);

                            // Apply the snapped value with transition
                            $figure.css({
                                'transition': 'padding-bottom 0.15s ease-out',
                                'padding-bottom': snappedPadding + '%'
                            });

                            // Update percentage display one last time
                            percentageDisplay.text(snappedPadding + '%');

                            // Clean up
                            $(self.iframeDoc).off('mousemove', handleMouseMove);
                            $(document).off('mousemove', handleMouseMove);
                            $(self.iframeDoc).off('mouseup', handleMouseUp);
                            $(document).off('mouseup', handleMouseUp);

                            // Fade out the handlers after a brief delay
                            setTimeout(function () {
                                dragHandler.css('opacity', '0');
                                percentageDisplay.css('opacity', '0');
                            }, 200);

                            self.save();
                        }
                    }

                    // Bind events to both documents
                    $(self.iframeDoc).on('mousemove', handleMouseMove);
                    $(document).on('mousemove', handleMouseMove);
                    $(self.iframeDoc).on('mouseup', handleMouseUp);
                    $(document).on('mouseup', handleMouseUp);

                    e.preventDefault();
                });
            }
        });

        _img.off('mouseenter mouseleave').on({ //Change space separation from comma separation.
            mouseenter: function (ev) {
                if ($(this).hasClass("fr-image")) return;
                // if it has a clicked class, dont show image changer
                if ($(this).closest(".ams-click").length > 0) return;
                $(this).parent().addClass("img-hover");
                //$(this).parent().append(imgTool);
                //imgTool.show();
            },
            mouseleave: function (ev) {
                $(this).parent().removeClass("img-hover");
                //if (!$(ev.relatedTarget).is(imgTool) && !$(ev.relatedTarget).parent().is(imgTool)) imgTool.hide();
            }
        });


        /*$(contentArea).off('mouseenter mouseleave').on({ //Change space separation from comma separation.
            mouseenter : function (ev) {
                var x = ev.originalEvent.clientX, y = ev.originalEvent.clientY,
                        elementMouseIsOver = self.iframeDoc[0].elementsFromPoint(x, y),
                        imageDiv;
                console.log(elementMouseIsOver)

                $.each(elementMouseIsOver, function(index, val) {


                     if($(val).is("img")){
                        if(val.hasAttribute("data-wps-edit")){
                            console.error(val);
                            imageDiv = val;
                            return false;
                        }
                     }
                });


                $(imageDiv).parent().append(imgTool);
                imgTool.show();



            },

            mouseleave : function (ev) {
                if (!$(ev.relatedTarget).is(imgTool) && !$(ev.relatedTarget).parent().is(imgTool)) imgTool.hide();
            }

        });*/

        //imgTool.off("click").on("click", function(ev) {
        _img.off("click").on("click", function (ev) {

            var _img = ev.currentTarget,
                _size = ($(_img).parent().attr('data-size')) ? $(_img).parent().attr('data-size').split(",") : [null, null],
                _focus = $(_img).parent().attr('data-focus'),
                _variable = $(_img).attr("data-wps-variable"),
                _personalization = {};

            if (_variable) {
                var _variableSplit = _variable.split(".");
                if (_variableSplit.length == 2) {
                    _personalization = {
                        setId: parseInt(_variableSplit[0]),
                        valueId: _variableSplit[1]
                    }
                }
            }
            console.log("_personalization", _personalization);

            if (typeof self.options.callFromKeditor === 'function') self.options.callFromKeditor("imageUploadModal", {
                "src": _img.src,
                "width": _size[0],
                "height": _size[1],
                "focal": _focus,
                "personalization": _personalization,
            }, function (data) {

                console.error("data", data);

                var _group = $(_img).attr("data-wps-edit-group");
                var _focal = data[0].focalpoint;


                // set image dimensions
                var _w = Math.max($(_img).width(), 900);
                var _h = Math.max($(_img).height(), 900);

                data[0].url = self.cloudImageFunction(data[0].url, { width: _w, height: _h }, data[0]);

                if (data[0].personalization) {

                    $(_img).attr("data-wps-variable", data[0].personalization.setId + "." + data[0].personalization.valueId)
                } else {
                    $(_img).removeAttr("data-wps-variable");
                }

                // preload the result image thumbnail
                $(_img).removeAttr('data-wps-edit-variable'); //delete data-wps-edit-variable
                $(_img).removeAttr('srcset'); //delete data-wps-edit-variable
                $(_img).attr("data-url", data[0].url);
                $(_img).parent().attr("data-focus", _focal.x + "," + _focal.y);

                // Function to set dimensions and auto-fit
                function setImageDimensions(width, height) {
                    if (width && height) {
                        $(_img).parent().attr("data-size", width + "," + height);

                        if (!$(_img).parent().hasClass("no_auto_fit")) {
                            var _el,
                                _auto_fit = $(_img).attr('data-wps-auto-fit');
                            if (_auto_fit == true) {
                                _el = $(_img).parent();
                            } else {
                                _el = $(_img).closest(_auto_fit);
                            }
                            var _percentage = height / width * 100;
                            _el.css({
                                paddingBottom: _percentage + '%'
                            });
                        }
                    }
                }

                // Set image source
                $(_img).attr("src", data[0].url);

                // Use provided dimensions if available
                if (data[0].width && data[0].height) {
                    setImageDimensions(data[0].width, data[0].height);
                } else {
                    // Fallback: get dimensions from the actual image
                    var img = new Image();
                    img.onload = function () {
                        setImageDimensions(this.naturalWidth, this.naturalHeight);
                    };
                    img.src = data[0].url;
                }

                if (_group) {
                    // find group attributes in component
                    var _groupEl = component.find('[data-wps-edit-group="' + _group + '"]');

                    $.each(_groupEl, function (index, el) {

                        // if it is not the _img itself, change image to new one
                        if (el != image[0]) {
                            $(el).attr("data-srcset", _srcset);
                            //$(el).attr("data-id", data.file.id);
                            $(el).parent().attr("data-focus", _focal.x + "," + _focal.y);

                            // if attribute data-wps-edit-size was set in element:
                            if (_size) {
                                $(el).attr("src", data[0].url.replace("/s/", "/" + _size + "/"));
                            } else {
                                $(el).attr("src", data[0].url.replace("/s/", "/l/"));
                            }
                        }
                    });
                    // find group attributes in settings-form
                    var container = _button.closest(".keditor-setting-form");
                    var _groupEl = container.find('[data-wps-edit-group="' + _group + '"]');
                    $.each(_groupEl, function (index, el) {
                        $(el).attr("src", data[0].url);
                    });
                }

                // cloudimage.io
                // first set src to si-src to make it work
                //   var ciResponsive = new window.parent.CIResponsive({
                //     token: 'axyqwmwryo'
                //   });

                self.window.imgCover.update(self.body[0]);
                self.save();
            })


        });


    }

    /**
     * Initialize padding drag handlers for elements with vertical spacing
     * Similar to img-drag-handler but for top/bottom padding
     */
    KEditor.prototype.initPaddingDragHandlers = function (contentArea) {
        var self = this;

        // Check privilege for user
        if (!self.privileges.includes('can_edit_page') && !self.options.isSysAdmin) return;

        // Check if contentArea is valid
        if (!contentArea || !contentArea.length || !contentArea.find) return;

        // Find all elements with vertical spacing edit
        var $spacingElements = contentArea.find('[data-wps-edit-name="vertical spacing size"]');

        $spacingElements.each(function () {
            var $spacingEl = $(this);

            // Remove existing handlers
            $spacingEl.find('.padding-drag-handler-top, .padding-drag-handler-bottom').remove();

            // Get current padding in px from computed style
            var computedStyle = self.window.getComputedStyle($spacingEl[0]);
            var currentTopPx = parseFloat(computedStyle.paddingTop) || 0;
            var currentBottomPx = parseFloat(computedStyle.paddingBottom) || 0;

            // Create top drag handler
            var $topHandler = $('<div class="padding-drag-handler-top"></div>');
            var $topDisplay = $('<span class="padding-display"></span>');
            $topHandler.append($topDisplay);
            $spacingEl.prepend($topHandler);

            // Create bottom drag handler
            var $bottomHandler = $('<div class="padding-drag-handler-bottom"></div>');
            var $bottomDisplay = $('<span class="padding-display"></span>');
            $bottomHandler.append($bottomDisplay);
            $spacingEl.append($bottomHandler);


            // Style displays
            var displayStyle = {};

            $topDisplay.css($.extend({}, displayStyle, {
                'top': '2px'
            }));

            $bottomDisplay.css($.extend({}, displayStyle, {
                'bottom': '2px'
            }));

            // Make spacing element relative positioned
            var currentPosition = $spacingEl.css('position');
            if (currentPosition === 'static') {
                $spacingEl.css('position', 'relative');
            }

            // Helper function to remove pt-* classes only
            function removeTopPaddingClasses() {
                var classes = ($spacingEl.attr('class') || '').split(' ');
                var newClasses = classes.filter(function (cls) {
                    return !cls.startsWith('pt-');
                });
                $spacingEl.attr('class', newClasses.join(' '));
            }

            // Helper function to remove pb-* classes only
            function removeBottomPaddingClasses() {
                var classes = ($spacingEl.attr('class') || '').split(' ');
                var newClasses = classes.filter(function (cls) {
                    return !cls.startsWith('pb-');
                });
                $spacingEl.attr('class', newClasses.join(' '));
            }

            // Padding classes sequence for cycling
            var topPaddingClasses = ['pt-0', 'pt-2', 'pt-3', 'pt-4', 'pt-5', 'pt-6'];
            var bottomPaddingClasses = ['pb-0', 'pb-2', 'pb-3', 'pb-4', 'pb-5', 'pb-6'];

            // Mapping from class names to friendly names
            var classToFriendlyName = {
                'pt-0': 'none', 'pb-0': 'none',
                'pt-2': 'xs', 'pb-2': 'xs',
                'pt-3': 's', 'pb-3': 's',
                'pt-4': 'm', 'pb-4': 'm',
                'pt-5': 'l', 'pb-5': 'l',
                'pt-6': 'xl', 'pb-6': 'xl'
            };

            // Mapping from class names to px values
            var classToPx = {
                'pt-0': 0, 'pb-0': 0,
                'pt-2': 8, 'pb-2': 8,
                'pt-3': 16, 'pb-3': 16,
                'pt-4': 24, 'pb-4': 24,
                'pt-5': 48, 'pb-5': 48,
                'pt-6': 64, 'pb-6': 64
            };

            // Helper function to get friendly name from class
            function getFriendlyName(className) {
                return classToFriendlyName[className] || className;
            }

            // Helper function to find nearest class based on px value
            function findNearestClass(pxValue, classSequence) {
                var nearestClass = classSequence[0];
                var minDiff = Infinity;

                for (var i = 0; i < classSequence.length; i++) {
                    var classPx = classToPx[classSequence[i]];
                    var diff = Math.abs(pxValue - classPx);
                    if (diff < minDiff) {
                        minDiff = diff;
                        nearestClass = classSequence[i];
                    }
                }

                return nearestClass;
            }

            // Helper function to get friendly name for px value if it matches a class
            function getDisplayValue(pxValue, classSequence) {
                // Check if px value exactly matches any class value
                for (var i = 0; i < classSequence.length; i++) {
                    if (classToPx[classSequence[i]] === pxValue) {
                        return getFriendlyName(classSequence[i]) + ' - ' + pxValue + 'px';
                    }
                }
                // Otherwise return px value
                return pxValue + 'px';
            }

            // Helper function to get next padding class in sequence
            function getNextPaddingClass(currentClasses, classSequence, currentPx) {
                // First try to find current class in sequence
                var currentIndex = -1;
                for (var i = 0; i < classSequence.length; i++) {
                    if ($.inArray(classSequence[i], currentClasses) !== -1) {
                        currentIndex = i;
                        break;
                    }
                }

                // If no class found, find nearest class based on px value
                if (currentIndex === -1 && currentPx !== undefined) {
                    var nearestClass = findNearestClass(currentPx, classSequence);
                    for (var j = 0; j < classSequence.length; j++) {
                        if (classSequence[j] === nearestClass) {
                            currentIndex = j;
                            break;
                        }
                    }
                }

                // Return next class in sequence, or first if none found or at end
                var nextIndex = (currentIndex + 1) % classSequence.length;
                return classSequence[nextIndex];
            }

            // Setup drag handler for top padding
            function setupTopHandler() {
                var isDragging = false;
                var hasDragged = false; // Track if mouse actually moved
                var startY, startPadding;
                var lastUpdate = 0;
                var rafId = null;

                $topHandler.on('mousedown', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    isDragging = true;
                    hasDragged = false; // Reset drag flag
                    startY = e.pageY;
                    startPadding = parseFloat($spacingEl.css('padding-top')) || 0;
                    var useSnapMode = e.metaKey || e.ctrlKey; // Cmd on Mac, Ctrl on Windows

                    $topHandler.data('isDragging', true);
                    $topDisplay.css('opacity', '1');

                    function handleMouseMove(e) {
                        if (!isDragging) return;

                        hasDragged = true; // Mark that dragging occurred
                        var currentSnapMode = e.metaKey || e.ctrlKey;

                        if (rafId) cancelAnimationFrame(rafId);

                        rafId = requestAnimationFrame(function () {
                            var currentTime = performance.now();
                            if (currentTime - lastUpdate > 16) {
                                var deltaY = startY - e.pageY; // Inverted for top padding
                                var sensitivity = 1;
                                var newPadding = Math.max(0, startPadding + (deltaY * sensitivity));

                                newPadding = Math.round(newPadding);

                                if (currentSnapMode) {
                                    // Snap to nearest class value
                                    var nearestClass = findNearestClass(newPadding, topPaddingClasses);
                                    var snappedPx = classToPx[nearestClass];

                                    removeTopPaddingClasses();
                                    $spacingEl.css('padding-top', snappedPx + 'px');
                                    $topDisplay.text(getFriendlyName(nearestClass));
                                } else {
                                    // Use free px values
                                    removeTopPaddingClasses();
                                    $spacingEl.css('padding-top', newPadding + 'px');
                                    $topDisplay.text(getDisplayValue(newPadding, topPaddingClasses));
                                }

                                lastUpdate = currentTime;
                            }
                        });
                    }

                    function handleMouseUp(e) {
                        if (isDragging) {
                            isDragging = false;
                            $topHandler.data('isDragging', false);
                            if (rafId) {
                                cancelAnimationFrame(rafId);
                                rafId = null;
                            }

                            // Only remove classes and apply px if actually dragged
                            if (hasDragged) {
                                var finalUseSnapMode = e.metaKey || e.ctrlKey;
                                var finalPadding = parseFloat($spacingEl.css('padding-top')) || 0;

                                if (finalUseSnapMode) {
                                    // Snap to nearest class
                                    var nearestClass = findNearestClass(finalPadding, topPaddingClasses);
                                    var snappedPx = classToPx[nearestClass];

                                    removeTopPaddingClasses();
                                    $spacingEl.addClass(nearestClass);
                                    $spacingEl.css('padding-top', '');
                                    $topDisplay.text(getFriendlyName(nearestClass));
                                } else {
                                    // Use px values
                                    removeTopPaddingClasses();
                                    $spacingEl.css('padding-top', finalPadding + 'px');
                                    $topDisplay.text(getDisplayValue(finalPadding, topPaddingClasses));
                                }
                            }

                            $(self.iframeDoc).off('mousemove', handleMouseMove);
                            $(document).off('mousemove', handleMouseMove);
                            $(self.iframeDoc).off('mouseup', handleMouseUp);
                            $(document).off('mouseup', handleMouseUp);

                            setTimeout(function () {
                                if (!$topHandler.data('isDragging')) {
                                    $topHandler.css('opacity', '0');
                                    $topDisplay.css('opacity', '0');
                                }
                            }, 200);

                            if (hasDragged) {
                                self.save();
                            }
                        }
                    }

                    $(self.iframeDoc).on('mousemove', handleMouseMove);
                    $(document).on('mousemove', handleMouseMove);
                    $(self.iframeDoc).on('mouseup', handleMouseUp);
                    $(document).on('mouseup', handleMouseUp);
                });
            }

            // Setup drag handler for bottom padding
            function setupBottomHandler() {
                var isDragging = false;
                var hasDragged = false; // Track if mouse actually moved
                var startY, startPadding;
                var lastUpdate = 0;
                var rafId = null;

                $bottomHandler.on('mousedown', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    isDragging = true;
                    hasDragged = false; // Reset drag flag
                    startY = e.pageY;
                    startPadding = parseFloat($spacingEl.css('padding-bottom')) || 0;
                    var useSnapMode = e.metaKey || e.ctrlKey; // Cmd on Mac, Ctrl on Windows

                    $bottomHandler.data('isDragging', true);
                    $bottomDisplay.css('opacity', '1');

                    function handleMouseMove(e) {
                        if (!isDragging) return;

                        hasDragged = true; // Mark that dragging occurred
                        var currentSnapMode = e.metaKey || e.ctrlKey;

                        if (rafId) cancelAnimationFrame(rafId);

                        rafId = requestAnimationFrame(function () {
                            var currentTime = performance.now();
                            if (currentTime - lastUpdate > 16) {
                                var deltaY = e.pageY - startY;
                                var sensitivity = 1;
                                var newPadding = Math.max(0, startPadding + (deltaY * sensitivity));

                                newPadding = Math.round(newPadding);

                                if (currentSnapMode) {
                                    // Snap to nearest class value
                                    var nearestClass = findNearestClass(newPadding, bottomPaddingClasses);
                                    var snappedPx = classToPx[nearestClass];

                                    removeBottomPaddingClasses();
                                    $spacingEl.css('padding-bottom', snappedPx + 'px');
                                    $bottomDisplay.text(getFriendlyName(nearestClass));
                                } else {
                                    // Use free px values
                                    removeBottomPaddingClasses();
                                    $spacingEl.css('padding-bottom', newPadding + 'px');
                                    $bottomDisplay.text(getDisplayValue(newPadding, bottomPaddingClasses));
                                }

                                lastUpdate = currentTime;
                            }
                        });
                    }

                    function handleMouseUp(e) {
                        if (isDragging) {
                            isDragging = false;
                            $bottomHandler.data('isDragging', false);
                            if (rafId) {
                                cancelAnimationFrame(rafId);
                                rafId = null;
                            }

                            // Only remove classes and apply px if actually dragged
                            if (hasDragged) {
                                var finalUseSnapMode = e.metaKey || e.ctrlKey;
                                var finalPadding = parseFloat($spacingEl.css('padding-bottom')) || 0;

                                if (finalUseSnapMode) {
                                    // Snap to nearest class
                                    var nearestClass = findNearestClass(finalPadding, bottomPaddingClasses);
                                    var snappedPx = classToPx[nearestClass];

                                    removeBottomPaddingClasses();
                                    $spacingEl.addClass(nearestClass);
                                    $spacingEl.css('padding-bottom', '');
                                    $bottomDisplay.text(getFriendlyName(nearestClass));
                                } else {
                                    // Use px values
                                    removeBottomPaddingClasses();
                                    $spacingEl.css('padding-bottom', finalPadding + 'px');
                                    $bottomDisplay.text(getDisplayValue(finalPadding, bottomPaddingClasses));
                                }
                            }

                            $(self.iframeDoc).off('mousemove', handleMouseMove);
                            $(document).off('mousemove', handleMouseMove);
                            $(self.iframeDoc).off('mouseup', handleMouseUp);
                            $(document).off('mouseup', handleMouseUp);

                            setTimeout(function () {
                                if (!$bottomHandler.data('isDragging')) {
                                    $bottomHandler.css('opacity', '0');
                                    $bottomDisplay.css('opacity', '0');
                                }
                            }, 200);

                            if (hasDragged) {
                                self.save();
                            }
                        }
                    }

                    $(self.iframeDoc).on('mousemove', handleMouseMove);
                    $(document).on('mousemove', handleMouseMove);
                    $(self.iframeDoc).on('mouseup', handleMouseUp);
                    $(document).on('mouseup', handleMouseUp);
                });
            }

            // Show/hide handlers only when hovering the handler itself
            $topHandler.hover(
                function () {
                    $topHandler.css('opacity', '1');
                    // Show current padding value or class
                    var currentClasses = ($spacingEl.attr('class') || '').split(' ').filter(function (c) { return c.trim(); });
                    var ptClass = '';
                    for (var i = 0; i < topPaddingClasses.length; i++) {
                        if ($.inArray(topPaddingClasses[i], currentClasses) !== -1) {
                            ptClass = topPaddingClasses[i];
                            break;
                        }
                    }
                    if (ptClass) {
                        $topDisplay.text(getFriendlyName(ptClass)).css('opacity', '1');
                    } else {
                        var pxValue = parseFloat($spacingEl.css('padding-top')) || 0;
                        $topDisplay.text(pxValue + 'px').css('opacity', '1');
                    }
                },
                function () {
                    if (!$topHandler.data('isDragging')) {
                        $topHandler.css('opacity', '0');
                        $topDisplay.css('opacity', '0');
                    }
                }
            );

            $bottomHandler.hover(
                function () {
                    $bottomHandler.css('opacity', '1');
                    // Show current padding value or class
                    var currentClasses = ($spacingEl.attr('class') || '').split(' ').filter(function (c) { return c.trim(); });
                    var pbClass = '';
                    for (var i = 0; i < bottomPaddingClasses.length; i++) {
                        if ($.inArray(bottomPaddingClasses[i], currentClasses) !== -1) {
                            pbClass = bottomPaddingClasses[i];
                            break;
                        }
                    }
                    if (pbClass) {
                        $bottomDisplay.text(getFriendlyName(pbClass)).css('opacity', '1');
                    } else {
                        var pxValue = parseFloat($spacingEl.css('padding-bottom')) || 0;
                        $bottomDisplay.text(pxValue + 'px').css('opacity', '1');
                    }
                },
                function () {
                    if (!$bottomHandler.data('isDragging')) {
                        $bottomHandler.css('opacity', '0');
                        $bottomDisplay.css('opacity', '0');
                    }
                }
            );

            setupTopHandler();
            setupBottomHandler();

            // Double-click handler for top padding - cycle through classes
            $topHandler.on('dblclick', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var currentClasses = ($spacingEl.attr('class') || '').split(' ').filter(function (c) { return c.trim(); });
                var currentPx = parseFloat($spacingEl.css('padding-top')) || 0;
                var nextClass = getNextPaddingClass(currentClasses, topPaddingClasses, currentPx);

                // Remove current pt-* classes and inline style
                removeTopPaddingClasses();
                $spacingEl.css('padding-top', '');

                // Add new class
                $spacingEl.addClass(nextClass);

                // Update display with friendly name
                $topDisplay.text(getFriendlyName(nextClass));

                self.save();
            });

            // Double-click handler for bottom padding - cycle through classes
            $bottomHandler.on('dblclick', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var currentClasses = ($spacingEl.attr('class') || '').split(' ').filter(function (c) { return c.trim(); });
                var currentPx = parseFloat($spacingEl.css('padding-bottom')) || 0;
                var nextClass = getNextPaddingClass(currentClasses, bottomPaddingClasses, currentPx);

                // Remove current pb-* classes and inline style
                removeBottomPaddingClasses();
                $spacingEl.css('padding-bottom', '');

                // Add new class
                $spacingEl.addClass(nextClass);

                // Update display with friendly name
                $bottomDisplay.text(getFriendlyName(nextClass));

                self.save();
            });
        });
    }


    KEditor.prototype.buildFocalPointHelper = function (image) {

        var self = this;
        var html = "<div id='Frames'>";

        for (var i = 1; i <= 9; i++) {
            html += "<div id='Frame" + i + "' class='focuspoint'> <img-cover class='pgs-image' data-focus='50,50' data-size='1703,614'> <img src='" + image.attr("src") + "'></img-cover></div>"
        }

        html += "</div>";

        /*var popup = self.buildPopup(html);
        $(self.body).append(popup);
        $(self.body).addClass("ams-desktop") // delete later!

        setTimeout(function() {
            popup.addClass('md-show')
        }, 10);
        */




    }

    KEditor.prototype.buildPopup = function (content) {

        var self = this;

        var _modal = $('<div class="pgs_modal pgs_modal_image_upload md-effect-1 " ><div class="md-content">' + content + '<div class="ams-po-buttons"><ul><li><button type="button" class="ams-active"><span>OK</span></button></li></ul></div></div></div><div class="pgs_modal_overlay"></div>');

        _modal.find(".ams-active").addBack(".ams-active").on("click", close);
        _modal.find(".pgs_modal_overlay").addBack(".pgs_modal_overlay").on("click", close);

        function close() {
            _modal.removeClass('md-show');
            setTimeout(function () {
                _modal.remove();
            }, 300);
        };

        return _modal;
    }


    KEditor.prototype.addUploader = function (_button, _dropzone, image, _options, callback) {

        var self = this;
        return;


        console.log("addUploader", _button, _dropzone, image);
        var _img = image,
            _size = $(_img).parent().attr('data-size'),
            _size = (_size) ? _size.split(",") : "",
            _focus = $(_img).parent().attr('data-focus');

        if (typeof self.options.callFromKeditor === 'function') self.options.callFromKeditor("imageUploadModal", {
            "src": _img.src,
            "width": _size[0],
            "height": _size[1],
            "focal": _focus
        }, function (data) {
            console.log("callFromKeditor", data[0]);
            console.log(data[0].url)


            var _group = $(_img).attr("data-wps-edit-group");
            var _focal = data[0].focalpoint;



            // if it is a video file return immediately
            if (data.file.type.indexOf("video/mp4") >= 0
                || data.file.type.indexOf("audio/mp3") >= 0
                || data.file.type.indexOf("audio/mpeg") >= 0) {
                callback(data);
                self.save();
                return;
            }
            // set image dimensions
            var _w = $(_img).width();
            var _h = $(_img).height();
            data[0].url = self.cloudImageFunction(data[0].url, { width: _w, height: _h }, data[0]);


            // preload the result image thumbnail
            $(_img).removeAttr('data-wps-edit-variable'); //delete data-wps-edit-variable
            $(_img).removeAttr('srcset'); //delete data-wps-edit-variable
            $(_img).attr("data-url", data[0].url);
            $(_img).parent().attr("data-focus", _focal.x + "," + _focal.y);
            if (data[0].width && data[0].height) $(_img).parent().attr("data-size", data[0].width + "," + data[0].height);
            $(_img).attr("src", data[0].url)

            if (data[0].width && data[0].height) {
                if (!$(_img).parent().hasClass("no_auto_fit")) {
                    var _el,
                        _auto_fit = $(_img).attr('data-wps-auto-fit');
                    if (_auto_fit == true) {
                        _el = $(_img).parent();
                    } else {
                        _el = $(_img).closest(_auto_fit);
                    }
                    var _percentage = data[0].height / data[0].width * 100;
                    _el.css({
                        paddingBottom: _percentage + '%'
                    });
                }
            }

            if (_group) {
                // find group attributes in component
                var _groupEl = component.find('[data-wps-edit-group="' + _group + '"]');

                $.each(_groupEl, function (index, el) {

                    // if it is not the _img itself, change image to new one
                    if (el != image[0]) {
                        $(el).attr("data-srcset", _srcset);
                        //$(el).attr("data-id", data.file.id);
                        $(el).parent().attr("data-focus", _focal.x + "," + _focal.y);

                        // if attribute data-wps-edit-size was set in element:
                        if (_size) {
                            $(el).attr("src", data[0].url.replace("/s/", "/" + _size + "/"));
                        } else {
                            $(el).attr("src", data[0].url.replace("/s/", "/l/"));
                        }
                    }
                });
                // find group attributes in settings-form
                var container = _button.closest(".keditor-setting-form");
                var _groupEl = container.find('[data-wps-edit-group="' + _group + '"]');
                $.each(_groupEl, function (index, el) {
                    $(el).attr("src", data[0].url);
                });
            }



            self.window.imgCover.update(self.body[0]);
            self.save();

            if (callback) {
                callback(data);
            }


        })

        return;



    }

    KEditor.prototype.absolutePath = function (href) {
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1") return href;
        var link = document.createElement("a");
        link.href = href;
        return (this.options.env.VUE_APP_PHP_SERVER_ENDPOINT + link.pathname + link.search + link.hash);
    }

    KEditor.prototype.initEditables = function (component, options) {


        var self = this;

        // check priviledge for user
        if (!self.privileges.includes('can_edit_page') && !self.options.isSysAdmin) return;

        options = options || "",
            edit_option = "",
            _options = [];

        // Register shared Froala plugins once (if not already done)
        if (!self._froalaPluginsRegistered && self.window.FroalaPluginsShared && self.window.FroalaEditor) {
            self._froalaPluginsRegistered = true;

            // Build font family object for plugin context (mirrors per-element logic below)
            var _pluginContextFonts = {};
            var _pluginCI = self.corporateIdentity || {};
            var _pluginGS = self.groupSettings || {};
            if (_pluginCI.defaultFonts) {
                $.each(_pluginCI.defaultFonts, function(k, v) { if (v && v.font) _pluginContextFonts[v.font] = v.font; });
            }
            if (_pluginCI.fontFamily) { $.extend(_pluginContextFonts, _pluginCI.fontFamily); }
            if (_pluginCI._customFonts && _pluginCI._customFonts.uploaded) {
                _pluginCI._customFonts.uploaded.forEach(function(f) { if (f && f.fontFamily) _pluginContextFonts[f.fontFamily] = f.fontFamily; });
            }
            if (_pluginCI._customFonts && _pluginCI._customFonts.google) {
                _pluginCI._customFonts.google.forEach(function(n) { if (n) _pluginContextFonts[n] = n; });
            }
            if (_pluginGS.editorSettings && _pluginGS.editorSettings.customFonts) {
                $.extend(_pluginContextFonts, _pluginGS.editorSettings.customFonts);
            }
            var _pluginSharedConfig = self.window.FroalaConfig || {};

            // Build context for shared plugins
            var pluginContext = {
                labels: self.labels,
                save: function() { self.save(); },
                callFromKeditor: self.options.callFromKeditor,
                allPageSiblings: self.options.allPageSiblings || [],
                groupSettings: self.groupSettings || {},
                chatGPTPlugin: self.options.chatGPTPlugin || null,
                corporateIdentity: self.corporateIdentity || {},
                variablesPlugin: self.options.variablesPlugin || [],
                formsData: self.options.formsData || [],
                personalizedData: self.options.personalizedData || [],
                cloudImageFunction: self.cloudImageFunction,
                isSysAdmin: self.options.isSysAdmin,
                // Base options for nested Froala instances (e.g. customTefFootnodePlugin popup editor)
                options: _pluginSharedConfig.getBaseOptions ? _pluginSharedConfig.getBaseOptions({
                    fontFamily: _pluginContextFonts
                }) : {}
            };

            try {
                self.window.FroalaPluginsShared.registerAllPlugins(self.window.FroalaEditor, pluginContext);
                console.log('KEditor: Shared Froala plugins registered successfully');
            } catch (e) {
                console.warn('KEditor: Failed to register shared Froala plugins:', e);
            }
        }

        // search for all editable elements with the attribute data-wps-edit are not a child of an element with the attribute data-wps-container  or that have the attribute data-wps-container
        var editableBlocks = component.find('[data-wps-edit]').filter(function () {
            var closestWpsContainer = $(this).closest('[data-wps-container]');
            return closestWpsContainer.length === 0 || !component.is(closestWpsContainer) && !component.find(closestWpsContainer).length;
        });




        for (var i = 0; i < editableBlocks.length; i++) {
            _editableBlock = $(editableBlocks[i]);
            // console.dir(_editableBlock[0])

            if (!_editableBlock.is("img") && !_editableBlock.hasClass("pgs-video") && _editableBlock.attr("data-wps-edit").indexOf("false") == -1) {
                //CKEDITOR.disableAutoInline = true;

                if (_editableBlock.attr("data-wps-edit-disable")) {
                    //console.error("return", editableBlocks[i])
                    // dont edit

                } else {
                    if (!_editableBlock.hasClass("fr-box")) {


                        //console.log(!_editableBlock.hasClass("fr-box"))
                        //_editableBlock.prop('contenteditable', true);

                        // get toolbar options from element
                        //var _options = KEditor.components.text.getToolbarOptions(_editableBlock, options);

                        //_options= (_editableBlock.attr("data-wps-toolbar-items")) ?  _editableBlock.attr("data-wps-toolbar-items").split(',') : ['undo', 'redo'];

                        _options = _editableBlock.attr("data-wps-toolbar-items");

                        if (_options) {
                            if (_options.indexOf("toolbarSet") >= 0) _options = self.options[_options].split(',');
                            else _options = _options.split(',');
                        } else {
                            _options = ['undo', 'redo'];
                        }

                        _options = self.options['toolbarSet6'].split(',');
                        // add extra toolbar values to editor from element
                        _options_add = _editableBlock.attr("data-wps-toolbar-items-add");
                        if (_options_add) {
                            var a = _options.indexOf("undo");
                            _options_add = _options_add.split(',')
                            _options.splice.apply(_options, [a, 0].concat(_options_add));
                        }


                        // ============================================================================
                        // FROALA PLUGINS - Now registered via FroalaPluginsShared (see line ~10283)
                        // The following plugins are handled by froala-plugins-shared.js:
                        // - customLinkList, customModalList, insertPdf
                        // - customReadMore, customButtonStyle, linkAltText
                        // - insertImage, customImageReplace, imageAudioPlugin
                        // - customVideoList, customVideoAutoplay, customVideoLoop
                        // - customVideoResponsive, customVideoReplace, customVideoAlternativeFormat
                        // - customVideoPoster, customVideoLink, customVideoLinkPlugin
                        // - customCountUp, customForms, customAnimation
                        // - line, br, DashedList, inline_snippets, customFormatUL
                        // - customFontAwesomePlugin, customTefFootnodePlugin
                        // - personalizationPlugin, chatGPT, customTableResponsive
                        // ============================================================================

                        // ============================================================
                        // GET SHARED CONFIG & BUILD DYNAMIC OPTIONS
                        // Uses FroalaConfig defaults, extends with group settings
                        // ============================================================
                        var _sharedConfig = self.window.FroalaConfig || {};
                        var _editorSettings = (self.groupSettings && self.groupSettings.editorSettings) || {};
                        var _corporateIdentity = self.corporateIdentity || {};

                        // Build colors from defaults + group settings + corporate identity
                        var _colorsText = ['#000', '#444', '#666', '#999', '#ccc', '#eee', '#f3f3f3', '#fff', 'REMOVE'];
                        if (_editorSettings.defaultColors) {
                            _colorsText = _editorSettings.defaultColors.slice();
                        }
                        if (_editorSettings._customColor) {
                            _editorSettings._customColor.forEach(function(el) {
                                if (el && _colorsText.indexOf(el) === -1) _colorsText.unshift(el);
                            });
                        }
                        if (_corporateIdentity._customColor) {
                            _corporateIdentity._customColor.forEach(function(el) {
                                if (el && _colorsText.indexOf(el) === -1) _colorsText.unshift(el);
                            });
                        }
                        var _colorsHEXInput = true;

                        // Build font families from defaults + corporate identity
                        var _customFontsObj = {};

                        // Add fonts from corporateIdentity.defaultFonts (font1, font2, font3, font4)
                        if (_corporateIdentity.defaultFonts) {
                            $.each(_corporateIdentity.defaultFonts, function(key, fontData) {
                                if (fontData && fontData.font) {
                                    _customFontsObj[fontData.font] = fontData.font;
                                }
                            });
                        }

                        // Legacy support: corporateIdentity.fontFamily (object)
                        if (_corporateIdentity.fontFamily) {
                            $.extend(_customFontsObj, _corporateIdentity.fontFamily);
                        }

                        // Legacy support: corporateIdentity._customFonts.uploaded (array)
                        if (_corporateIdentity._customFonts && _corporateIdentity._customFonts.uploaded) {
                            _corporateIdentity._customFonts.uploaded.forEach(function(font) {
                                if (font && font.fontFamily) {
                                    _customFontsObj[font.fontFamily] = font.fontFamily;
                                }
                            });
                        }

                        // Legacy support: corporateIdentity._customFonts.google (array)
                        if (_corporateIdentity._customFonts && _corporateIdentity._customFonts.google) {
                            _corporateIdentity._customFonts.google.forEach(function(fontName) {
                                if (fontName) {
                                    _customFontsObj[fontName] = fontName;
                                }
                            });
                        }

                        // Group-level custom fonts from editorSettings (e.g. {"OnAir": "OnAir"})
                        if (self.groupSettings.editorSettings && self.groupSettings.editorSettings.customFonts) {
                            $.extend(_customFontsObj, self.groupSettings.editorSettings.customFonts);
                        }

                        // Link edit buttons (conditional based on element options)
                        var linkEditButtons = ['linkEdit', 'linkRemove', 'linkStyle', 'linkAltText', '-', 'customLinkList', 'customModalList', 'customReadMoreBtn', 'insertPdf'];
                        edit_option = _editableBlock.attr("data-wps-options");
                        if (edit_option && edit_option.indexOf("linkEdit=false") >= 0) {
                            linkEditButtons = ['linkRemove', 'linkStyle'];
                        }

                        // Image edit buttons (use shared config default)
                        var imageEditButtons = _sharedConfig.IMAGE_EDIT_BUTTONS || [
                            'imageAlign', 'imageCaption', 'imageRemove', 'customImageReplace', '|',
                            'imageLink', 'linkEdit', 'linkRemove', '-', 'customLinkList', 'customModalList',
                            'imageStyle', 'imageAlt', 'imageSize', 'openImageAudioPopup', 'customAdditionalTextBtn'
                        ];

                        // Plugins (from shared config)
                        // Standard Froala plugins + third-party plugins
                        var _pluginsEnabled = (_sharedConfig.DEFAULT_PLUGINS_IFRAME || [
                            'align', 'colors', 'emoticons', 'fontFamily', 'fontSize', 'help',
                            'image', 'inlineClass', 'inlineStyle', 'lineBreaker', 'lineHeight',
                            'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'specialCharacters',
                            'table', 'url', 'wordPaste', 'codeView', 'video',
                            'fontAwesome', 'embedly'
                        ]).slice(); // Clone the array

                        // Add custom plugins (required for them to be loaded by Froala)
                        var _customPlugins = _sharedConfig.CUSTOM_PLUGINS || [
                            'customFontAwesomePlugin', 'customTefFootnodePlugin', 'customImagePlugin',
                            'customPersonalizationPlugin', 'customVideoPlugin', 'customCountUpPlugin',
                            'customAnimationPlugin', 'customReadMore', 'customFormsPlugin',
                            'customLinkAltText', 'customImageAudioPlugin', 'customVideoLinkPlugin'
                        ];
                        _pluginsEnabled = _pluginsEnabled.concat(_customPlugins);

                        // Font sizes (from shared config or corporate identity)
                        var _fontsize = _corporateIdentity.fontSize || _sharedConfig.EXTENDED_FONT_SIZES || _sharedConfig.DEFAULT_FONT_SIZES || ['10', '12', '14', '16', '18', '20', '24', '28', '32', '36', '48', '60'];

                        // ============================================================
                        // STYLE OBJECTS (from shared config + group settings)
                        // Uses helper functions from froala-config.js
                        // ============================================================
                        var _imageStyles = _sharedConfig.getImageStyles ? _sharedConfig.getImageStyles(self.labels) : {};
                        if (_editorSettings.imageStyles) $.extend(_imageStyles, _editorSettings.imageStyles);

                        var _linkStyles = _sharedConfig.getLinkStyles ? _sharedConfig.getLinkStyles(self.labels) : {};
                        if (_editorSettings.linkStyles) $.extend(_linkStyles, _editorSettings.linkStyles);

                        var _inlineClasses = _sharedConfig.getInlineClasses ? _sharedConfig.getInlineClasses(self.labels) : {};
                        if (_editorSettings.inlineClasses) $.extend(_inlineClasses, _editorSettings.inlineClasses);

                        var _tableStyles = _sharedConfig.getTableStyles ? _sharedConfig.getTableStyles(self.labels) : {};
                        if (_editorSettings.tableStyles) $.extend(_tableStyles, _editorSettings.tableStyles);

                        var _tableCellStyles = _sharedConfig.getTableCellStyles ? _sharedConfig.getTableCellStyles(self.labels) : {};
                        if (_editorSettings.tableCellStyles) $.extend(_tableCellStyles, _editorSettings.tableCellStyles);

                        var _paragraphStyles = _sharedConfig.getParagraphStyles ? _sharedConfig.getParagraphStyles(self.labels) : {};
                        if (_editorSettings.paragraphStyles) $.extend(_paragraphStyles, _editorSettings.paragraphStyles);

                        // Line heights (from shared config + group settings)
                        var _lineHeights = $.extend({}, _sharedConfig.DEFAULT_LINE_HEIGHTS || { Default: '', 1: '1', 1.5: '1.5', 2: '2' });
                        if (_editorSettings.lineHeights) $.extend(_lineHeights, _editorSettings.lineHeights);

                        // Paragraph format (from shared config + group settings)
                        var _paragraphFormat = $.extend({}, _sharedConfig.DEFAULT_PARAGRAPH_FORMAT || { H6: 'H6', H5: 'H5', H4: 'H4', H3: 'H3', H2: 'H2', H1: 'H1', N: 'Normal' });
                        if (_editorSettings.paragraphFormat) $.extend(_paragraphFormat, _editorSettings.paragraphFormat);





                        // ============================================================
                        // BUILD OPTIONS FROM SHARED CONFIG (froala-config.js)
                        // Only override what's iframe-specific
                        // ============================================================

                        // Get base options from shared config with dynamic overrides
                        var _baseOptions = _sharedConfig.getBaseOptions ? _sharedConfig.getBaseOptions({
                            // Dynamic values from group settings / corporate identity
                            colorsText: _colorsText,
                            colorsBackground: _colorsText,
                            tableColors: _colorsText,
                            colorsHEXInput: _colorsHEXInput,
                            fontSize: _fontsize,
                            fontFamily: _customFontsObj,
                            lineHeights: _lineHeights,
                            paragraphFormat: _paragraphFormat,
                            paragraphStyles: _paragraphStyles,
                            inlineClasses: _inlineClasses,
                            linkStyles: _linkStyles,
                            imageStyles: _imageStyles,
                            tableStyles: _tableStyles,
                            tableCellStyles: _tableCellStyles,
                            // Edit buttons (may have group-specific customizations)
                            linkEditButtons: linkEditButtons,
                            imageEditButtons: imageEditButtons,
                            // Plugins and toolbar
                            pluginsEnabled: _pluginsEnabled,
                            toolbarButtons: self.options['toolbarSet7'],
                            // Language
                            language: self.options.language || 'en'
                        }) : {};

                        // Fallback: ensure license key is always set even if FroalaConfig failed to load
                        if (!_baseOptions.key) {
                            _baseOptions.key = '8JF3bA2C6D5A3A1F3G3C3SmB-22gwa1DBKSPC1WKTUCQOe1OURPG1KDa6A-61B6A4D4D4C5G2A1A3G1A6==';
                            _baseOptions.attribution = false;
                        }

                        // Merge base options with iframe-specific options
                        var _options = $.extend({}, _baseOptions, {
                            // ============================================================
                            // IFRAME-SPECIFIC OPTIONS (not in shared config)
                            // ============================================================
                            toolbarInline: true,
                            scrollableContainer: $(editableBlocks[0]).closest("body")[0],
                            initOnClick: true,
                            align: 'right',

                            // Bind events
                            events: {
                                initialized: function () {
                                    // Workaround for Froala bug: toolbar.enable() called when toolbar is undefined
                                    // This happens during scroll when toolbarInline is true
                                    var editor = this;
                                    if (editor.toolbar && editor.toolbar.enable) {
                                        var originalEnable = editor.toolbar.enable;
                                        editor.toolbar.enable = function() {
                                            if (editor.toolbar) {
                                                return originalEnable.apply(this, arguments);
                                            }
                                        };
                                    }
                                },
                                contentChanged: function () {
                                    // Get editor instance.
                                    var editor = this;

                                    var _content = editor.html.get(true);

                                    $(editor).trigger('datachange');


                                    self.save();

                                    // Callback code here.
                                },
                                'mouseup': function (evt) {
                                    var shared = (self.window && self.window.FroalaPluginsShared)
                                        ? self.window.FroalaPluginsShared
                                        : window.FroalaPluginsShared;
                                    if (shared && shared.handleInlinePopupMouseup) {
                                        shared.handleInlinePopupMouseup(this, evt);
                                    }
                                },
                                'paste.after': function () {
                                    // Do something here.
                                    // this is the editor instance.
                                    // console.log('paste.after',this);
                                },
                                'paste.afterCleanup': function (clipboard_html) {
                                    // Do something here.
                                    // this is the editor instance.
                                    // console.log('paste.afterCleanup',this, clipboard_html);

                                    var tempDiv = document.createElement('div');
                                    tempDiv.innerHTML = clipboard_html;

                                    // Select the table element and remove the 'border' attribute
                                    // froala bug -> does not remove inline attributes on pasting
                                    var table = tempDiv.querySelector('table');
                                    if (table) {
                                        table.removeAttribute('border');
                                    }

                                    // Regenerate inline collapsible IDs to avoid duplicates
                                    var $tempDiv = $(tempDiv);
                                    $tempDiv.find('[data-toggle="collapse"][data-target]').each(function() {
                                        var $trigger = $(this);
                                        var targetId = $trigger.attr('data-target');
                                        if (!targetId) return;

                                        targetId = targetId.replace('#', '');
                                        var newId = 'inlineCollapse' + Date.now() + Math.random().toString().slice(2, 11);

                                        var $target = $tempDiv.find('#' + targetId).first();
                                        if ($target.length > 0) {
                                            $target.attr('id', newId);
                                            if ($target.attr('aria-controls')) {
                                                $target.attr('aria-controls', newId);
                                            }
                                            $trigger.attr('data-target', '#' + newId);
                                            if ($trigger.attr('aria-controls')) {
                                                $trigger.attr('aria-controls', newId);
                                            }
                                        }
                                    });

                                    // Serialize the DOM object back to an HTML string
                                    var newHtmlString = tempDiv.innerHTML;

                                    return newHtmlString;


                                },
                                'paste.before': function (original_event) {
                                    // Do something here.
                                    // this is the editor instance.
                                    // console.log('paste.before',this, original_event);
                                },
                                'paste.beforeCleanup': function (clipboard_html) {
                                    // Do something here.
                                    // this is the editor instance.
                                    // console.log('paste.beforeCleanup',this, clipboard_html);
                                },
                                'paste.wordPaste': function (clipboard_html) {
                                    // Do something here.
                                    // this is the editor instance.
                                    // console.log('paste.wordPaste',this, clipboard_html);
                                },
                                'image.beforePasteUpload': function (img) {
                                    // Do something here.
                                    // this is the editor instance.
                                    // console.log("this",this);
                                    // console.log("img",img);
                                    //return false;
                                },
                                'image.beforeUpload': function (images) {
                                    // Do something here.
                                    // this is the editor instance.
                                    // console.log("image.beforeUpload", this, images);
                                    //return false;
                                    // if(typeof self.options.callFromKeditor === 'function' ) self.options.callFromKeditor("imageUploadModal", {
                                    //     "src": images[0],
                                    //     // "width" : _size[0],
                                    //     // "height": _size[1]
                                    //   }, function(data){
                                    //     console.error("data", data);
                                    //   })
                                }
                                //   'mousedown': function (mousedownEvent) {
                                //     // Do something here.
                                //     // this is the editor instance.
                                //     console.error("mousedown",this.customFontAwesomePlugin.showPopup());
                                //     console.error("mousedownEvent", mousedownEvent.currentTarget.className)
                                //     console.error(self.window.FroalaEditor.PLUGINS)
                                //     console.error(editor)

                                //     if($(mousedownEvent.currentTarget).hasClass("fa")){
                                //         //editor.customFontAwesomePlugin.showPopup();
                                //     }
                                //   }
                            }
                        });

                        if (_editableBlock.hasClass("wps-br")) {
                            _options.enter = self.window.FroalaEditor.ENTER_BR;
                        }
                        if (_editableBlock[0].tagName.toLowerCase() == "a") {
                            _options.enter = self.window.FroalaEditor.ENTER_BR;
                        }

                        self.options.keditorOptions = _options;




                        editor = new self.window.FroalaEditor(_editableBlock[0], _options);

                        //   console.warn("_editableBlock", _editableBlock);
                        //   console.log(_editableBlock.find(".fa"))
                        //   _editableBlock.find(".fa").click(function(evt){
                        //       console.log("click", evt);
                        //     editor.customFontAwesomePlugin.showPopup();

                        //   })




                    }
                }


            }
        }



    }


    KEditor.prototype.getOptions = function () {
        var keditor = $(this).data('keditor');

        return $.extend(true, {}, keditor.options);
    };


    var absolutePath = function (href) {
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1") return href;
        var link = document.createElement("a");
        link.href = href;
        return (link.protocol + "//" + link.host + link.pathname + link.search + link.hash);
    }



    // KEditor plugins
    $.fn.keditor = function (options) {
        var element = $(this)
        var data = element.data('keditor');


        if (!data) {
            element.data('keditor', (data = new KEditor(element, options)));
        } else {




            // closed editor and open another again
            // keditor is still available
            // so just set new content
            data.options.data = options.data;
            data.options.pageId = options.pageId;
            data.options.pageUpdatedAt = options.pageUpdatedAt;

            // Switch history context to the new page
            if (data.switchPageHistory) {
                data.switchPageHistory();
            }

            //clean modals
            data.element.find("iframe").contents().find('.pgs_modal').remove();
            data.element.find("iframe").contents().find(".pgs_modal_overlay").remove();


            if (data.element.find("iframe").contents().find('.keditor-ui').length == 0) {
                if (window.confirm("There was an error. Please reload the page. [7gsze]")) {
                    window.parent.location.reload();
                }
                return;
            }

            if (options.content) {
                // Mark as restoring to prevent creating a snapshot from old content
                if (data.historyState) {
                    data.historyState.isRestoring = true;
                }

                data.setContent(options.content);

                // Reset restoring flag after content is set
                setTimeout(function() {
                    if (data.historyState) {
                        data.historyState.isRestoring = false;
                    }
                }, 600);
                // if(self.options.newArticle) self.save();
            } else {
                // if there is not content saved, use template
                originalContent = data.template;
                data.setContent(originalContent);

                data.save();
            }
        }

        if (typeof options == 'string') {
            return data[options].apply(data, Array.prototype.slice.call(arguments, 1));
        } else {
            return data;
        }
    };

    $.fn.keditor.constructor = KEditor;

    // Export KEditor
    $.keditor = KEditor;

    // Export KEditor to window for parent panel registration
    window.KEditor = KEditor;


    function getScrollbarWidth() {

        // Creating invisible container
        var outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll'; // forcing scrollbar to appear
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
        document.body.appendChild(outer);

        // Creating inner element and placing it in the container
        var inner = document.createElement('div');
        outer.appendChild(inner);

        // Calculating difference between container's full width and the child width
        var scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

        // Removing temporary elements from the DOM
        outer.parentNode.removeChild(outer);

        return scrollbarWidth;

    }

})(jQuery);
